// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/plugnmeet.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/plugnmeet.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/fonts/NunitoSans-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/fonts/NunitoSans-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../assets/fonts/NunitoSans-Italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../assets/fonts/NunitoSans-ExtraBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../assets/fonts/NunitoSans-SemiBold.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "plugnmeet";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}
@font-face {
  font-family: "Nunito Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
i {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "plugnmeet" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.pnm-timeline-solid:before {
  content: "\\e934";
}

.pnm-check:before {
  content: "\\e932";
}

.pnm-updown:before {
  content: "\\e933";
}

.pnm-closed-captioning:before {
  content: "\\e931";
}

.pnm-pip:before {
  content: "\\e930";
}

.pnm-cross:before {
  content: "\\e92f";
}

.pnm-emoji:before {
  content: "\\e92e";
}

.pnm-pin:before {
  content: "\\e92d";
}

.pnm-moon:before {
  content: "\\e92b";
}

.pnm-sun:before {
  content: "\\e92c";
}

.pnm-display:before {
  content: "\\e92a";
}

.pnm-blank-img:before {
  content: "\\e929";
}

.pnm-breakout-room:before {
  content: "\\e928";
}

.pnm-delete:before {
  content: "\\e927";
}

.pnm-poll:before {
  content: "\\e925";
}

.pnm-waiting-room:before {
  content: "\\e926";
}

.pnm-menu-small:before {
  content: "\\e900";
}

.pnm-attachment:before {
  content: "\\e901";
}

.pnm-webcam:before {
  content: "\\e902";
}

.pnm-settings:before {
  content: "\\e903";
}

.pnm-send:before {
  content: "\\e904";
}

.pnm-screen-share:before {
  content: "\\e905";
}

.pnm-raise-hand:before {
  content: "\\e906";
}

.pnm-participant:before {
  content: "\\e907";
}

.pnm-arrow-below:before {
  content: "\\e908";
}

.pnm-mic-mute:before {
  content: "\\e909";
}

.pnm-lock:before {
  content: "\\e90a";
}

.pnm-mic-unmute:before {
  content: "\\e90b";
}

.pnm-menu-horizontal:before {
  content: "\\e90c";
}

.pnm-call:before {
  content: "\\e90d";
}

.pnm-chat:before {
  content: "\\e90e";
}

.pnm-listen-only:before {
  content: "\\e90f";
}

.pnm-network:before {
  content: "\\e910";
}

.pnm-fullscreen:before {
  content: "\\e911";
}

.pnm-arrow-down:before {
  content: "\\e912";
}

.pnm-arrow-up:before {
  content: "\\e913";
}

.pnm-logout:before {
  content: "\\e914";
}

.pnm-rec:before {
  content: "\\e915";
}

.pnm-broadcasting:before {
  content: "\\e916";
}

.pnm-blur:before {
  content: "\\e917";
}

.pnm-ban-solid:before {
  content: "\\e918";
}

.pnm-notepad:before {
  content: "\\e919";
}

.pnm-journal:before {
  content: "\\e91a";
}

.pnm-whiteboard:before {
  content: "\\e91b";
}

.pnm-download:before {
  content: "\\e91c";
}

.pnm-keyboard:before {
  content: "\\e91d";
}

.pnm-eye-slash:before {
  content: "\\e91e";
}

.pnm-arrow-left-short:before {
  content: "\\e91f";
}

.pnm-arrow-right-short:before {
  content: "\\e920";
}

.pnm-file-play:before {
  content: "\\e921";
}

.pnm-presenter:before {
  content: "\\e922";
}

.pnm-speaker:before {
  content: "\\e923";
}

.pnm-speaker-muted:before {
  content: "\\e924";
}

/* ! tailwindcss v3.4.1 | MIT License | https://tailwindcss.com */

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {
  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {
  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {
  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {
  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {
  .container {
    max-width: 1536px;
  }
}
.pointer-events-none {
  pointer-events: none;
}
.pointer-events-auto {
  pointer-events: auto;
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.collapse {
  visibility: collapse;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.inset-0 {
  inset: 0px;
}
.inset-x-0 {
  left: 0px;
  right: 0px;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.\\!-left-3 {
  left: -0.75rem !important;
}
.\\!bottom-\\[62px\\] {
  bottom: 62px !important;
}
.-bottom-1 {
  bottom: -0.25rem;
}
.-bottom-\\[30px\\] {
  bottom: -30px;
}
.-bottom-\\[3px\\] {
  bottom: -3px;
}
.-left-\\[14px\\] {
  left: -14px;
}
.-right-1 {
  right: -0.25rem;
}
.-right-3 {
  right: -0.75rem;
}
.-right-\\[14px\\] {
  right: -14px;
}
.-top-2 {
  top: -0.5rem;
}
.-top-\\[7px\\] {
  top: -7px;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-1 {
  bottom: 0.25rem;
}
.bottom-14 {
  bottom: 3.5rem;
}
.bottom-2 {
  bottom: 0.5rem;
}
.bottom-4 {
  bottom: 1rem;
}
.bottom-5 {
  bottom: 1.25rem;
}
.bottom-7 {
  bottom: 1.75rem;
}
.bottom-\\[120px\\] {
  bottom: 120px;
}
.bottom-\\[40px\\] {
  bottom: 40px;
}
.bottom-\\[48px\\] {
  bottom: 48px;
}
.bottom-\\[60px\\] {
  bottom: 60px;
}
.left-0 {
  left: 0px;
}
.left-1 {
  left: 0.25rem;
}
.left-1\\/2 {
  left: 50%;
}
.left-10 {
  left: 2.5rem;
}
.left-2 {
  left: 0.5rem;
}
.left-\\[-35px\\] {
  left: -35px;
}
.left-\\[2\\.7rem\\] {
  left: 2.7rem;
}
.left-\\[2px\\] {
  left: 2px;
}
.left-\\[50\\%\\] {
  left: 50%;
}
.right-0 {
  right: 0px;
}
.right-10 {
  right: 2.5rem;
}
.right-2 {
  right: 0.5rem;
}
.right-3 {
  right: 0.75rem;
}
.right-6 {
  right: 1.5rem;
}
.right-\\[-100px\\] {
  right: -100px;
}
.right-\\[2px\\] {
  right: 2px;
}
.top-0 {
  top: 0px;
}
.top-1 {
  top: 0.25rem;
}
.top-1\\/2 {
  top: 50%;
}
.top-2 {
  top: 0.5rem;
}
.top-3 {
  top: 0.75rem;
}
.top-4 {
  top: 1rem;
}
.top-5 {
  top: 1.25rem;
}
.top-7 {
  top: 1.75rem;
}
.top-8 {
  top: 2rem;
}
.top-\\[11px\\] {
  top: 11px;
}
.top-\\[40\\%\\] {
  top: 40%;
}
.top-\\[50px\\] {
  top: 50px;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-50 {
  z-index: 50;
}
.z-\\[0\\] {
  z-index: 0;
}
.z-\\[1\\] {
  z-index: 1;
}
.z-\\[2\\] {
  z-index: 2;
}
.z-\\[99999\\] {
  z-index: 99999;
}
.z-\\[9999\\] {
  z-index: 9999;
}
.z-\\[999\\] {
  z-index: 999;
}
.z-\\[99\\] {
  z-index: 99;
}
.col-span-6 {
  grid-column: span 6 / span 6;
}
.clear-both {
  clear: both;
}
.\\!m-auto {
  margin: auto !important;
}
.m-1 {
  margin: 0.25rem;
}
.m-\\[3px\\] {
  margin: 3px;
}
.m-auto {
  margin: auto;
}
.-mx-2 {
  margin-left: -0.5rem;
  margin-right: -0.5rem;
}
.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-16 {
  margin-top: 4rem;
  margin-bottom: 4rem;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-5 {
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.my-8 {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.\\!mt-2 {
  margin-top: 0.5rem !important;
}
.-mb-1 {
  margin-bottom: -0.25rem;
}
.-ml-\\[1px\\] {
  margin-left: -1px;
}
.-mt-\\[1px\\] {
  margin-top: -1px;
}
.-mt-\\[2px\\] {
  margin-top: -2px;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-\\[50px\\] {
  margin-bottom: 50px;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-3 {
  margin-left: 0.75rem;
}
.ml-6 {
  margin-left: 1.5rem;
}
.ml-\\[10px\\] {
  margin-left: 10px;
}
.ml-auto {
  margin-left: auto;
}
.mr-0 {
  margin-right: 0px;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-4 {
  margin-right: 1rem;
}
.mr-\\[6px\\] {
  margin-right: 6px;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-9 {
  margin-top: 2.25rem;
}
.mt-\\[10px\\] {
  margin-top: 10px;
}
.mt-\\[2px\\] {
  margin-top: 2px;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.h-0 {
  height: 0px;
}
.h-0\\.5 {
  height: 0.125rem;
}
.h-10 {
  height: 2.5rem;
}
.h-14 {
  height: 3.5rem;
}
.h-20 {
  height: 5rem;
}
.h-24 {
  height: 6rem;
}
.h-4 {
  height: 1rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-60 {
  height: 15rem;
}
.h-7 {
  height: 1.75rem;
}
.h-8 {
  height: 2rem;
}
.h-80 {
  height: 20rem;
}
.h-9 {
  height: 2.25rem;
}
.h-\\[130px\\] {
  height: 130px;
}
.h-\\[15px\\] {
  height: 15px;
}
.h-\\[16px\\] {
  height: 16px;
}
.h-\\[1px\\] {
  height: 1px;
}
.h-\\[200px\\] {
  height: 200px;
}
.h-\\[22px\\] {
  height: 22px;
}
.h-\\[25px\\] {
  height: 25px;
}
.h-\\[25rem\\] {
  height: 25rem;
}
.h-\\[2px\\] {
  height: 2px;
}
.h-\\[30px\\] {
  height: 30px;
}
.h-\\[35px\\] {
  height: 35px;
}
.h-\\[4\\.5rem\\] {
  height: 4.5rem;
}
.h-\\[40px\\] {
  height: 40px;
}
.h-\\[50px\\] {
  height: 50px;
}
.h-\\[55px\\] {
  height: 55px;
}
.h-\\[62px\\] {
  height: 62px;
}
.h-\\[80px\\] {
  height: 80px;
}
.h-\\[calc\\(100\\%\\)\\] {
  height: calc(100%);
}
.h-\\[calc\\(100\\%-40px\\)\\] {
  height: calc(100% - 40px);
}
.h-\\[calc\\(100\\%-45px\\)\\] {
  height: calc(100% - 45px);
}
.h-\\[calc\\(100\\%-50px\\)\\] {
  height: calc(100% - 50px);
}
.h-\\[calc\\(100\\%-80px\\)\\] {
  height: calc(100% - 80px);
}
.h-full {
  height: 100%;
}
.h-screen {
  height: 100vh;
}
.max-h-14 {
  max-height: 3.5rem;
}
.max-h-60 {
  max-height: 15rem;
}
.max-h-\\[170px\\] {
  max-height: 170px;
}
.max-h-\\[345px\\] {
  max-height: 345px;
}
.max-h-\\[500px\\] {
  max-height: 500px;
}
.min-h-\\[36px\\] {
  min-height: 36px;
}
.min-h-\\[60px\\] {
  min-height: 60px;
}
.min-h-\\[75px\\] {
  min-height: 75px;
}
.min-h-\\[90px\\] {
  min-height: 90px;
}
.min-h-screen {
  min-height: 100vh;
}
.\\!w-full {
  width: 100% !important;
}
.w-1\\/2 {
  width: 50%;
}
.w-10 {
  width: 2.5rem;
}
.w-11 {
  width: 2.75rem;
}
.w-11\\/12 {
  width: 91.666667%;
}
.w-16 {
  width: 4rem;
}
.w-28 {
  width: 7rem;
}
.w-3\\/5 {
  width: 60%;
}
.w-4 {
  width: 1rem;
}
.w-40 {
  width: 10rem;
}
.w-44 {
  width: 11rem;
}
.w-48 {
  width: 12rem;
}
.w-5 {
  width: 1.25rem;
}
.w-52 {
  width: 13rem;
}
.w-56 {
  width: 14rem;
}
.w-6 {
  width: 1.5rem;
}
.w-60 {
  width: 15rem;
}
.w-64 {
  width: 16rem;
}
.w-8 {
  width: 2rem;
}
.w-\\[100\\%\\] {
  width: 100%;
}
.w-\\[100px\\] {
  width: 100px;
}
.w-\\[150px\\] {
  width: 150px;
}
.w-\\[15px\\] {
  width: 15px;
}
.w-\\[16px\\] {
  width: 16px;
}
.w-\\[180px\\] {
  width: 180px;
}
.w-\\[18px\\] {
  width: 18px;
}
.w-\\[20px\\] {
  width: 20px;
}
.w-\\[22px\\] {
  width: 22px;
}
.w-\\[250px\\] {
  width: 250px;
}
.w-\\[25px\\] {
  width: 25px;
}
.w-\\[300px\\] {
  width: 300px;
}
.w-\\[330px\\] {
  width: 330px;
}
.w-\\[350px\\] {
  width: 350px;
}
.w-\\[35px\\] {
  width: 35px;
}
.w-\\[40px\\] {
  width: 40px;
}
.w-\\[450px\\] {
  width: 450px;
}
.w-\\[50px\\] {
  width: 50px;
}
.w-\\[62px\\] {
  width: 62px;
}
.w-\\[calc\\(100\\%\\)\\] {
  width: calc(100%);
}
.w-\\[calc\\(100\\%-20px\\)\\] {
  width: calc(100% - 20px);
}
.w-\\[calc\\(100\\%-2rem\\)\\] {
  width: calc(100% - 2rem);
}
.w-\\[calc\\(100\\%-36px\\)\\] {
  width: calc(100% - 36px);
}
.w-\\[calc\\(50\\%-6px\\)\\] {
  width: calc(50% - 6px);
}
.w-auto {
  width: auto;
}
.w-full {
  width: 100%;
}
.w-max {
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
}
.w-min {
  width: -webkit-min-content;
  width: -moz-min-content;
  width: min-content;
}
.max-w-2xl {
  max-width: 42rem;
}
.max-w-5xl {
  max-width: 64rem;
}
.max-w-\\[1000px\\] {
  max-width: 1000px;
}
.max-w-\\[100px\\] {
  max-width: 100px;
}
.max-w-\\[1100px\\] {
  max-width: 1100px;
}
.max-w-\\[1200px\\] {
  max-width: 1200px;
}
.max-w-\\[400px\\] {
  max-width: 400px;
}
.max-w-\\[50px\\] {
  max-width: 50px;
}
.max-w-fit {
  max-width: -webkit-fit-content;
  max-width: -moz-fit-content;
  max-width: fit-content;
}
.max-w-full {
  max-width: 100%;
}
.max-w-lg {
  max-width: 32rem;
}
.max-w-max {
  max-width: -webkit-max-content;
  max-width: -moz-max-content;
  max-width: max-content;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-sm {
  max-width: 24rem;
}
.max-w-xl {
  max-width: 36rem;
}
.flex-1 {
  flex: 1 1 0%;
}
.flex-auto {
  flex: 1 1 auto;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink-0 {
  flex-shrink: 0;
}
.border-collapse {
  border-collapse: collapse;
}
.origin-bottom-left {
  transform-origin: bottom left;
}
.origin-bottom-right {
  transform-origin: bottom right;
}
.origin-top-right {
  transform-origin: top right;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-full {
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-full {
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-0 {
  --tw-rotate: -0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-45 {
  --tw-rotate: -45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-90 {
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45 {
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90 {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-\\[156deg\\] {
  --tw-rotate: 156deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-90 {
  --tw-scale-x: .9;
  --tw-scale-y: .9;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-95 {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.cursor-default {
  cursor: default;
}
.cursor-move {
  cursor: move;
}
.cursor-pointer {
  cursor: pointer;
}
.select-none {
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}
.list-none {
  list-style-type: none;
}
.grid-cols-6 {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}
.flex-wrap {
  flex-wrap: wrap;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-6 {
  gap: 1.5rem;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-gray-100 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-divide-opacity));
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-pre-wrap {
  white-space: pre-wrap;
}
.break-words {
  overflow-wrap: break-word;
}
.\\!rounded {
  border-radius: 0.25rem !important;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-3xl {
  border-radius: 1.5rem;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-bl-lg {
  border-bottom-left-radius: 0.5rem;
}
.rounded-br-lg {
  border-bottom-right-radius: 0.5rem;
}
.rounded-tl-lg {
  border-top-left-radius: 0.5rem;
}
.rounded-tr-lg {
  border-top-right-radius: 0.5rem;
}
.border {
  border-width: 1px;
}
.border-2 {
  border-width: 2px;
}
.\\!border-t-2 {
  border-top-width: 2px !important;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-b-4 {
  border-bottom-width: 4px;
}
.border-r {
  border-right-width: 1px;
}
.border-t {
  border-top-width: 1px;
}
.border-t-\\[28px\\] {
  border-top-width: 28px;
}
.border-solid {
  border-style: solid;
}
.border-dashed {
  border-style: dashed;
}
.border-dotted {
  border-style: dotted;
}
.\\!border-primaryColor {
  --tw-border-opacity: 1 !important;
  border-color: rgb(0 77 144 / var(--tw-border-opacity)) !important;
}
.border-\\[\\#004d90\\] {
  --tw-border-opacity: 1;
  border-color: rgb(0 77 144 / var(--tw-border-opacity));
}
.border-\\[\\#004d90\\]\\/20 {
  border-color: rgb(0 77 144 / 0.2);
}
.border-\\[\\#24aef7\\] {
  --tw-border-opacity: 1;
  border-color: rgb(36 174 247 / var(--tw-border-opacity));
}
.border-\\[\\#3d3d3d\\] {
  --tw-border-opacity: 1;
  border-color: rgb(61 61 61 / var(--tw-border-opacity));
}
.border-black {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}
.border-black\\/50 {
  border-color: rgb(0 0 0 / 0.5);
}
.border-black\\/80 {
  border-color: rgb(0 0 0 / 0.8);
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}
.border-primaryColor {
  --tw-border-opacity: 1;
  border-color: rgb(0 77 144 / var(--tw-border-opacity));
}
.border-primaryColor\\/10 {
  border-color: rgb(0 77 144 / 0.1);
}
.border-primaryColor\\/20 {
  border-color: rgb(0 77 144 / 0.2);
}
.border-primaryColor\\/50 {
  border-color: rgb(0 77 144 / 0.5);
}
.border-primaryColor\\/70 {
  border-color: rgb(0 77 144 / 0.7);
}
.border-secondaryColor {
  --tw-border-opacity: 1;
  border-color: rgb(36 174 247 / var(--tw-border-opacity));
}
.border-slate-500 {
  --tw-border-opacity: 1;
  border-color: rgb(100 116 139 / var(--tw-border-opacity));
}
.border-slate-700 {
  --tw-border-opacity: 1;
  border-color: rgb(51 65 85 / var(--tw-border-opacity));
}
.border-transparent {
  border-color: transparent;
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.\\!bg-primaryColor {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(0 77 144 / var(--tw-bg-opacity)) !important;
}
.\\!bg-transparent {
  background-color: transparent !important;
}
.bg-\\[\\#F2F2F2\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(242 242 242 / var(--tw-bg-opacity));
}
.bg-amber-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity));
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.bg-black\\/50 {
  background-color: rgb(0 0 0 / 0.5);
}
.bg-blue-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity));
}
.bg-brandRed {
  --tw-bg-opacity: 1;
  background-color: rgb(237 33 57 / var(--tw-bg-opacity));
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}
.bg-primaryColor {
  --tw-bg-opacity: 1;
  background-color: rgb(0 77 144 / var(--tw-bg-opacity));
}
.bg-red-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity));
}
.bg-secondaryColor {
  --tw-bg-opacity: 1;
  background-color: rgb(36 174 247 / var(--tw-bg-opacity));
}
.bg-slate-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity));
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-white\\/80 {
  background-color: rgb(255 255 255 / 0.8);
}
.bg-white\\/90 {
  background-color: rgb(255 255 255 / 0.9);
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.from-primaryColor {
  --tw-gradient-from: #004D90 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 77 144 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-secondaryColor {
  --tw-gradient-to: #24AEF7 var(--tw-gradient-to-position);
}
.bg-cover {
  background-size: cover;
}
.bg-center {
  background-position: center;
}
.bg-no-repeat {
  background-repeat: no-repeat;
}
.object-cover {
  object-fit: cover;
}
.p-1 {
  padding: 0.25rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.\\!px-2 {
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}
.\\!px-3 {
  padding-left: 0.75rem !important;
  padding-right: 0.75rem !important;
}
.\\!py-\\[0\\.4rem\\] {
  padding-top: 0.4rem !important;
  padding-bottom: 0.4rem !important;
}
.px-10 {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-\\[10px\\] {
  padding-left: 10px;
  padding-right: 10px;
}
.px-\\[12px\\] {
  padding-left: 12px;
  padding-right: 12px;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-14 {
  padding-top: 3.5rem;
  padding-bottom: 3.5rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-\\[0\\.4rem\\] {
  padding-top: 0.4rem;
  padding-bottom: 0.4rem;
}
.py-\\[1px\\] {
  padding-top: 1px;
  padding-bottom: 1px;
}
.py-\\[28px\\] {
  padding-top: 28px;
  padding-bottom: 28px;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-5 {
  padding-bottom: 1.25rem;
}
.pb-8 {
  padding-bottom: 2rem;
}
.pb-\\[2px\\] {
  padding-bottom: 2px;
}
.pb-\\[3px\\] {
  padding-bottom: 3px;
}
.pb-\\[6px\\] {
  padding-bottom: 6px;
}
.pl-1 {
  padding-left: 0.25rem;
}
.pl-10 {
  padding-left: 2.5rem;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pl-3 {
  padding-left: 0.75rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pl-7 {
  padding-left: 1.75rem;
}
.pr-1 {
  padding-right: 0.25rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pr-7 {
  padding-right: 1.75rem;
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-10 {
  padding-top: 2.5rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-5 {
  padding-top: 1.25rem;
}
.pt-\\[3px\\] {
  padding-top: 3px;
}
.pt-\\[5px\\] {
  padding-top: 5px;
}
.pt-\\[6px\\] {
  padding-top: 6px;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.align-middle {
  vertical-align: middle;
}
.\\!text-\\[10px\\] {
  font-size: 10px !important;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-\\[12px\\] {
  font-size: 12px;
}
.text-\\[14px\\] {
  font-size: 14px;
}
.text-\\[20px\\] {
  font-size: 20px;
}
.text-\\[5px\\] {
  font-size: 5px;
}
.text-\\[7px\\] {
  font-size: 7px;
}
.text-\\[9px\\] {
  font-size: 9px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.capitalize {
  text-transform: capitalize;
}
.leading-4 {
  line-height: 1rem;
}
.leading-5 {
  line-height: 1.25rem;
}
.leading-6 {
  line-height: 1.5rem;
}
.leading-\\[1\\.2\\] {
  line-height: 1.2;
}
.leading-\\[1\\] {
  line-height: 1;
}
.leading-\\[28px\\] {
  line-height: 28px;
}
.leading-\\[32px\\] {
  line-height: 32px;
}
.leading-\\[40px\\] {
  line-height: 40px;
}
.leading-normal {
  line-height: 1.5;
}
.text-\\[\\#3d3d3d\\] {
  --tw-text-opacity: 1;
  color: rgb(61 61 61 / var(--tw-text-opacity));
}
.text-\\[\\#ffbd40\\] {
  --tw-text-opacity: 1;
  color: rgb(255 189 64 / var(--tw-text-opacity));
}
.text-amber-600 {
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity));
}
.text-amber-900 {
  --tw-text-opacity: 1;
  color: rgb(120 53 15 / var(--tw-text-opacity));
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-blue-900 {
  --tw-text-opacity: 1;
  color: rgb(30 58 138 / var(--tw-text-opacity));
}
.text-darkPrimary {
  --tw-text-opacity: 1;
  color: rgb(1 16 43 / var(--tw-text-opacity));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}
.text-indigo-600 {
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity));
}
.text-primaryColor {
  --tw-text-opacity: 1;
  color: rgb(0 77 144 / var(--tw-text-opacity));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity));
}
.text-red-900 {
  --tw-text-opacity: 1;
  color: rgb(127 29 29 / var(--tw-text-opacity));
}
.text-secondaryColor {
  --tw-text-opacity: 1;
  color: rgb(36 174 247 / var(--tw-text-opacity));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.opacity-30 {
  opacity: 0.3;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-70 {
  opacity: 0.7;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-footer {
  --tw-shadow: 0 -4px 52px rgba(0, 0, 0, 0.15);
  --tw-shadow-colored: 0 -4px 52px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-header {
  --tw-shadow: 0 4px 52px rgba(0, 0, 0, 0.15);
  --tw-shadow-colored: 0 4px 52px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.ring-1 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-black {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(0 0 0 / var(--tw-ring-opacity));
}
.ring-white {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity));
}
.ring-opacity-5 {
  --tw-ring-opacity: 0.05;
}
.ring-opacity-60 {
  --tw-ring-opacity: 0.6;
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition {
  transition-property: color, background-color, border-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-text-decoration-color, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-text-decoration-color, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, fill, stroke, -webkit-text-decoration-color;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, -webkit-text-decoration-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-100 {
  transition-duration: 100ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-75 {
  transition-duration: 75ms;
}
.duration-\\[400ms\\] {
  transition-duration: 400ms;
}
.ease-in {
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
body {
  margin: 0;
  font-family: "Nunito Sans", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-weight: 400;
}

code {
  font-family: "Nunito Sans", sans-serif;
}

.primaryColor {
  color: #004d90;
}

.secondaryColor {
  color: #24aef7;
}

.bg-primaryColor {
  background: #004d90;
}

.bg-secondaryColor {
  background: #24aef7;
}

.border-primaryColor {
  color: #004d90;
}

.border-secondaryColor {
  color: #24aef7;
}

.multi-gradient {
  background: rgb(235, 248, 255);
  background: linear-gradient(150deg, rgb(235, 248, 255) 0%, rgb(255, 255, 255) 10%, rgb(243, 237, 249) 67%, rgb(214, 231, 255) 100%);
}

.scrollBar::-webkit-scrollbar-thumb {
  border-radius: 5px;
  border-style: none;
  --tw-bg-opacity: 1;
  background-color: rgb(36 174 247 / var(--tw-bg-opacity));
  background: #24aef7;
}
.scrollBar::-webkit-scrollbar-track {
  background-color: rgba(0,0,0,0.15);
}
.scrollBar::-webkit-scrollbar {
  width: 0.5rem;
}

.scrollBar2::-webkit-scrollbar {
  width: 2px;
}

.scrollBar4::-webkit-scrollbar {
  width: 0.25rem;
}

.scrollBar3::-webkit-scrollbar {
  height: 0.5rem;
  width: 100%;
}

.private-m-tab .inner2::-webkit-scrollbar-track {
  --tw-bg-opacity: 1;
  background-color: rgb(224 226 231 / var(--tw-bg-opacity));
}
.private-m-tab .inner2::-webkit-scrollbar {
  height: 5px;
}
.private-m-tab .inner2::-webkit-scrollbar-thumb {
  border-radius: 5px;
  border-style: none;
  --tw-bg-opacity: 1;
  background-color: rgb(36 174 247 / var(--tw-bg-opacity));
  background: #24aef7;
}

.message-item .system p.message-content {
  font-size: 1rem;
  line-height: 1.5rem;
  line-height: 20px;
}
.message-item p.message-content {
  overflow-wrap: break-word;
  border-radius: 0 15px 15px;
  padding: 10px;
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.message-item p.message-content span.download {
  position: relative;
}
.message-item p.message-content span.download i.pnm-download {
  position: absolute;
  top: -2px;
  margin-right: 2px;
  font-size: 1rem;
  line-height: 1.5rem;
}
.message-item p.message-content span.download a {
  padding-left: 1.25rem;
}
.message-item .content.me {
  width: 100%;
}
.message-item .content.me p.message-content {
  margin-left: auto;
  border-radius: 15px 0 15px 15px;
}
.message-item .content.me p.message-content i.pnm-download {
  top: -1px;
}
.message-item .content.me p.message-content a {
  -webkit-text-decoration-line: underline;
          text-decoration-line: underline;
}
.message-item .content.me .name {
  text-align: right;
}

.all-webcam-wrapper {
  display: flex;
  height: 100%;
  align-items: center;
}
.all-webcam-wrapper::-webkit-scrollbar {
  display: none;
}
.all-webcam-wrapper .all-webcam-wrapper-inner {
  display: grid;
  height: 100%;
  width: 100%;
  gap: 0.5rem;
  padding: 1.25rem;
}
.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-0 {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
}
.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-1 {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
}
.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-2 {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
}
.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-0.total-items-2 .video-camera-item {
  width: 50%;
}
.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-1.total-items-2 .video-camera-item {
  width: 50%;
}
.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-0.total-items-3 .video-camera-item {
  width: 33.333333%;
}
.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-1.total-items-3 .video-camera-item {
  width: 33.333333%;
}
.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-1.total-items-5.inner-items-2 .video-camera-item {
  width: 33.333333%;
}
.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-0.total-items-7.inner-items-4 .video-camera-item {
  width: 25%;
}
.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-1.total-items-7.inner-items-3 .video-camera-item {
  width: 25%;
}
.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-1.total-items-8.inner-items-4 .video-camera-item {
  width: 25%;
}
.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-2.total-items-11.inner-items-3 .video-camera-item {
  width: 25%;
}
.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-2.total-items-10.inner-items-2 .video-camera-item {
  width: 25%;
}
.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-2.total-items-13.inner-items-3 .video-camera-item {
  width: 20%;
}
.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-2.total-items-14.inner-items-4 .video-camera-item {
  width: 20%;
}
.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-2.total-items-15.inner-items-5 .video-camera-item {
  width: 20%;
}
.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-2.total-items-16.inner-items-4 .video-camera-item {
  width: 16.3%;
}
.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-2.total-items-17.inner-items-5 .video-camera-item {
  width: 16.3%;
}
.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-2.total-items-18.inner-items-6 .video-camera-item {
  width: 16.3%;
}
.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-2.total-items-19.inner-items-5 .video-camera-item {
  width: 13.95%;
}
.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-2.total-items-20.inner-items-6 .video-camera-item {
  width: 13.95%;
}
.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-2.total-items-21.inner-items-7 .video-camera-item {
  width: 13.95%;
}
.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-2.total-items-22.inner-items-6 .video-camera-item {
  width: 12.15%;
}
.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-2.total-items-23.inner-items-7 .video-camera-item {
  width: 12.15%;
}
.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-2.total-items-24.inner-items-8 .video-camera-item {
  width: 12.15%;
}
.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-1.total-items-9.inner-items-4 .video-camera-item {
  width: 20%;
}
.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-1.total-items-10.inner-items-5 .video-camera-item {
  width: 20%;
}
.all-webcam-wrapper .all-webcam-wrapper-inner .video-camera-item.admin {
  order: 1;
}
.all-webcam-wrapper .all-webcam-wrapper-inner .video-camera-item.participants {
  order: 2;
}
.all-webcam-wrapper .all-webcam-wrapper-inner .video-camera-item.admin.speaking::before {
  --tw-border-opacity: 1;
  border-color: rgb(0 78 145 / var(--tw-border-opacity));
}
.all-webcam-wrapper button.previous-cam {
  position: absolute;
  top: 48%;
  left: -55px;
  z-index: 1;
  height: 30px;
  width: 120px;
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  border-radius: 0 0 20px 20px;
  background-color: rgb(0 0 0 / 0.5);
  padding-top: 6px;
  text-align: center;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.all-webcam-wrapper button.previous-cam i {
  margin: auto;
  width: 20px;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.all-webcam-wrapper button.previous-cam:hover i {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.all-webcam-wrapper button.next-cam {
  position: absolute;
  top: 48%;
  left: auto;
  right: -55px;
  z-index: 1;
  height: 30px;
  width: 120px;
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  border-radius: 20px 20px 0 0;
  background-color: rgb(0 0 0 / 0.5);
  padding-top: 2px;
  text-align: center;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.all-webcam-wrapper button.next-cam i {
  margin: auto;
  width: 20px;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.all-webcam-wrapper button.next-cam:hover i {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.fullWidthMainArea .select-camera-number {
  display: none;
}

.select-camera-number {
  position: absolute;
  left: 1.5rem;
  top: 0px;
  display: flex;
  align-items: center;
  font-size: 0.75rem;
  line-height: 1rem;
}
.select-camera-number select#select-camera-num {
  margin-right: 5px;
  border-width: 1px;
  border-style: solid;
  --tw-border-opacity: 1;
  border-color: rgb(51 51 51 / var(--tw-border-opacity));
  background-color: transparent;
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.video-camera-item {
  z-index: 1;
  height: 100%;
  width: 100%;
  overflow: hidden;
  border-radius: 1rem;
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.video-camera-item .loading {
  top: 50%;
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.video-camera-item::before {
  position: absolute;
  z-index: 999;
  height: 100%;
  width: 100%;
  border-radius: 15px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent;
  --tw-content: "";
  content: var(--tw-content);
}
.video-camera-item::after {
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.1) 50%);
  position: absolute;
  z-index: 99;
  height: 100%;
  width: 100%;
  --tw-content: "";
  content: var(--tw-content);
}
.video-camera-item .name {
  position: absolute;
  bottom: 10px;
  left: 0.75rem;
  z-index: 999;
  font-size: 0.875rem;
  line-height: 1.25rem;
  line-height: 1;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.video-camera-item .camera-modules .camera-video-player {
  position: absolute;
  display: flex;
  height: 100%;
  width: 100%;
}
.video-camera-item .camera-modules .camera-video-player video.camera-video {
  height: 100%;
  width: 100%;
}
.video-camera-item .camera-modules .status {
  position: absolute;
  bottom: 0.75rem;
  right: 0.75rem;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
}
.video-camera-item .camera-modules .status > div {
  display: flex;
  height: 1.25rem;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  background-color: rgb(0 0 0 / 0.2);
  padding: 0.5rem;
}
.video-camera-item .camera-modules .status.PinWebcam {
  right: auto;
  left: 0.75rem;
  top: 0.75rem;
  align-items: flex-start;
}

.video-camera-item.speaking::before {
  --tw-border-opacity: 1;
  border-color: rgb(36 174 247 / var(--tw-border-opacity));
  color: #24aef7;
}

#main-area.fullWidthMainArea .all-webcam-wrapper {
  background: rgb(235, 248, 255);
  background: linear-gradient(150deg, rgb(235, 248, 255) 0%, rgb(255, 255, 255) 10%, rgb(243, 237, 249) 67%, rgb(214, 231, 255) 100%);
  position: absolute;
  left: 0px;
  z-index: 2;
  display: block;
  height: 100%;
  width: 270px;
  padding-top: 30px;
  padding-bottom: 30px;
  padding-left: 0px;
  padding-right: 0px;
}
#main-area.fullWidthMainArea .all-webcam-wrapper .video-camera-item::after {
  background-color: transparent;
  opacity: 1;
}
#main-area.fullWidthMainArea .all-webcam-wrapper .video-camera-item .name {
  top: auto;
  left: 0.75rem;
  opacity: 1;
}
#main-area.fullWidthMainArea .all-webcam-wrapper .video-camera-item .connection-status {
  display: flex;
}
#main-area.fullWidthMainArea .all-webcam-wrapper .video-camera-item .mic-status {
  display: flex;
}
#main-area.fullWidthMainArea .all-webcam-wrapper button.previous-cam {
  top: 0px;
  left: 0px;
  width: 100%;
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
#main-area.fullWidthMainArea .all-webcam-wrapper button.next-cam {
  position: absolute;
  left: 0px;
  bottom: 0px;
  top: auto;
  width: 100%;
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
#main-area.fullWidthMainArea .all-webcam-wrapper .all-webcam-wrapper-inner {
  display: block;
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 5px;
  padding-right: 5px;
}
#main-area.fullWidthMainArea .middle-fullscreen-wrapper.verticalsWebcamsActivated {
  padding-left: 260px;
}
#main-area.fullWidthMainArea .middle-fullscreen-wrapper {
  height: 100%;
  width: 100%;
  flex: auto;
}

.SpeechHistory::before {
  content: "";
  position: absolute;
  bottom: -6px;
  left: 3.5rem;
  height: 12px;
  width: 12px;
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  border-width: 1px;
  border-style: solid;
  border-color: rgb(1 16 43 / 0.4);
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

:is(.dark .SpeechHistory)::before {
  --tw-bg-opacity: 1;
  background-color: rgb(1 16 43 / var(--tw-bg-opacity));
}

.tooltip {
  visibility: hidden;
  position: absolute;
  bottom: 52px;
  margin: 0px;
  display: inline-block;
  width: 150px;
  border-radius: 0.25rem;
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
  padding-top: 6px;
  padding-bottom: 6px;
  padding-left: 10px;
  padding-right: 10px;
  text-align: center;
  font-size: 13px;
  --tw-text-opacity: 1;
  color: rgb(1 16 43 / var(--tw-text-opacity));
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

:is(.dark .tooltip) {
  --tw-bg-opacity: 1;
  background-color: rgb(11 45 101 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(167 204 237 / var(--tw-text-opacity));
}
.tooltip::before {
  content: "";
  position: absolute;
  bottom: -6px;
  left: 0px;
  right: 0px;
  margin: auto;
  height: 12px;
  width: 12px;
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  border-width: 1px;
  border-style: solid;
  border-color: rgb(1 16 43 / 0.4);
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
:is(.dark .tooltip)::before {
  --tw-bg-opacity: 1;
  background-color: rgb(11 45 101 / var(--tw-bg-opacity));
}
.tooltip::after {
  content: "";
  position: absolute;
  left: 0px;
  bottom: 0px;
  height: 0.5rem;
  width: 100%;
  border-radius: 0.25rem;
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
:is(.dark .tooltip)::after {
  --tw-bg-opacity: 1;
  background-color: rgb(11 45 101 / var(--tw-bg-opacity));
}

.tooltip-left::before {
  left: 24px !important;
  right: auto !important;
}

html[dir=rtl] span.tooltip.tooltip-left {
  right: -34px !important;
  left: auto !important;
}

html[dir=rtl] span.tooltip.tooltip-left::before {
  left: auto !important;
  right: 45px !important;
}

.has-tooltip:hover .tooltip {
  visibility: visible;
  z-index: 50;
}

#main-footer .record {
  animation-name: pulse;
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}

.message-form {
  background: rgb(214, 231, 255);
  background: linear-gradient(0deg, rgba(214, 231, 255, 0.5) 67%, rgb(214, 231, 255) 100%);
}

.Toastify__toast-container {
  z-index: 999999;
}

.Toastify__toast-body {
  margin: 0px;
  font-weight: 300;
}

.vertical-webcams .all-webcam-wrapper-inner .video-camera-item {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  margin-left: 0px;
  margin-right: 0px;
  height: calc(33.33% - 10px);
}

.share-screen-wrapper.is-share-screen-running .screen-share-video {
  height: 100%;
  width: 100%;
}
.share-screen-wrapper.is-share-screen-running .screen-share-video video.video-player {
  top: 15px;
  left: 15px;
  height: calc(100% - 30px);
  width: calc(100% - 30px);
}
.share-screen-wrapper.is-share-screen-running .screen-share-video video.video-player.self-screen-share {
  left: 35%;
  width: 30%;
}

.footer-podcast-button {
  position: relative;
}
.footer-podcast-button .lds-ripple {
  position: absolute;
  left: 0.5rem;
  height: 30px;
  width: 30px;
}
.footer-podcast-button .lds-ripple div {
  border-width: 2px;
  border-style: solid;
  --tw-border-opacity: 1;
  border-color: rgb(0 77 144 / var(--tw-border-opacity));
  animation: lds-ripple2 0.8s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
.footer-podcast-button .lds-ripple div:last-child {
  animation-delay: -0.3s;
}

.transition-left-panel {
  position: absolute;
  z-index: 3;
  height: 100%;
  --tw-shadow: 0 0 10px -7px rgb(0, 0, 0);
  --tw-shadow-colored: 0 0 10px -7px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.transition-right-panel {
  position: absolute;
  right: 0px;
  z-index: 2;
  height: 100%;
  --tw-shadow: 0 0 10px -7px rgb(0, 0, 0);
  --tw-shadow-colored: 0 0 10px -7px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.media-player-inner {
  position: relative;
  width: 100% !important;
  height: inherit !important;
}
.media-player-inner > div {
  height: inherit !important;
  margin: auto;
}
.media-player-inner > div > div {
  position: relative;
  overflow: hidden;
  padding-bottom: 56.25%;
}
.media-player-inner iframe {
  position: absolute;
  left: 0px;
  top: 0px;
  height: 100%;
  width: 100%;
}

.is-pc .media-player-inner > div {
  width: 100% !important;
}

.range {
  width: 100%;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border-style: none;
  background-color: transparent;
  padding: 0px;
  vertical-align: middle;
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.range::-webkit-slider-runnable-track {
  background-color: rgba(128, 128, 128, 0.5);
  border: 1px solid transparent;
  height: 10px;
  border-radius: 5px;
  border-width: 1px;
  border-style: solid;
  border-color: transparent;
  background-color: rgba(128,128,128,0.5);
}
:is(.dark .range)::-webkit-slider-runnable-track {
  background-color: rgb(36 174 247 / 0.9);
}
.range::-moz-range-track {
  height: 10px;
  border-radius: 5px;
  border-width: 1px;
  border-style: solid;
  border-color: transparent;
  background-color: rgba(128,128,128,0.5);
}
:is(.dark .range)::-moz-range-track {
  background-color: rgb(36 174 247 / 0.9);
}
.range::-webkit-slider-thumb {
  margin-top: -5px;
  height: 18px;
  width: 18px;
  -webkit-appearance: none;
          appearance: none;
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: rgb(0 77 144 / var(--tw-bg-opacity));
  background: #004d90;
}
:is(.dark .range)::-webkit-slider-thumb {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.range::-moz-range-thumb {
  height: 18px;
  width: 18px;
  border-radius: 20px;
  border-style: none;
  --tw-bg-opacity: 1;
  background-color: rgb(0 77 144 / var(--tw-bg-opacity));
  background: #004d90;
}
.range:active::-webkit-slider-thumb {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.range:active::-moz-range-thumb {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.showParticipantsPanel .active-speakers-wrap {
  z-index: 2;
}

.showChatPanel .active-speakers-wrap {
  z-index: 2;
}
.showChatPanel .screen-share-video button {
  right: 320px;
}

.breakout-room-list-item .timer {
  border-color: #fff;
  color: #fff;
  border-radius: 8px;
  margin-left: 5px;
}

.react-js-player-wrap .video-js {
  padding-top: 0 !important;
}
.react-js-player-wrap .video-js button.vjs-big-play-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.excalidraw.excalidraw-modal-container {
  z-index: 99999 !important;
}

.landscape-device.is-mobile #main-area.fullWidthMainArea .share-screen-wrapper {
  height: 100%;
}
.landscape-device.is-mobile #main-area.fullWidthMainArea .middle-fullscreen-wrapper .notepad-wrapper {
  position: relative;
  top: 3%;
  margin-top: 0px;
  height: 94%;
}
.landscape-device.is-mobile #main-area.fullWidthMainArea .middle-fullscreen-wrapper .externalMediaPlayerWrapper {
  height: 100%;
}
.landscape-device.is-mobile #main-area.fullWidthMainArea .middle-fullscreen-wrapper .externalMediaPlayerWrapper .media-player-inner div {
  margin: auto;
}
.landscape-device.is-mobile #main-area.fullWidthMainArea .middle-fullscreen-wrapper .externalMediaPlayerWrapper .media-player-inner div div {
  padding-bottom: 0px;
}
.landscape-device.is-mobile #main-area.fullWidthMainArea .middle-fullscreen-wrapper .external-display-link-wrapper {
  margin: 0px;
  height: 100%;
  padding: 0.5rem;
}
.landscape-device.is-mobile #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper.vertical-webcams.total-cam-1 {
  padding: 0px;
}
.landscape-device.is-mobile #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper.vertical-webcams.total-cam-1 .all-webcam-wrapper-inner {
  display: flex !important;
  flex-wrap: wrap;
  align-items: center;
}
.landscape-device.is-mobile #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper.vertical-webcams.total-cam-1 .all-webcam-wrapper-inner .video-camera-item {
  height: 45%;
}
.landscape-device.is-mobile #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper.vertical-webcams.total-cam-2 {
  padding: 0px;
}
.landscape-device.is-mobile #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper.vertical-webcams.total-cam-2 .all-webcam-wrapper-inner {
  display: flex !important;
  flex-wrap: wrap;
  align-items: center;
}
.landscape-device.is-mobile #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper.vertical-webcams.total-cam-2 .all-webcam-wrapper-inner .video-camera-item {
  height: 45%;
}
.landscape-device.is-mobile #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper.vertical-webcams.total-cam-3 {
  padding: 0px;
}
.landscape-device.is-mobile #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper.vertical-webcams.total-cam-3 .all-webcam-wrapper-inner {
  display: flex !important;
  flex-wrap: wrap;
  align-items: center;
}
.landscape-device.is-mobile #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper.vertical-webcams.total-cam-3 .all-webcam-wrapper-inner .video-camera-item {
  height: 30%;
}
.landscape-device.is-mobile #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper.vertical-webcams .all-webcam-wrapper-inner .video-camera-item {
  width: 100%;
}
.landscape-device.is-mobile #main-area.fullWidthMainArea .middle-fullscreen-wrapper.verticalsWebcamsActivated .screen-share-video button {
  bottom: 55px;
}

.portrait-device.is-mobile #main-area.fullWidthMainArea .verticalsWebcamsActivated .excalidraw-wrapper {
  margin: 0px;
  height: calc(100% - 110px);
  padding: 0.5rem;
}
.portrait-device.is-mobile #main-area.fullWidthMainArea .verticalsWebcamsActivated .notepad-wrapper {
  margin: 0px;
  height: calc(100% - 110px);
  padding: 0.5rem;
}
.portrait-device.is-mobile #main-area.fullWidthMainArea .verticalsWebcamsActivated .Div-external-media-player {
  margin: 0px;
  height: calc(100% - 110px);
  padding: 0.5rem;
}
.portrait-device.is-mobile #main-area.fullWidthMainArea .verticalsWebcamsActivated .Div-external-media-player .externalMediaPlayerWrapper {
  padding: 0px;
}
.portrait-device.is-mobile #main-area.fullWidthMainArea .verticalsWebcamsActivated .external-display-link-wrapper {
  margin: 0px;
  height: calc(100% - 110px);
  padding: 0.5rem;
}
.portrait-device.is-mobile #main-area.fullWidthMainArea .verticalsWebcamsActivated .screen-share-video {
  height: calc(100% - 110px);
}
.portrait-device.is-mobile .middle-fullscreen-wrapper .screen-share-video {
  margin: 0px;
  height: 100%;
  padding: 0.5rem;
}
.portrait-device.is-mobile .middle-fullscreen-wrapper .external-display-link-wrapper {
  margin: 0px;
  height: 100%;
  padding: 0.5rem;
}
.portrait-device.is-mobile .middle-fullscreen-wrapper .notepad-wrapper {
  margin: 0px;
  height: 100%;
  padding: 0.5rem;
}
.portrait-device.is-mobile .middle-fullscreen-wrapper .excalidraw-wrapper {
  margin: 0px;
  height: 100%;
  padding: 0.5rem;
}
.portrait-device.is-mobile .media-player-inner > div {
  width: 100% !important;
}

aside {
  box-shadow: 0 2px 5px rgba(239, 239, 239, 0.8588235294) !important;
  width: 100% !important;
}

.landscape-device.is-tablet #main-area.fullWidthMainArea .middle-fullscreen-wrapper.verticalsWebcamsActivated .all-webcam-wrapper {
  height: 100%;
}
.landscape-device.is-tablet .camera-row-1.total-items-5.inner-items-2 .video-camera-item {
  width: 50%;
}
.landscape-device.is-tablet .camera-row-2.total-items-5.inner-items-1 .video-camera-item {
  width: 50%;
}
.landscape-device.is-tablet .camera-row-1.total-items-7.inner-items-3 .video-camera-item {
  width: 33.333333%;
}
.landscape-device.is-tablet .camera-row-2.total-items-7.inner-items-1 .video-camera-item {
  width: 33.333333%;
}
.landscape-device.is-tablet .camera-row-2.total-items-8.inner-items-2 .video-camera-item {
  width: 33.333333%;
}

.portrait-device.is-tablet .camera-row-0.total-items-2 {
  flex-wrap: wrap;
}
.portrait-device.is-tablet .camera-row-0.total-items-2 .video-camera-item {
  height: 50%;
  width: 100%;
}
.portrait-device.is-tablet .camera-row-0.total-items-3 {
  flex-wrap: wrap;
}
.portrait-device.is-tablet .camera-row-0.total-items-3 .video-camera-item {
  height: 33.333333%;
  width: 100%;
}
.portrait-device.is-tablet #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper {
  position: absolute;
  bottom: -5px;
  z-index: 9;
  height: auto;
  width: 100%;
  padding: 0px;
}
.portrait-device.is-tablet #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper .all-webcam-wrapper-inner {
  margin: 0px;
  flex-wrap: wrap;
  gap: 0px;
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 15px;
  padding-right: 15px;
}
.portrait-device.is-tablet #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper .all-webcam-wrapper-inner .video-camera-item {
  margin: 5px;
  height: 100px;
  width: 100%;
  max-width: 135px;
  padding-bottom: 0px;
}
.portrait-device.is-tablet #main-area.fullWidthMainArea .middle-fullscreen-wrapper.verticalsWebcamsActivated {
  padding-left: 0px;
}
.portrait-device.is-tablet #main-area.fullWidthMainArea .middle-fullscreen-wrapper.verticalsWebcamsActivated .screen-share-video {
  height: calc(100% - 105px);
}
.portrait-device.is-tablet #main-area.fullWidthMainArea .middle-fullscreen-wrapper.verticalsWebcamsActivated .screen-share-video button {
  position: absolute;
  bottom: 0px;
}
.portrait-device.is-tablet #main-area.fullWidthMainArea .middle-fullscreen-wrapper.verticalsWebcamsActivated .excalidraw-wrapper {
  height: calc(100% - 135px);
}
.portrait-device.is-tablet #main-area.fullWidthMainArea .middle-fullscreen-wrapper.verticalsWebcamsActivated .notepad-wrapper {
  height: calc(100% - 150px);
}
.portrait-device.is-tablet #main-area.fullWidthMainArea .middle-fullscreen-wrapper.verticalsWebcamsActivated .Div-external-media-player {
  height: calc(100% - 105px);
}
.portrait-device.is-tablet #main-area.fullWidthMainArea .middle-fullscreen-wrapper.verticalsWebcamsActivated .external-display-link-wrapper {
  height: calc(100% - 145px);
}
.portrait-device.is-tablet #main-area.fullWidthMainArea .all-webcam-wrapper.vertical-webcams .all-webcam-wrapper-inner {
  display: flex !important;
  justify-content: center;
}
.portrait-device.is-tablet #main-area.fullWidthMainArea .all-webcam-wrapper.vertical-webcams .all-webcam-wrapper-inner button.next-cam {
  right: -42px;
  left: auto;
  top: 45px;
  height: 1.25rem;
  width: 100px;
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.portrait-device.is-tablet #main-area.fullWidthMainArea .all-webcam-wrapper.vertical-webcams .all-webcam-wrapper-inner button.previous-cam {
  right: auto;
  left: -42px;
  top: 45px;
  height: 1.25rem;
  width: 100px;
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  padding-top: 0px;
}
.portrait-device.is-tablet .excalidraw-wrapper {
  margin-top: 1rem;
}

.message-form textarea#message-textarea {
  color: #004d90;
}
.message-form textarea#message-textarea::placeholder {
  color: rgba(0, 77, 144, 0.6666666667);
}

.dark .message-form textarea#message-textarea,
.dark .message-form textarea#message-textarea::placeholder {
  color: #fff;
}

.is-mobile .footer-collapse-arrow,
.is-mobile .header-collapse-arrow {
  display: none;
}

.portrait-device.is-tablet .footer-collapse-arrow,
.portrait-device.is-tablet .header-collapse-arrow {
  display: none;
}

.footer-collapse-arrow span::before,
.header-collapse-arrow span::before {
  content: "";
  bottom: -6px;
  position: absolute;
  right: 1.25rem;
  height: 10px;
  width: 10px;
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

:is(.dark .footer-collapse-arrow span)::before,:is(.dark 
.header-collapse-arrow span)::before {
  --tw-bg-opacity: 1;
  background-color: rgb(1 16 43 / var(--tw-bg-opacity));
}

.header-collapse-arrow span::before {
  bottom: auto;
  top: -5px;
}

.notepad-wrapper .inner {
  resize: both;
  overflow: auto;
}

.waiting-room-logo {
  height: 90px;
  display: flex;
}
.waiting-room-logo .waiting-room-logo-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  cursor: unset;
}

.header-logo {
  height: 45px;
  display: flex;
}
.header-logo .header-logo-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: left;
  cursor: unset;
}

html[dir=rtl] .header-logo .header-logo-img {
  object-position: right;
}

html[dir=rtl] .rtl\\:microphone-rtl-left::before {
  left: 26px;
  margin-left: 0;
}

.show-speech-setting .rtl\\:tooltip-right::before {
  left: 26px;
  right: auto;
}

#main-health-monitor-panel {
  position: fixed;
  left: 0px;
  width: 100%;
  z-index: 99999;
  height: 100vh;
  top: 0px;
  background-color: rgba(0, 0, 0, 0.3);
}
#main-health-monitor-panel.monitor-panel.close {
  display: none;
}
#main-health-monitor-panel.monitor-panel.open {
  display: block;
}
#main-health-monitor-panel .wrapper-health-monitor {
  background-color: white;
  border-radius: 8px;
  padding: 50px;
  min-height: calc(100% - 50px);
  margin-top: 25px;
  width: calc(100% - 50px);
  margin-left: 25px;
  position: relative;
}
#main-health-monitor-panel .wrapper-health-monitor .monitor-header {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  padding: 50px;
}
#main-health-monitor-panel .wrapper-health-monitor .monitor-header .monitor-patient.name {
  font-size: 30px;
  font-weight: bold;
}
#main-health-monitor-panel .wrapper-health-monitor .monitor-header .monitor-patient.close-modal {
  position: absolute;
  right: 10px;
  top: 10px;
  border-radius: 100%;
  border: 1px solid black;
  padding: 10px;
  width: 45px;
  height: 45px;
  text-align: center;
}
#main-health-monitor-panel .wrapper-health-monitor .monitor-content {
  margin-top: 80px;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-column-gap: 10px;
  grid-row-gap: 10px;
}
#main-health-monitor-panel .wrapper-health-monitor .monitor-content .monitor-alert {
  background-color: green;
  width: 100%;
  border-radius: 8px;
  color: white;
  padding: 20px;
}
#main-health-monitor-panel .wrapper-health-monitor .monitor-content .monitor-alert.alert {
  background-color: red;
}
#main-health-monitor-panel .wrapper-health-monitor .monitor-content .monitor-alert .title {
  text-align: right;
}
#main-health-monitor-panel .wrapper-health-monitor .monitor-content .monitor-alert .content {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
}
#main-health-monitor-panel .wrapper-health-monitor .monitor-content .monitor-alert .content .monitor-value {
  font-weight: 900;
  font-size: 25px;
}
#main-health-monitor-panel .wrapper-health-monitor .monitor-chart {
  margin-top: 20px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  max-height: calc(100vh - 350px);
  overflow-y: scroll;
  overflow-x: hidden;
}
#main-health-monitor-panel .wrapper-health-monitor .monitor-chart::-webkit-scrollbar-track {
  display: none;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #F5F5F5;
}
#main-health-monitor-panel .wrapper-health-monitor .monitor-chart::-webkit-scrollbar {
  display: none;
  width: 6px;
  background-color: #F5F5F5;
}
#main-health-monitor-panel .wrapper-health-monitor .monitor-chart::-webkit-scrollbar-thumb {
  display: none;
  background-color: #000000;
}
#main-health-monitor-panel .wrapper-health-monitor .monitor-chart .monitor-chart-wrapper {
  width: 100%;
}

.monitor-icon {
  width: 20px;
  position: relative;
}

@keyframes refresh {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0.5;
  }
}
@keyframes wobble {
  0% {
    transform: none;
  }
  15% {
    transform: translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg);
  }
  30% {
    transform: translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg);
  }
  45% {
    transform: translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg);
  }
  60% {
    transform: translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg);
  }
  75% {
    transform: translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg);
  }
  100% {
    transform: none;
  }
}
@keyframes pulse {
  0% {
    box-shadow: 0 0 5px 0 rgba(0, 77, 144, 0.3);
  }
  65% {
    box-shadow: 0 0 5px 13px rgb(242, 242, 242);
  }
  90% {
    box-shadow: 0 0 5px 13px rgb(242, 242, 242);
  }
}
@keyframes lds-ripple2 {
  0% {
    top: 16px;
    left: 16px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 0;
    left: 0;
    width: 30px;
    height: 30px;
    opacity: 0;
  }
}
.shake {
  animation-name: wobble;
  -webkit-animation-duration: 0.8s;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-timing-function: linear;
  -webkit-transform-origin: 50% 100%;
  display: inline-block;
}

.hiddenAnimation {
  animation: refresh 0.5s infinite;
}

.dark .main-app-bg::before {
  position: absolute;
  height: 100%;
  width: 100%;
  --tw-bg-opacity: 1;
  background-color: rgb(0 18 34 / var(--tw-bg-opacity));
  opacity: 0.7;
  --tw-content: "";
  content: var(--tw-content);
}
.dark .waiting-room::before {
  position: absolute;
  height: 100%;
  width: 100%;
  --tw-bg-opacity: 1;
  background-color: rgb(0 18 34 / var(--tw-bg-opacity));
  opacity: 0.7;
  --tw-content: "";
  content: var(--tw-content);
}
.dark .error-app-bg::before {
  position: absolute;
  height: 100%;
  width: 100%;
  --tw-bg-opacity: 1;
  background-color: rgb(0 18 34 / var(--tw-bg-opacity));
  opacity: 0.7;
  --tw-content: "";
  content: var(--tw-content);
}
.dark .multi-gradient {
  background: #031a3e;
}
.dark #main-area.fullWidthMainArea .all-webcam-wrapper {
  background: #031a3e;
}
.dark .message-form {
  background: transparent;
}
.dark .Toastify__toast {
  background: #222;
  color: #fff;
}
.dark button.Toastify__close-button svg path {
  fill: #fff;
}
.dark .wb-page-navigation button:disabled {
  background-color: var(--button-gray-1) !important;
}
.dark .header-before-start {
  opacity: 0.4;
}
.dark .header-before-end {
  opacity: 0.1;
}
.dark .select-camera-number {
  color: #a7cced;
}
.dark .select-camera-number select#select-camera-num {
  border-color: #a7cced;
}

.plugNmeet-app #main-area.isRecorder .all-webcam-wrapper {
  height: 100vh;
}
.plugNmeet-app #main-area.fullWidthMainArea.isRecorder .middle-fullscreen-wrapper.verticalsWebcamsActivated {
  padding-left: 440px;
}
.plugNmeet-app .isRecorder .transition-right-panel {
  position: relative;
}
.plugNmeet-app .isRecorder.showScreenShare .middle-area {
  display: flex;
  align-items: center;
  justify-content: center;
}

@media screen and (max-width: 1800px) {
  .plugNmeet-app #main-area.fullWidthMainArea.isRecorder .middle-fullscreen-wrapper.verticalsWebcamsActivated {
    padding-left: 270px;
  }
}
@media screen and (max-width: 1280px) {
  .plugNmeet-app #main-area.fullWidthMainArea.isRecorder .middle-fullscreen-wrapper.verticalsWebcamsActivated {
    padding-left: 200px;
  }
}
@media screen and (max-width: 1023px) {
  .plugNmeet-app #main-area.fullWidthMainArea.isRecorder .middle-fullscreen-wrapper.verticalsWebcamsActivated {
    padding-left: 0px;
  }
}
@media (min-width: 1024px) {
  .all-webcam-wrapper-inner {
    padding: 1.5rem;
  }
  #main-area.column-camera-position-top.fullWidthMainArea .verticalsWebcamsActivated .all-webcam-wrapper,
  #main-area.column-camera-position-bottom.fullWidthMainArea .verticalsWebcamsActivated .all-webcam-wrapper {
    top: 0px;
    height: 130px;
    width: 100%;
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 15px;
    padding-right: 15px;
  }
  #main-area.column-camera-position-top.column-camera-width-medium.fullWidthMainArea .verticalsWebcamsActivated .all-webcam-wrapper,
  #main-area.column-camera-position-bottom.column-camera-width-medium.fullWidthMainArea .verticalsWebcamsActivated .all-webcam-wrapper {
    height: 120px;
  }
  #main-area.column-camera-position-top.column-camera-width-small.fullWidthMainArea .verticalsWebcamsActivated .all-webcam-wrapper,
  #main-area.column-camera-position-bottom.column-camera-width-small.fullWidthMainArea .verticalsWebcamsActivated .all-webcam-wrapper {
    height: 110px;
  }
  #main-area.column-camera-position-top.fullWidthMainArea .verticalsWebcamsActivated .all-webcam-wrapper .video-camera-item,
  #main-area.column-camera-position-bottom.fullWidthMainArea .verticalsWebcamsActivated .all-webcam-wrapper .video-camera-item {
    margin: 0px;
    display: inline-block;
    height: 100%;
  }
  #main-area.column-camera-position-top.fullWidthMainArea .verticalsWebcamsActivated .all-webcam-wrapper .all-webcam-wrapper-inner,
  #main-area.column-camera-position-bottom.fullWidthMainArea .verticalsWebcamsActivated .all-webcam-wrapper .all-webcam-wrapper-inner {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  #main-area.column-camera-position-top.fullWidthMainArea .verticalsWebcamsActivated .all-webcam-wrapper .all-webcam-wrapper-inner .video-camera-item,
  #main-area.column-camera-position-bottom.fullWidthMainArea .verticalsWebcamsActivated .all-webcam-wrapper .all-webcam-wrapper-inner .video-camera-item {
    width: 12.5%;
  }
  #main-area.column-camera-position-top.fullWidthMainArea .verticalsWebcamsActivated,
  #main-area.column-camera-position-bottom.fullWidthMainArea .verticalsWebcamsActivated {
    padding: 0 !important;
  }
  #main-area.column-camera-position-top.fullWidthMainArea .verticalsWebcamsActivated .all-webcam-wrapper .all-webcam-wrapper-inner button.next-cam,
  #main-area.column-camera-position-bottom.fullWidthMainArea .verticalsWebcamsActivated .all-webcam-wrapper .all-webcam-wrapper-inner button.next-cam {
    right: 0px;
    left: auto;
    height: 100%;
    width: 1.25rem;
    border-radius: 0px;
  }
  #main-area.column-camera-position-top.fullWidthMainArea .verticalsWebcamsActivated .all-webcam-wrapper .all-webcam-wrapper-inner button.next-cam i,
  #main-area.column-camera-position-bottom.fullWidthMainArea .verticalsWebcamsActivated .all-webcam-wrapper .all-webcam-wrapper-inner button.next-cam i {
    display: inline-block;
    --tw-rotate: -90deg;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
  #main-area.column-camera-position-top.fullWidthMainArea .verticalsWebcamsActivated .all-webcam-wrapper .all-webcam-wrapper-inner button.previous-cam,
  #main-area.column-camera-position-bottom.fullWidthMainArea .verticalsWebcamsActivated .all-webcam-wrapper .all-webcam-wrapper-inner button.previous-cam {
    height: 100%;
    width: 1.25rem;
    border-radius: 0px;
    padding: 0px;
  }
  #main-area.column-camera-position-top.fullWidthMainArea .verticalsWebcamsActivated .all-webcam-wrapper .all-webcam-wrapper-inner button.previous-cam i,
  #main-area.column-camera-position-bottom.fullWidthMainArea .verticalsWebcamsActivated .all-webcam-wrapper .all-webcam-wrapper-inner button.previous-cam i {
    display: inline-block;
    --tw-rotate: -90deg;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
  #main-area.column-camera-position-top.fullWidthMainArea .verticalsWebcamsActivated .all-webcam-wrapper {
    bottom: 0px;
  }
  #main-area.column-camera-position-bottom.fullWidthMainArea .verticalsWebcamsActivated .all-webcam-wrapper {
    bottom: 0px;
    top: auto;
  }
  #main-area.column-camera-position-left.column-camera-width-medium.fullWidthMainArea .middle-fullscreen-wrapper.verticalsWebcamsActivated {
    padding-left: 250px;
  }
  #main-area.column-camera-position-left.column-camera-width-small.fullWidthMainArea .middle-fullscreen-wrapper.verticalsWebcamsActivated {
    padding-left: 230px;
  }
  #main-area.column-camera-position-left.column-camera-width-medium.fullWidthMainArea .middle-fullscreen-wrapper.verticalsWebcamsActivated .all-webcam-wrapper {
    width: 240px;
  }
  #main-area.column-camera-position-left.column-camera-width-small.fullWidthMainArea .middle-fullscreen-wrapper.verticalsWebcamsActivated .all-webcam-wrapper {
    width: 220px;
  }
  #main-area.column-camera-width-medium.fullWidthMainArea #main-left-panel {
    width: 240px;
  }
  #main-area.column-camera-width-small.fullWidthMainArea #main-left-panel {
    width: 220px;
  }
  #main-area.column-camera-position-top.fullWidthMainArea .verticalsWebcamsActivated .excalidraw-wrapper {
    margin-top: 140px;
    height: calc(100% - 150px);
  }
  #main-area.column-camera-position-top.column-camera-width-medium.fullWidthMainArea .verticalsWebcamsActivated .excalidraw-wrapper {
    margin-top: 130px;
    height: calc(100% - 140px);
  }
  #main-area.column-camera-position-top.column-camera-width-small.fullWidthMainArea .verticalsWebcamsActivated .excalidraw-wrapper {
    margin-top: 120px;
    height: calc(100% - 130px);
  }
  #main-area.column-camera-position-bottom.fullWidthMainArea .verticalsWebcamsActivated .excalidraw-wrapper {
    margin-top: 2.25rem;
    height: calc(100% - 175px);
  }
  #main-area.column-camera-position-bottom.column-camera-width-medium.fullWidthMainArea .verticalsWebcamsActivated .excalidraw-wrapper {
    margin-top: 2.25rem;
    height: calc(100% - 165px);
  }
  #main-area.column-camera-position-bottom.column-camera-width-small.fullWidthMainArea .verticalsWebcamsActivated .excalidraw-wrapper {
    margin-top: 2.25rem;
    height: calc(100% - 155px);
  }
  #main-area.column-camera-position-top.fullWidthMainArea .verticalsWebcamsActivated .screen-share-video {
    margin-top: 130px;
    height: calc(100% - 130px);
  }
  #main-area.column-camera-position-top.column-camera-width-medium.fullWidthMainArea .verticalsWebcamsActivated .screen-share-video {
    margin-top: 120px;
    height: calc(100% - 120px);
  }
  #main-area.column-camera-position-top.column-camera-width-small.fullWidthMainArea .verticalsWebcamsActivated .screen-share-video {
    margin-top: 110px;
    height: calc(100% - 110px);
  }
  #main-area.column-camera-position-bottom.fullWidthMainArea .verticalsWebcamsActivated .screen-share-video {
    height: calc(100% - 130px);
  }
  #main-area.column-camera-position-bottom.column-camera-width-medium.fullWidthMainArea .verticalsWebcamsActivated .screen-share-video {
    height: calc(100% - 120px);
  }
  #main-area.column-camera-position-bottom.column-camera-width-small.fullWidthMainArea .verticalsWebcamsActivated .screen-share-video {
    height: calc(100% - 110px);
  }
  #main-area.column-camera-position-top.fullWidthMainArea .verticalsWebcamsActivated .notepad-wrapper {
    margin-top: 140px;
    height: calc(100% - 150px);
  }
  #main-area.column-camera-position-top.column-camera-width-medium.fullWidthMainArea .verticalsWebcamsActivated .notepad-wrapper {
    margin-top: 130px;
    height: calc(100% - 140px);
  }
  #main-area.column-camera-position-top.column-camera-width-small.fullWidthMainArea .verticalsWebcamsActivated .notepad-wrapper {
    margin-top: 120px;
    height: calc(100% - 130px);
  }
  #main-area.column-camera-position-bottom.fullWidthMainArea .verticalsWebcamsActivated .notepad-wrapper {
    height: calc(100% - 175px);
  }
  #main-area.column-camera-position-bottom.column-camera-width-medium.fullWidthMainArea .verticalsWebcamsActivated .notepad-wrapper {
    height: calc(100% - 165px);
  }
  #main-area.column-camera-position-bottom.column-camera-width-small.fullWidthMainArea .verticalsWebcamsActivated .notepad-wrapper {
    height: calc(100% - 155px);
  }
  #main-area.column-camera-position-top.fullWidthMainArea .verticalsWebcamsActivated .Div-external-media-player {
    margin-top: 130px;
    height: calc(100% - 130px);
  }
  #main-area.column-camera-position-top.column-camera-width-medium.fullWidthMainArea .verticalsWebcamsActivated .Div-external-media-player {
    margin-top: 120px;
    height: calc(100% - 120px);
  }
  #main-area.column-camera-position-top.column-camera-width-small.fullWidthMainArea .verticalsWebcamsActivated .Div-external-media-player {
    margin-top: 110px;
    height: calc(100% - 110px);
  }
  #main-area.column-camera-position-bottom.fullWidthMainArea .verticalsWebcamsActivated .Div-external-media-player {
    height: calc(100% - 130px);
  }
  #main-area.column-camera-position-bottom.column-camera-width-medium.fullWidthMainArea .verticalsWebcamsActivated .Div-external-media-player {
    height: calc(100% - 120px);
  }
  #main-area.column-camera-position-bottom.column-camera-width-small.fullWidthMainArea .verticalsWebcamsActivated .Div-external-media-player {
    height: calc(100% - 110px);
  }
  #main-area.column-camera-position-top.fullWidthMainArea .verticalsWebcamsActivated .external-display-link-wrapper {
    margin-top: 140px;
    height: calc(100% - 150px);
  }
  #main-area.column-camera-position-top.column-camera-width-medium.fullWidthMainArea .verticalsWebcamsActivated .external-display-link-wrapper {
    margin-top: 130px;
    height: calc(100% - 140px);
  }
  #main-area.column-camera-position-top.column-camera-width-small.fullWidthMainArea .verticalsWebcamsActivated .external-display-link-wrapper {
    margin-top: 120px;
    height: calc(100% - 130px);
  }
  #main-area.column-camera-position-bottom.fullWidthMainArea .verticalsWebcamsActivated .external-display-link-wrapper {
    height: calc(100% - 175px);
  }
  #main-area.column-camera-position-bottom.column-camera-width-medium.fullWidthMainArea .verticalsWebcamsActivated .external-display-link-wrapper {
    height: calc(100% - 165px);
  }
  #main-area.column-camera-position-bottom.column-camera-width-small.fullWidthMainArea .verticalsWebcamsActivated .external-display-link-wrapper {
    height: calc(100% - 155px);
  }
  #main-area.fullWidthMainArea.column-camera-position-left.column-camera-width-full .active-speakers-wrap {
    left: auto;
    right: 30px;
    width: calc(100% - 300px);
  }
  #main-area.fullWidthMainArea.column-camera-position-left.column-camera-width-medium .active-speakers-wrap {
    left: auto;
    right: 30px;
    width: calc(100% - 280px);
  }
  #main-area.fullWidthMainArea.column-camera-position-left.column-camera-width-small .active-speakers-wrap {
    left: auto;
    right: 30px;
    width: calc(100% - 260px);
  }
  .column-camera-position-top .active-speakers-wrap,
  .column-camera-position-bottom .active-speakers-wrap {
    max-width: calc(100% - 30px);
    margin: auto;
    right: 0;
  }
  .column-camera-width-medium .all-webcam-wrapper.total-cam-1 .all-webcam-wrapper-inner,
  .column-camera-width-medium .all-webcam-wrapper.total-cam-2 .all-webcam-wrapper-inner,
  .column-camera-width-medium .all-webcam-wrapper.total-cam-3 .all-webcam-wrapper-inner,
  .column-camera-width-medium .all-webcam-wrapper.total-cam-4 .all-webcam-wrapper-inner,
  .column-camera-width-medium .all-webcam-wrapper.total-cam-5 .all-webcam-wrapper-inner,
  .column-camera-width-medium .all-webcam-wrapper.total-cam-6 .all-webcam-wrapper-inner {
    width: 80%;
    margin: auto;
    height: 90%;
  }
  .column-camera-width-small .all-webcam-wrapper.total-cam-1 .all-webcam-wrapper-inner,
  .column-camera-width-small .all-webcam-wrapper.total-cam-2 .all-webcam-wrapper-inner,
  .column-camera-width-small .all-webcam-wrapper.total-cam-3 .all-webcam-wrapper-inner {
    width: 60%;
    margin: auto;
    height: 70%;
  }
  .column-camera-width-small .all-webcam-wrapper.total-cam-4 .all-webcam-wrapper-inner,
  .column-camera-width-small .all-webcam-wrapper.total-cam-5 .all-webcam-wrapper-inner,
  .column-camera-width-small .all-webcam-wrapper.total-cam-6 .all-webcam-wrapper-inner {
    width: 70%;
    margin: auto;
    height: 80%;
  }
}
@media only screen and (max-width: 980px) and (max-height: 450px) {
  .landscape-device #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper {
    bottom: auto;
    right: auto;
    left: 0px;
    height: 100%;
    width: 140px;
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
    padding-left: 0px;
    padding-right: 0px;
  }
  .landscape-device #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper .all-webcam-wrapper-inner {
    display: block !important;
    padding-top: 0px;
    padding-bottom: 0px;
    padding-left: 5px;
    padding-right: 5px;
  }
  .landscape-device #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper .all-webcam-wrapper-inner .video-camera-item {
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
    margin-left: 0px;
    margin-right: 0px;
    height: 31.33%;
  }
  .landscape-device #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper .all-webcam-wrapper-inner button.next-cam {
    top: auto;
    bottom: 0px;
    left: 0px;
    width: 100%;
    --tw-rotate: 0deg;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
  .landscape-device #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper .all-webcam-wrapper-inner button.previous-cam {
    top: 0px;
    left: 0px;
    width: 100%;
    --tw-rotate: 0deg;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
  .landscape-device .share-screen-wrapper.is-share-screen-running .screen-share-video button {
    bottom: 55px;
  }
}
@media only screen and (max-height: 720px) {
  .externalMediaPlayerWrapper {
    max-width: 900px;
  }
}
@media screen and (max-width: 1279px) {
  .all-MessageModule-wrap .message-item .system p.message-content {
    font-size: 0.875rem;
    line-height: 1.25rem;
    line-height: 16px;
  }
  .showChatPanel .screen-share-video button {
    right: 250px;
  }
}
@media screen and (max-width: 1023px) {
  .transition-left-panel {
    position: absolute;
    z-index: 9999;
    height: 100%;
  }
  .transition-right-panel {
    position: absolute;
    height: 100%;
    right: 0;
    z-index: 9999;
  }
  .transition-right-panel #main-right-panel .message-form {
    position: absolute;
  }
  .transition-right-panel #main-right-panel .messageModule-wrapper {
    height: calc(100% - 72px);
  }
  #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper {
    position: absolute;
    bottom: 0px;
    z-index: 9;
    height: auto;
    width: 100%;
    padding: 0px;
    padding-top: 0px;
  }
  #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper .all-webcam-wrapper-inner {
    margin: 0px;
    flex-wrap: wrap;
    gap: 0px;
    padding-top: 0px;
    padding-bottom: 0px;
    padding-left: 15px;
    padding-right: 15px;
  }
  #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper .all-webcam-wrapper-inner .video-camera-item {
    margin: 5px;
    height: 100px;
    width: 100%;
    max-width: 150px;
    padding-bottom: 0px;
  }
  #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper .all-webcam-wrapper-inner .video-camera-item .connection-status {
    display: none;
  }
  #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper .all-webcam-wrapper-inner .video-camera-item .mic-status {
    display: none;
  }
  #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper .all-webcam-wrapper-inner .video-camera-item .name {
    left: 5px;
    font-size: 0.75rem;
    line-height: 1rem;
  }
  #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper .all-webcam-wrapper-inner .video-camera-item .camera-video-player button {
    right: 0px;
    top: 0px;
  }
  #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper .all-webcam-wrapper-inner .video-camera-item .status.PinWebcam {
    left: 0px;
    top: 0px;
  }
  #main-area.fullWidthMainArea .all-webcam-wrapper.vertical-webcams .all-webcam-wrapper-inner {
    display: flex !important;
    flex-wrap: nowrap;
    justify-content: center;
  }
  #main-area.fullWidthMainArea .all-webcam-wrapper .all-webcam-wrapper-inner button.next-cam {
    right: -42px;
    left: auto;
    top: 45px;
    height: 1.25rem;
    width: 100px;
    --tw-rotate: -90deg;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
  #main-area.fullWidthMainArea .all-webcam-wrapper .all-webcam-wrapper-inner button.previous-cam {
    right: auto;
    left: -42px;
    top: 45px;
    height: 1.25rem;
    width: 100px;
    --tw-rotate: -90deg;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
  #main-area.fullWidthMainArea .middle-fullscreen-wrapper.verticalsWebcamsActivated {
    padding-left: 0px;
  }
  #main-area.fullWidthMainArea .middle-fullscreen-wrapper.verticalsWebcamsActivated .screen-share-video button {
    bottom: 165px;
  }
  .share-screen-wrapper.is-share-screen-running .screen-share-video button {
    position: fixed;
    bottom: 55px;
  }
  .Toastify__toast-container .Toastify__toast-body {
    padding: 0px;
  }
  .Toastify__toast-container .Toastify__toast {
    min-height: 40px;
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
  #main-area.hideParticipantsPanel.showScreenShare .active-speakers-wrap {
    flex-wrap: wrap;
    padding: 0px;
  }
  #main-area.hideParticipantsPanel.showScreenShare .active-speakers-wrap div {
    font-size: 10px;
  }
  #main-area.hideParticipantsPanel.showScreenShare .active-speakers-wrap div i {
    font-size: 7px;
  }
  .pin-webcam {
    display: none;
  }
  #main-right-panel {
    background: rgb(235, 248, 255);
    background: linear-gradient(150deg, rgb(235, 248, 255) 0%, rgb(255, 255, 255) 10%, rgb(243, 237, 249) 67%, rgb(214, 231, 255) 100%);
  }
  .dark #main-right-panel {
    background: #001222;
  }
  .plugNmeet-app {
    position: relative;
    height: 100vh;
  }
  .plugNmeet-app header#main-header {
    position: fixed;
    top: 0px;
    width: 100%;
  }
  .plugNmeet-app footer#main-footer {
    position: fixed;
    bottom: 0px;
    z-index: 99999;
    width: 100%;
  }
  .plugNmeet-app #main-area {
    height: calc(100% - 105px) !important;
    position: fixed;
    top: 50px;
    width: 100%;
  }
  .plugNmeet-app #main-area.isRecorder {
    height: 100% !important;
    top: 0px;
  }
  .landscape-device.is-mobile #main-area.fullWidthMainArea .middle-fullscreen-wrapper.verticalsWebcamsActivated {
    padding-left: 140px;
  }
  .private-m-tab {
    width: calc(100vh - 180px);
  }
  .excalidraw-wrapper {
    margin-top: 0.5rem;
    height: calc(100% - 20px);
  }
  body #plugNmeet-app .excalidraw-wrapper .excalidraw button.scroll-back-to-content {
    bottom: 35px !important;
  }
}
@media screen and (max-width: 767px) {
  .transition-right-panel {
    width: 100%;
  }
  .transition-right-panel .messageModule-wrapper {
    width: 100%;
  }
  .transition-right-panel .message-form {
    width: 100%;
  }
  .transition-left-panel {
    width: 100%;
  }
  .transition-left-panel #main-left-panel {
    width: 100%;
  }
  .is-mobile.portrait-device #main-area {
    height: calc(100vh - 180px);
  }
  .message-form .btns {
    margin-top: -6px;
    width: 50px;
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 0px;
    padding-right: 0px;
  }
  .message-form .btns button {
    margin-bottom: 10px;
    width: 50px;
  }
  .message-form .btns button i {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
  .private-m-tab::before {
    position: absolute;
    height: 0.25rem;
    width: 100%;
    background-color: rgb(0,77,144,0.2);
    --tw-content: "";
    content: var(--tw-content);
  }
}
@media screen and (min-width: 641px) {
  .preview-camera-webcam video {
    min-height: 240px;
  }
  .preview-camera-webcam canvas {
    min-height: 240px;
  }
}
@media screen and (max-width: 640px) {
  header#main-header {
    flex-wrap: wrap;
  }
  header#main-header .logo {
    order: 1;
    width: 50%;
  }
  header#main-header .dark-area {
    order: 1;
    height: 1.25rem;
    width: 50%;
  }
  header#main-header .middle {
    order: 2;
    margin-top: -10px;
    width: 100%;
  }
  header#main-header .middle h2 {
    word-break: break-all;
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
  footer#main-footer .footer-icon {
    margin-right: 5px;
  }
  footer#main-footer .whiteboard {
    margin-right: 5px;
  }
  footer#main-footer .shared-notepad {
    margin-right: 5px;
  }
  .excalidraw-wrapper .excalidraw .Stack_horizontal {
    display: flex !important;
    flex-wrap: wrap;
    justify-content: center !important;
  }
  .header-logo {
    height: 30px;
  }
  .all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-0.total-items-2 {
    flex-wrap: wrap;
  }
  .all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-0.total-items-2 .video-camera-item {
    height: 50%;
    width: 100%;
  }
  .all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-0.total-items-3 {
    flex-wrap: wrap;
  }
  .all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-0.total-items-3 .video-camera-item {
    height: 33.333333%;
    width: 100%;
  }
  .all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-0.total-items-4.inner-items-2 {
    flex-wrap: nowrap;
  }
  .all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-0.total-items-4.inner-items-2 .video-camera-item {
    height: 100%;
    width: 50%;
  }
  .all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-0.total-items-5.inner-items-2 {
    flex-wrap: nowrap;
  }
  .all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-0.total-items-5.inner-items-2 .video-camera-item {
    height: 100%;
    width: 50%;
  }
  .all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-1.total-items-5.inner-items-2 .video-camera-item {
    width: 50%;
  }
  .all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-2.total-items-5.inner-items-1 .video-camera-item {
    width: 50%;
  }
  .all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-2.total-items-6.inner-items-1 .video-camera-item {
    width: 50%;
  }
  .all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-0.total-items-6.inner-items-2 {
    flex-wrap: nowrap;
  }
  .all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-0.total-items-6.inner-items-2 .video-camera-item {
    height: 100%;
    width: 50%;
  }
}
@media screen and (max-width: 575px) {
  #main-area .share-screen-wrapper.is-share-screen-running .all-webcam-wrapper .all-webcam-wrapper-inner .video-camera-item {
    width: calc(32.5% - 10px);
    max-width: 100%;
  }
}
@media screen and (max-width: 370px) {
  .video-camera-item .name {
    font-size: 10px;
  }
  header#main-header .middle h2 {
    font-size: 0.75rem;
    line-height: 1rem;
  }
  .active-speakers-wrap div {
    padding-top: 0px;
    padding-bottom: 0px;
    padding-left: 5px;
    padding-right: 5px;
    font-size: 10px;
  }
  .active-speakers-wrap div i {
    font-size: 8px;
  }
}
@media screen and (min-width: 1800px) {
  #main-area.fullWidthMainArea .all-webcam-wrapper {
    width: 440px;
  }
  #main-area.fullWidthMainArea .middle-fullscreen-wrapper.verticalsWebcamsActivated {
    padding-left: 440px;
  }
  #main-area.fullWidthMainArea #main-left-panel {
    width: 440px;
  }
  #main-area.column-camera-position-left.column-camera-width-medium.fullWidthMainArea .middle-fullscreen-wrapper.verticalsWebcamsActivated {
    padding-left: 360px;
  }
  #main-area.column-camera-position-left.column-camera-width-small.fullWidthMainArea .middle-fullscreen-wrapper.verticalsWebcamsActivated {
    padding-left: 280px;
  }
  #main-area.column-camera-position-left.column-camera-width-medium.fullWidthMainArea .middle-fullscreen-wrapper.verticalsWebcamsActivated .all-webcam-wrapper {
    width: 360px;
  }
  #main-area.column-camera-position-left.column-camera-width-small.fullWidthMainArea .middle-fullscreen-wrapper.verticalsWebcamsActivated .all-webcam-wrapper {
    width: 280px;
  }
  #main-area.column-camera-width-medium.fullWidthMainArea #main-left-panel {
    width: 360px;
  }
  #main-area.column-camera-width-small.fullWidthMainArea #main-left-panel {
    width: 280px;
  }
  #main-area.fullWidthMainArea.column-camera-position-left.column-camera-width-full .active-speakers-wrap {
    left: auto;
    right: 30px;
    width: calc(100% - 470px);
  }
  #main-area.fullWidthMainArea.column-camera-position-left.column-camera-width-medium .active-speakers-wrap {
    left: auto;
    right: 30px;
    width: calc(100% - 390px);
  }
  #main-area.fullWidthMainArea.column-camera-position-left.column-camera-width-small .active-speakers-wrap {
    left: auto;
    right: 30px;
    width: calc(100% - 310px);
  }
  .column-camera-position-top .active-speakers-wrap,
  .column-camera-position-bottom .active-speakers-wrap {
    max-width: calc(100% - 30px);
    margin: auto;
    right: 0;
  }
}
@media screen and (max-width: 1025px) {
  button.previous-cam {
    left: -43px;
    height: 25px;
    width: 95px;
  }
  button.next-cam {
    right: -43px;
    height: 25px;
    width: 95px;
  }
  .footer-collapse-arrow,
  .header-collapse-arrow {
    display: none;
  }
}
@media screen and (max-width: 1025px) and (min-width: 641px) {
  .camera-row-1.total-items-5.inner-items-2 .video-camera-item {
    width: 50% !important;
  }
  .camera-row-2.total-items-5.inner-items-1 .video-camera-item {
    width: 50%;
  }
  .camera-row-1.total-items-7.inner-items-3 .video-camera-item {
    width: 50% !important;
  }
  .camera-row-2.total-items-7.inner-items-1 .video-camera-item {
    width: 33.333333%;
  }
  .camera-row-2.total-items-8.inner-items-2 .video-camera-item {
    width: 33.333333%;
  }
  .camera-row-2.total-items-9.inner-items-3 .video-camera-item {
    width: 33.333333%;
  }
}
.placeholder\\:text-black\\/50::placeholder {
  color: rgb(0 0 0 / 0.5);
}
.placeholder\\:text-darkText::placeholder {
  --tw-text-opacity: 1;
  color: rgb(167 204 237 / var(--tw-text-opacity));
}
.placeholder\\:text-primaryColor\\/70::placeholder {
  color: rgb(0 77 144 / 0.7);
}
.last\\:mr-0:last-child {
  margin-right: 0px;
}
.last\\:border-none:last-child {
  border-style: none;
}
.last\\:pr-0:last-child {
  padding-right: 0px;
}
.autofill\\:bg-transparent:-webkit-autofill {
  background-color: transparent;
}
.autofill\\:bg-transparent:autofill {
  background-color: transparent;
}
.hover\\:scale-95:hover {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:\\!bg-primaryColor:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(0 77 144 / var(--tw-bg-opacity)) !important;
}
.hover\\:\\!bg-secondaryColor:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(36 174 247 / var(--tw-bg-opacity)) !important;
}
.hover\\:bg-\\[\\#3d3d3d\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(61 61 61 / var(--tw-bg-opacity));
}
.hover\\:bg-\\[\\#ECF4FF\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(236 244 255 / var(--tw-bg-opacity));
}
.hover\\:bg-blue-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(191 219 254 / var(--tw-bg-opacity));
}
.hover\\:bg-brandRed\\/90:hover {
  background-color: rgb(237 33 57 / 0.9);
}
.hover\\:bg-primaryColor:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(0 77 144 / var(--tw-bg-opacity));
}
.hover\\:bg-red-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(248 113 113 / var(--tw-bg-opacity));
}
.hover\\:bg-red-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity));
}
.hover\\:bg-red-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(153 27 27 / var(--tw-bg-opacity));
}
.hover\\:bg-secondaryColor:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(36 174 247 / var(--tw-bg-opacity));
}
.hover\\:bg-white\\/\\[0\\.12\\]:hover {
  background-color: rgb(255 255 255 / 0.12);
}
.hover\\:text-\\[\\#b8b8b8\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(184 184 184 / var(--tw-text-opacity));
}
.hover\\:text-secondaryColor:hover {
  --tw-text-opacity: 1;
  color: rgb(36 174 247 / var(--tw-text-opacity));
}
.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.hover\\:shadow-md:hover {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:border-indigo-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity));
}
.focus\\:bg-secondaryColor:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(36 174 247 / var(--tw-bg-opacity));
}
.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-indigo-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 102 241 / var(--tw-ring-opacity));
}
.focus\\:ring-offset-2:focus {
  --tw-ring-offset-width: 2px;
}
.focus-visible\\:ring-2:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-blue-500:focus-visible {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity));
}
.focus-visible\\:ring-offset-2:focus-visible {
  --tw-ring-offset-width: 2px;
}
.group:hover .group-hover\\:visible {
  visibility: visible;
}
.group:hover .group-hover\\:text-secondaryColor {
  --tw-text-opacity: 1;
  color: rgb(36 174 247 / var(--tw-text-opacity));
}
.group:hover .group-hover\\:opacity-100 {
  opacity: 1;
}
:is(.dark .dark\\:divide-secondaryColor) > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(36 174 247 / var(--tw-divide-opacity));
}
:is(.dark .dark\\:border-\\[\\#24aef7\\]) {
  --tw-border-opacity: 1;
  border-color: rgb(36 174 247 / var(--tw-border-opacity));
}
:is(.dark .dark\\:border-darkText) {
  --tw-border-opacity: 1;
  border-color: rgb(167 204 237 / var(--tw-border-opacity));
}
:is(.dark .dark\\:border-darkText\\/20) {
  border-color: rgb(167 204 237 / 0.2);
}
:is(.dark .dark\\:border-darkText\\/30) {
  border-color: rgb(167 204 237 / 0.3);
}
:is(.dark .dark\\:border-darkText\\/70) {
  border-color: rgb(167 204 237 / 0.7);
}
:is(.dark .dark\\:border-darkText\\/80) {
  border-color: rgb(167 204 237 / 0.8);
}
:is(.dark .dark\\:border-darkText\\/90) {
  border-color: rgb(167 204 237 / 0.9);
}
:is(.dark .dark\\:border-primaryColor) {
  --tw-border-opacity: 1;
  border-color: rgb(0 77 144 / var(--tw-border-opacity));
}
:is(.dark .dark\\:border-white) {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
:is(.dark :is(.dark .dark\\:dark\\:border-darkText\\/20)) {
  border-color: rgb(167 204 237 / 0.2);
}
:is(.dark .dark\\:bg-\\[\\#262627\\]) {
  --tw-bg-opacity: 1;
  background-color: rgb(38 38 39 / var(--tw-bg-opacity));
}
:is(.dark .dark\\:bg-darkPrimary) {
  --tw-bg-opacity: 1;
  background-color: rgb(1 16 43 / var(--tw-bg-opacity));
}
:is(.dark .dark\\:bg-darkPrimary\\/70) {
  background-color: rgb(1 16 43 / 0.7);
}
:is(.dark .dark\\:bg-darkPrimary\\/90) {
  background-color: rgb(1 16 43 / 0.9);
}
:is(.dark .dark\\:bg-darkSecondary) {
  --tw-bg-opacity: 1;
  background-color: rgb(0 18 34 / var(--tw-bg-opacity));
}
:is(.dark .dark\\:bg-darkSecondary2) {
  --tw-bg-opacity: 1;
  background-color: rgb(11 45 101 / var(--tw-bg-opacity));
}
:is(.dark .dark\\:bg-darkSecondary3) {
  --tw-bg-opacity: 1;
  background-color: rgb(3 26 62 / var(--tw-bg-opacity));
}
:is(.dark .dark\\:bg-darkText) {
  --tw-bg-opacity: 1;
  background-color: rgb(167 204 237 / var(--tw-bg-opacity));
}
:is(.dark .dark\\:bg-secondaryColor) {
  --tw-bg-opacity: 1;
  background-color: rgb(36 174 247 / var(--tw-bg-opacity));
}
:is(.dark .dark\\:bg-transparent) {
  background-color: transparent;
}
:is(.dark .dark\\:text-\\[\\#b8b8b8\\]) {
  --tw-text-opacity: 1;
  color: rgb(184 184 184 / var(--tw-text-opacity));
}
:is(.dark .dark\\:text-brandRed) {
  --tw-text-opacity: 1;
  color: rgb(237 33 57 / var(--tw-text-opacity));
}
:is(.dark .dark\\:text-darkPrimary) {
  --tw-text-opacity: 1;
  color: rgb(1 16 43 / var(--tw-text-opacity));
}
:is(.dark .dark\\:text-darkSecondary) {
  --tw-text-opacity: 1;
  color: rgb(0 18 34 / var(--tw-text-opacity));
}
:is(.dark .dark\\:text-darkSecondary2) {
  --tw-text-opacity: 1;
  color: rgb(11 45 101 / var(--tw-text-opacity));
}
:is(.dark .dark\\:text-darkText) {
  --tw-text-opacity: 1;
  color: rgb(167 204 237 / var(--tw-text-opacity));
}
:is(.dark .dark\\:text-darkText\\/60) {
  color: rgb(167 204 237 / 0.6);
}
:is(.dark .dark\\:text-darkText\\/80) {
  color: rgb(167 204 237 / 0.8);
}
:is(.dark .dark\\:text-secondaryColor) {
  --tw-text-opacity: 1;
  color: rgb(36 174 247 / var(--tw-text-opacity));
}
:is(.dark .dark\\:text-white) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
:is(.dark .dark\\:text-white\\/90) {
  color: rgb(255 255 255 / 0.9);
}
:is(.dark .dark\\:ring-secondaryColor) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(36 174 247 / var(--tw-ring-opacity));
}
:is(.dark .dark\\:placeholder\\:text-white\\/70)::placeholder {
  color: rgb(255 255 255 / 0.7);
}
:is(.dark .dark\\:hover\\:bg-\\[\\#3d3d3d\\]:hover) {
  --tw-bg-opacity: 1;
  background-color: rgb(61 61 61 / var(--tw-bg-opacity));
}
:is(.dark .hover\\:dark\\:bg-darkSecondary2):hover {
  --tw-bg-opacity: 1;
  background-color: rgb(11 45 101 / var(--tw-bg-opacity));
}
:is(.dark .hover\\:dark\\:text-secondaryColor):hover {
  --tw-text-opacity: 1;
  color: rgb(36 174 247 / var(--tw-text-opacity));
}
:is(.dark .group:hover .dark\\:group-hover\\:text-white) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
@media (min-width: 640px) {
  .sm\\:-left-20 {
    left: -5rem;
  }
  .sm\\:right-auto {
    right: auto;
  }
  .sm\\:col-span-3 {
    grid-column: span 3 / span 3;
  }
  .sm\\:col-span-4 {
    grid-column: span 4 / span 4;
  }
  .sm\\:m-0 {
    margin: 0px;
  }
  .sm\\:mb-6 {
    margin-bottom: 1.5rem;
  }
  .sm\\:ml-4 {
    margin-left: 1rem;
  }
  .sm\\:flex {
    display: flex;
  }
  .sm\\:w-56 {
    width: 14rem;
  }
  .sm\\:w-\\[13rem\\] {
    width: 13rem;
  }
  .sm\\:w-\\[250px\\] {
    width: 250px;
  }
  .sm\\:w-\\[calc\\(100\\%-12rem\\)\\] {
    width: calc(100% - 12rem);
  }
  .sm\\:w-auto {
    width: auto;
  }
  .sm\\:max-w-\\[140px\\] {
    max-width: 140px;
  }
  .sm\\:max-w-\\[30\\.5rem\\] {
    max-width: 30.5rem;
  }
  .sm\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .sm\\:px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .sm\\:py-\\[2px\\] {
    padding-top: 2px;
    padding-bottom: 2px;
  }
  .sm\\:text-\\[12px\\] {
    font-size: 12px;
  }
  .sm\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }
  .sm\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}
@media (min-width: 768px) {
  .md\\:-left-6 {
    left: -1.5rem;
  }
  .md\\:bottom-0 {
    bottom: 0px;
  }
  .md\\:left-auto {
    left: auto;
  }
  .md\\:top-0 {
    top: 0px;
  }
  .md\\:mb-6 {
    margin-bottom: 1.5rem;
  }
  .md\\:inline-block {
    display: inline-block;
  }
  .md\\:flex {
    display: flex;
  }
  .md\\:h-\\[60px\\] {
    height: 60px;
  }
  .md\\:w-1\\/4 {
    width: 25%;
  }
  .md\\:w-\\[60px\\] {
    width: 60px;
  }
  .md\\:justify-center {
    justify-content: center;
  }
  .md\\:p-6 {
    padding: 1.5rem;
  }
  .md\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .md\\:pl-0 {
    padding-left: 0px;
  }
  .md\\:pl-12 {
    padding-left: 3rem;
  }
  .md\\:pl-6 {
    padding-left: 1.5rem;
  }
  .md\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }
  .md\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
  .md\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}
@media (min-width: 1024px) {
  .lg\\:-left-28 {
    left: -7rem;
  }
  .lg\\:bottom-\\[65px\\] {
    bottom: 65px;
  }
  .lg\\:left-\\[3\\.1rem\\] {
    left: 3.1rem;
  }
  .lg\\:right-6 {
    right: 1.5rem;
  }
  .lg\\:h-\\[32px\\] {
    height: 32px;
  }
  .lg\\:h-\\[40px\\] {
    height: 40px;
  }
  .lg\\:h-\\[60px\\] {
    height: 60px;
  }
  .lg\\:w-72 {
    width: 18rem;
  }
  .lg\\:w-\\[13\\.2rem\\] {
    width: 13.2rem;
  }
  .lg\\:w-\\[380px\\] {
    width: 380px;
  }
  .lg\\:w-\\[40px\\] {
    width: 40px;
  }
  .lg\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .lg\\:py-14 {
    padding-top: 3.5rem;
    padding-bottom: 3.5rem;
  }
  .lg\\:py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .lg\\:\\!text-xs {
    font-size: 0.75rem !important;
    line-height: 1rem !important;
  }
  .lg\\:text-\\[12px\\] {
    font-size: 12px;
  }
  .lg\\:text-\\[14px\\] {
    font-size: 14px;
  }
  .lg\\:text-\\[16px\\] {
    font-size: 16px;
  }
  .lg\\:text-\\[5px\\] {
    font-size: 5px;
  }
  .lg\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
  .lg\\:text-xs {
    font-size: 0.75rem;
    line-height: 1rem;
  }
}
@media (min-width: 1280px) {
  .xl\\:z-0 {
    z-index: 0;
  }
  .xl\\:-mx-4 {
    margin-left: -1rem;
    margin-right: -1rem;
  }
  .xl\\:mb-3 {
    margin-bottom: 0.75rem;
  }
  .xl\\:mb-5 {
    margin-bottom: 1.25rem;
  }
  .xl\\:h-\\[30px\\] {
    height: 30px;
  }
  .xl\\:w-60 {
    width: 15rem;
  }
  .xl\\:w-\\[13\\.75rem\\] {
    width: 13.75rem;
  }
  .xl\\:w-\\[300px\\] {
    width: 300px;
  }
  .xl\\:w-\\[30px\\] {
    width: 30px;
  }
  .xl\\:w-\\[320px\\] {
    width: 320px;
  }
  .xl\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .xl\\:pt-3 {
    padding-top: 0.75rem;
  }
  .xl\\:pt-4 {
    padding-top: 1rem;
  }
  .xl\\:pt-5 {
    padding-top: 1.25rem;
  }
  .xl\\:text-\\[13px\\] {
    font-size: 13px;
  }
  .xl\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}
.ltr\\:-right-5:where([dir="ltr"], [dir="ltr"] *) {
  right: -1.25rem;
}
.ltr\\:-right-6:where([dir="ltr"], [dir="ltr"] *) {
  right: -1.5rem;
}
.ltr\\:left-0:where([dir="ltr"], [dir="ltr"] *) {
  left: 0px;
}
.ltr\\:right-0:where([dir="ltr"], [dir="ltr"] *) {
  right: 0px;
}
.ltr\\:right-10:where([dir="ltr"], [dir="ltr"] *) {
  right: 2.5rem;
}
.ltr\\:right-3:where([dir="ltr"], [dir="ltr"] *) {
  right: 0.75rem;
}
.ltr\\:right-6:where([dir="ltr"], [dir="ltr"] *) {
  right: 1.5rem;
}
.ltr\\:right-8:where([dir="ltr"], [dir="ltr"] *) {
  right: 2rem;
}
.ltr\\:ml-2:where([dir="ltr"], [dir="ltr"] *) {
  margin-left: 0.5rem;
}
.ltr\\:ml-3:where([dir="ltr"], [dir="ltr"] *) {
  margin-left: 0.75rem;
}
.ltr\\:ml-4:where([dir="ltr"], [dir="ltr"] *) {
  margin-left: 1rem;
}
.ltr\\:mr-1:where([dir="ltr"], [dir="ltr"] *) {
  margin-right: 0.25rem;
}
.ltr\\:mr-2:where([dir="ltr"], [dir="ltr"] *) {
  margin-right: 0.5rem;
}
.ltr\\:mr-3:where([dir="ltr"], [dir="ltr"] *) {
  margin-right: 0.75rem;
}
.ltr\\:mr-4:where([dir="ltr"], [dir="ltr"] *) {
  margin-right: 1rem;
}
.ltr\\:mr-6:where([dir="ltr"], [dir="ltr"] *) {
  margin-right: 1.5rem;
}
.ltr\\:translate-x-1:where([dir="ltr"], [dir="ltr"] *) {
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.ltr\\:translate-x-5:where([dir="ltr"], [dir="ltr"] *) {
  --tw-translate-x: 1.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.ltr\\:translate-x-6:where([dir="ltr"], [dir="ltr"] *) {
  --tw-translate-x: 1.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.ltr\\:pl-3:where([dir="ltr"], [dir="ltr"] *) {
  padding-left: 0.75rem;
}
.ltr\\:pr-4:where([dir="ltr"], [dir="ltr"] *) {
  padding-right: 1rem;
}
.ltr\\:text-left:where([dir="ltr"], [dir="ltr"] *) {
  text-align: left;
}
@media (min-width: 640px) {
  .sm\\:ltr\\:mr-10:where([dir="ltr"], [dir="ltr"] *) {
    margin-right: 2.5rem;
  }
}
@media (min-width: 1024px) {
  .lg\\:ltr\\:mr-6:where([dir="ltr"], [dir="ltr"] *) {
    margin-right: 1.5rem;
  }
}
.rtl\\:-left-3:where([dir="rtl"], [dir="rtl"] *) {
  left: -0.75rem;
}
.rtl\\:-left-4:where([dir="rtl"], [dir="rtl"] *) {
  left: -1rem;
}
.rtl\\:-left-5:where([dir="rtl"], [dir="rtl"] *) {
  left: -1.25rem;
}
.rtl\\:-left-6:where([dir="rtl"], [dir="rtl"] *) {
  left: -1.5rem;
}
.rtl\\:left-0:where([dir="rtl"], [dir="rtl"] *) {
  left: 0px;
}
.rtl\\:left-10:where([dir="rtl"], [dir="rtl"] *) {
  left: 2.5rem;
}
.rtl\\:left-3:where([dir="rtl"], [dir="rtl"] *) {
  left: 0.75rem;
}
.rtl\\:left-6:where([dir="rtl"], [dir="rtl"] *) {
  left: 1.5rem;
}
.rtl\\:left-8:where([dir="rtl"], [dir="rtl"] *) {
  left: 2rem;
}
.rtl\\:-ml-4:where([dir="rtl"], [dir="rtl"] *) {
  margin-left: -1rem;
}
.rtl\\:ml-1:where([dir="rtl"], [dir="rtl"] *) {
  margin-left: 0.25rem;
}
.rtl\\:ml-2:where([dir="rtl"], [dir="rtl"] *) {
  margin-left: 0.5rem;
}
.rtl\\:ml-3:where([dir="rtl"], [dir="rtl"] *) {
  margin-left: 0.75rem;
}
.rtl\\:ml-4:where([dir="rtl"], [dir="rtl"] *) {
  margin-left: 1rem;
}
.rtl\\:ml-6:where([dir="rtl"], [dir="rtl"] *) {
  margin-left: 1.5rem;
}
.rtl\\:mr-2:where([dir="rtl"], [dir="rtl"] *) {
  margin-right: 0.5rem;
}
.rtl\\:mr-3:where([dir="rtl"], [dir="rtl"] *) {
  margin-right: 0.75rem;
}
.rtl\\:mr-4:where([dir="rtl"], [dir="rtl"] *) {
  margin-right: 1rem;
}
.rtl\\:-translate-x-0:where([dir="rtl"], [dir="rtl"] *) {
  --tw-translate-x: -0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rtl\\:-translate-x-0\\.5:where([dir="rtl"], [dir="rtl"] *) {
  --tw-translate-x: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rtl\\:-translate-x-5:where([dir="rtl"], [dir="rtl"] *) {
  --tw-translate-x: -1.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rtl\\:-translate-x-6:where([dir="rtl"], [dir="rtl"] *) {
  --tw-translate-x: -1.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rtl\\:translate-x-0:where([dir="rtl"], [dir="rtl"] *) {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rtl\\:rotate-180:where([dir="rtl"], [dir="rtl"] *) {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rtl\\:flex-row-reverse:where([dir="rtl"], [dir="rtl"] *) {
  flex-direction: row-reverse;
}
.rtl\\:justify-end:where([dir="rtl"], [dir="rtl"] *) {
  justify-content: flex-end;
}
.rtl\\:pl-4:where([dir="rtl"], [dir="rtl"] *) {
  padding-left: 1rem;
}
.rtl\\:pr-3:where([dir="rtl"], [dir="rtl"] *) {
  padding-right: 0.75rem;
}
.rtl\\:pt-2:where([dir="rtl"], [dir="rtl"] *) {
  padding-top: 0.5rem;
}
.rtl\\:text-right:where([dir="rtl"], [dir="rtl"] *) {
  text-align: right;
}
@media (min-width: 640px) {
  .sm\\:rtl\\:ml-10:where([dir="rtl"], [dir="rtl"] *) {
    margin-left: 2.5rem;
  }
}
@media (min-width: 768px) {
  .md\\:rtl\\:pr-4:where([dir="rtl"], [dir="rtl"] *) {
    padding-right: 1rem;
  }
}
@media (min-width: 1024px) {
  .lg\\:rtl\\:ml-6:where([dir="rtl"], [dir="rtl"] *) {
    margin-left: 1.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/plugnmeet-fonts.scss","webpack://./src/styles/index.scss","webpack://./node_modules/tailwindcss/base.css","webpack://./node_modules/tailwindcss/components.css","webpack://./node_modules/tailwindcss/utilities.css","webpack://./src/styles/common.scss","webpack://./src/styles/variables.scss","webpack://./src/styles/keyframes-animation.scss","webpack://./src/styles/dark-mode.scss","webpack://./src/styles/recorder.scss","webpack://./src/styles/media_screens/min_1024.scss","webpack://./src/styles/media_screens/max_w_980_max_h_450.scss","webpack://./src/styles/media_screens/max_h_720.scss","webpack://./src/styles/media_screens/max_1279.scss","webpack://./src/styles/media_screens/max_1023.scss","webpack://./src/styles/media_screens/max_767.scss","webpack://./src/styles/media_screens/min_641.scss","webpack://./src/styles/media_screens/max_640.scss","webpack://./src/styles/media_screens/max_575.scss","webpack://./src/styles/media_screens/max_370.scss","webpack://./src/styles/media_screens/min_1800.scss","webpack://./src/styles/media_screens/max_1025.scss","webpack://./src/styles/media_screens/min_641_max_1025.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,+DAAA;EACA,2DAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;ACCF;ADEA;EACE,0BAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;EACA,4CAAA;ACAF;ADGA;EACE,+EAAA;EACA,mCAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EAEA,sCAAA;EACA,mCAAA;EACA,kCAAA;ACFF;;ADKA;EACE,gBAAA;ACFF;;ADIA;EACE,gBAAA;ACDF;;ADGA;EACE,gBAAA;ACAF;;ADEA;EACE,gBAAA;ACCF;;ADCA;EACE,gBAAA;ACEF;;ADAA;EACE,gBAAA;ACGF;;ADDA;EACE,gBAAA;ACIF;;ADFA;EACE,gBAAA;ACKF;;ADHA;EACE,gBAAA;ACMF;;ADJA;EACE,gBAAA;ACOF;;ADLA;EACE,gBAAA;ACQF;;ADNA;EACE,gBAAA;ACSF;;ADPA;EACE,gBAAA;ACUF;;ADRA;EACE,gBAAA;ACWF;;ADTA;EACE,gBAAA;ACYF;;ADVA;EACE,gBAAA;ACaF;;ADXA;EACE,gBAAA;ACcF;;ADZA;EACE,gBAAA;ACeF;;ADbA;EACE,gBAAA;ACgBF;;ADdA;EACE,gBAAA;ACiBF;;ADfA;EACE,gBAAA;ACkBF;;ADhBA;EACE,gBAAA;ACmBF;;ADjBA;EACE,gBAAA;ACoBF;;ADlBA;EACE,gBAAA;ACqBF;;ADnBA;EACE,gBAAA;ACsBF;;ADpBA;EACE,gBAAA;ACuBF;;ADrBA;EACE,gBAAA;ACwBF;;ADtBA;EACE,gBAAA;ACyBF;;ADvBA;EACE,gBAAA;AC0BF;;ADxBA;EACE,gBAAA;AC2BF;;ADzBA;EACE,gBAAA;AC4BF;;AD1BA;EACE,gBAAA;AC6BF;;AD3BA;EACE,gBAAA;AC8BF;;AD5BA;EACE,gBAAA;AC+BF;;AD7BA;EACE,gBAAA;ACgCF;;AD9BA;EACE,gBAAA;ACiCF;;AD/BA;EACE,gBAAA;ACkCF;;ADhCA;EACE,gBAAA;ACmCF;;ADjCA;EACE,gBAAA;ACoCF;;ADlCA;EACE,gBAAA;ACqCF;;ADnCA;EACE,gBAAA;ACsCF;;ADpCA;EACE,gBAAA;ACuCF;;ADrCA;EACE,gBAAA;ACwCF;;ADtCA;EACE,gBAAA;ACyCF;;ADvCA;EACE,gBAAA;AC0CF;;ADxCA;EACE,gBAAA;AC2CF;;ADzCA;EACE,gBAAA;AC4CF;;AD1CA;EACE,gBAAA;AC6CF;;AD3CA;EACE,gBAAA;AC8CF;;AD5CA;EACE,gBAAA;AC+CF;;AD7CA;EACE,gBAAA;ACgDF;;AD9CA;EACE,gBAAA;ACiDF;;AD/CA;EACE,gBAAA;ACkDF;;AChPA,iEAAA;;AAAA;;;CAAA;;AAAA;;;EAAA,sBAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,mBAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;;AAAA;;EAAA,gBAAA;AAAA;;AAAA;;;;;;;;CAAA;;AAAA;;EAAA,gBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA;EAAA,gBAAA,EAAA,MAAA;EAAA,WAAA,EAAA,MAAA;EAAA,+HAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,wCAAA,EAAA,MAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;;AAAA;;;;CAAA;;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,yCAAA;UAAA,iCAAA;AAAA;;AAAA;;CAAA;;AAAA;;;;;;EAAA,kBAAA;EAAA,oBAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,cAAA;EAAA,wBAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,mBAAA;AAAA;;AAAA;;;;;CAAA;;AAAA;;;;EAAA,+GAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,cAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,cAAA;EAAA,cAAA;EAAA,kBAAA;EAAA,wBAAA;AAAA;;AAAA;EAAA,eAAA;AAAA;;AAAA;EAAA,WAAA;AAAA;;AAAA;;;;CAAA;;AAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;EAAA,yBAAA,EAAA,MAAA;AAAA;;AAAA;;;;CAAA;;AAAA;;;;;EAAA,oBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA;EAAA,gCAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,SAAA,EAAA,MAAA;EAAA,UAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,oBAAA;AAAA;;AAAA;;;CAAA;;AAAA;;;;EAAA,0BAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,aAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,gBAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,wBAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,YAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,wBAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,0BAAA,EAAA,MAAA;EAAA,aAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,kBAAA;AAAA;;AAAA;;CAAA;;AAAA;;;;;;;;;;;;;EAAA,SAAA;AAAA;;AAAA;EAAA,SAAA;EAAA,UAAA;AAAA;;AAAA;EAAA,UAAA;AAAA;;AAAA;;;EAAA,gBAAA;EAAA,SAAA;EAAA,UAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,UAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,gBAAA;AAAA;;AAAA;;;CAAA;;AAAA;;EAAA,UAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,eAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,eAAA;AAAA;;AAAA;;;;CAAA;;AAAA;;;;;;;;EAAA,cAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,eAAA;EAAA,YAAA;AAAA;;AAAA,wEAAA;;AAAA;EAAA,aAAA;AAAA;;AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA;AAAA;;AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA;AAAA;ACAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;AAAA;ACAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,SAAA;EAAA;AAAA;AAAA;EAAA,QAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,0BAAA;EAAA,uBAAA;EAAA;AAAA;AAAA;EAAA,0BAAA;EAAA,uBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA,2BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA,2BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,eAAA;EAAA,eAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,yBAAA;KAAA,sBAAA;UAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,uDAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,4DAAA;EAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,kEAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA,uBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,kEAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,gCAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,eAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,0EAAA;EAAA,8FAAA;EAAA;AAAA;AAAA;EAAA,4CAAA;EAAA,uDAAA;EAAA;AAAA;AAAA;EAAA,2CAAA;EAAA,sDAAA;EAAA;AAAA;AAAA;EAAA,+EAAA;EAAA,mGAAA;EAAA;AAAA;AAAA;EAAA,0CAAA;EAAA,uDAAA;EAAA;AAAA;AAAA;EAAA,gFAAA;EAAA,oGAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA,2GAAA;EAAA,yGAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,wKAAA;EAAA,wJAAA;EAAA,gNAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,uGAAA;EAAA,+FAAA;EAAA,8HAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;ACCA;EACE,SAAA;EACA,sCAAA;EACA,mCAAA;EACA,kCAAA;EACA,gBAAA;AJqPF;;AIlPA;EACE,sCAAA;AJqPF;;AIlPA;EACE,cCda;ALmQf;;AIlPA;EACE,cCjBe;ALsQjB;;AIlPA;EACE,mBCtBa;AL2Qf;;AIlPA;EACE,mBCzBe;AL8QjB;;AIlPA;EACE,cC9Ba;ALmRf;;AIlPA;EACE,cCjCe;ALsRjB;;AI/OA;EACE,8BAAA;EACA,mIAAA;AJkPF;;AIpOI;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,wDAAA;EAAA;AAAA;AAIA;EAAA;AAAA;AAIA;EAAA;AAAA;;AAMA;EAAA;AAAA;;AAMA;EAAA;AAAA;;AAMA;EAAA,cAAA;EAAA;AAAA;;AAUE;EAAA,kBAAA;EAAA;AAAA;AAIA;EAAA;AAAA;AAIA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,wDAAA;EAAA;AAAA;;AAQA;EAAA,eAAA;EAAA,mBAAA;EAAA;AAAA;AAKF;EAAA,yBAAA;EAAA,0BAAA;EAAA,aAAA;EAAA,mBAAA;EAAA;AAAA;AAEE;EAAA;AAAA;AAEE;EAAA,kBAAA;EAAA,SAAA;EAAA,iBAAA;EAAA,eAAA;EAAA;AAAA;AAIA;EAAA;AAAA;AAMJ;EAAA;AAAA;AAEE;EAAA,iBAAA;EAAA;AAAA;AAEE;EAAA;AAAA;AAIA;EAAA,uCAAA;UAAA;AAAA;AAKF;EAAA;AAAA;;AASJ;EAAA,aAAA;EAAA,YAAA;EAAA;AAAA;AAEE;EAAA;AAAA;AAIA;EAAA,aAAA;EAAA,YAAA;EAAA,WAAA;EAAA,WAAA;EAAA;AAAA;AAEE;EAAA,aAAA;EAAA,uBAAA;EAAA;AAAA;AAIA;EAAA,aAAA;EAAA,uBAAA;EAAA;AAAA;AAIA;EAAA,aAAA;EAAA,uBAAA;EAAA;AAAA;AAKE;EAAA;AAAA;AAMA;EAAA;AAAA;AAMA;EAAA;AAAA;AAMA;EAAA;AAAA;AAMA;EAAA;AAAA;AAMA;EAAA;AAAA;AAMA;EAAA;AAAA;AAMA;EAAA;AAAA;AAMA;EAAA;AAAA;AAMA;EAAA;AAAA;AAMA;EAAA;AAAA;AAMA;EAAA;AAAA;AAMA;EAAA;AAAA;AAMA;EAAA;AAAA;AAMA;EAAA;AAAA;AAMA;EAAA;AAAA;AAMA;EAAA;AAAA;AAMA;EAAA;AAAA;AAMA;EAAA;AAAA;AAMA;EAAA;AAAA;AAMA;EAAA;AAAA;AAMA;EAAA;AAAA;AAMA;EAAA;AAAA;AAMA;EAAA;AAAA;AAKF;EAAA;AAAA;AAIA;EAAA;AAAA;AAKE;EAAA,sBAAA;EAAA;AAAA;AAMJ;EAAA,kBAAA;EAAA,QAAA;EAAA,WAAA;EAAA,UAAA;EAAA,YAAA;EAAA,YAAA;EAAA,mBAAA;EAAA,+LAAA;EAAA,4BAAA;EAAA,kCAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,wBAAA;EAAA,wDAAA;EAAA;AAAA;AAEE;EAAA,YAAA;EAAA,WAAA;EAAA,oBAAA;EAAA,gDAAA;EAAA,wBAAA;EAAA,wDAAA;EAAA;AAAA;AAKE;EAAA,oBAAA;EAAA;AAAA;AAMJ;EAAA,kBAAA;EAAA,QAAA;EAAA,UAAA;EAAA,YAAA;EAAA,UAAA;EAAA,YAAA;EAAA,YAAA;EAAA,mBAAA;EAAA,+LAAA;EAAA,4BAAA;EAAA,kCAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,wBAAA;EAAA,wDAAA;EAAA;AAAA;AAEE;EAAA,YAAA;EAAA,WAAA;EAAA,oBAAA;EAAA,gDAAA;EAAA,wBAAA;EAAA,wDAAA;EAAA;AAAA;AAKE;EAAA,oBAAA;EAAA;AAAA;;AAQJ;EAAA;AAAA;;AAKF;EAAA,kBAAA;EAAA,YAAA;EAAA,QAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA;AAAA;AAEE;EAAA,iBAAA;EAAA,iBAAA;EAAA,mBAAA;EAAA,sBAAA;EAAA,sDAAA;EAAA,6BAAA;EAAA,8BAAA;EAAA;AAAA;;AAKF;EAAA,UAAA;EAAA,YAAA;EAAA,WAAA;EAAA,gBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA;AAAA;AAEE;EAAA,QAAA;EAAA,sBAAA;EAAA;AAAA;AAIA;EAAA,kBAAA;EAAA,YAAA;EAAA,YAAA;EAAA,WAAA;EAAA,mBAAA;EAAA,iBAAA;EAAA,mBAAA;EAAA,yBAAA;EAAA,gBAAA;EAAA;AAAA;AAGF;EACE,gFAAA;EAKA,kBAAA;EAAA,WAAA;EAAA,YAAA;EAAA,WAAA;EAAA,gBAAA;EAAA,0BAAA;AJ2GJ;AIvGI;EAAA,kBAAA;EAAA,YAAA;EAAA,aAAA;EAAA,YAAA;EAAA,mBAAA;EAAA,oBAAA;EAAA,cAAA;EAAA,oBAAA;EAAA;AAAA;AAKE;EAAA,kBAAA;EAAA,aAAA;EAAA,YAAA;EAAA;AAAA;AAEE;EAAA,YAAA;EAAA;AAAA;AAKF;EAAA,kBAAA;EAAA,eAAA;EAAA,cAAA;EAAA,YAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,uBAAA;EAAA;AAAA;AAEE;EAAA,aAAA;EAAA,eAAA;EAAA,mBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kCAAA;EAAA;AAAA;AAKF;EAAA,WAAA;EAAA,aAAA;EAAA,YAAA;EAAA;AAAA;;AAOF;EAAA,sBAAA;EAAA,wDAAA;EAAA;AAAA;;AAOF;EACE,8BAAA;EACA,mIAAA;EAOA,kBAAA;EAAA,SAAA;EAAA,UAAA;EAAA,cAAA;EAAA,YAAA;EAAA,YAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,iBAAA;EAAA,kBAAA;AJyFJ;AItFQ;EAAA,6BAAA;EAAA;AAAA;AAIA;EAAA,SAAA;EAAA,aAAA;EAAA;AAAA;AAIA;EAAA;AAAA;AAIA;EAAA;AAAA;AAKF;EAAA,QAAA;EAAA,SAAA;EAAA,WAAA;EAAA,iBAAA;EAAA;AAAA;AAIA;EAAA,kBAAA;EAAA,SAAA;EAAA,WAAA;EAAA,SAAA;EAAA,WAAA;EAAA,iBAAA;EAAA;AAAA;AAIA;EAAA,cAAA;EAAA,gBAAA;EAAA,mBAAA;EAAA,iBAAA;EAAA;AAAA;AAKF;EAAA;AAAA;AAIA;EAAA,YAAA;EAAA,WAAA;EAAA;AAAA;;AAKF;EACE,WAAA;EACA,kBAAA;EAAA,YAAA;EAAA,YAAA;EAAA,YAAA;EAAA,WAAA;EAAA,kBAAA;EAAA,+LAAA;EAAA,iBAAA;EAAA,mBAAA;EAAA,gCAAA;EAAA,kBAAA;EAAA,yDAAA;AJ6EJ;;AI7EI;EAAA,kBAAA;EAAA;AAAA;;AAMF;EAAA,kBAAA;EAAA,kBAAA;EAAA,YAAA;EAAA,WAAA;EAAA,qBAAA;EAAA,YAAA;EAAA,sBAAA;EAAA,kBAAA;EAAA,yDAAA;EAAA,gBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,4CAAA;EAAA,+EAAA;EAAA,mGAAA;EAAA;AAAA;;AAAA;EAAA,kBAAA;EAAA,uDAAA;EAAA,oBAAA;EAAA;AAAA;AACA;EACE,WAAA;EACA,kBAAA;EAAA,YAAA;EAAA,SAAA;EAAA,UAAA;EAAA,YAAA;EAAA,YAAA;EAAA,WAAA;EAAA,kBAAA;EAAA,+LAAA;EAAA,iBAAA;EAAA,mBAAA;EAAA,gCAAA;EAAA,kBAAA;EAAA,yDAAA;AJ4EJ;AI5EI;EAAA,kBAAA;EAAA;AAAA;AAGF;EACE,WAAA;EACA,kBAAA;EAAA,SAAA;EAAA,WAAA;EAAA,cAAA;EAAA,WAAA;EAAA,sBAAA;EAAA,kBAAA;EAAA,yDAAA;AJ2EJ;AI3EI;EAAA,kBAAA;EAAA;AAAA;;AAKF;EACE,qBAAA;EACA,sBAAA;AJyEJ;;AIrEA;EACE,uBAAA;EACA,qBAAA;AJwEF;;AIrEA;EACE,qBAAA;EACA,sBAAA;AJwEF;;AIlEM;EAAA,mBAAA;EAAA;AAAA;;AAQJ;EACE,qBAAA;EACA,wBAAA;EACA,mCAAA;EACA,iCAAA;AJiEJ;;AI7DA;EACE,8BAAA;EACA,wFAAA;AJgEF;;AIxDE;EAAA;AAAA;;AAIA;EAAA,WAAA;EAAA;AAAA;;AAMI;EAAA,kBAAA;EAAA,qBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA;AAAA;;AAQF;EAAA,YAAA;EAAA;AAAA;AAEE;EAAA,SAAA;EAAA,UAAA;EAAA,yBAAA;EAAA;AAAA;AAIA;EAAA,SAAA;EAAA;AAAA;;AAQJ;EAAA;AAAA;AAEE;EAAA,kBAAA;EAAA,YAAA;EAAA,YAAA;EAAA;AAAA;AAEE;EAAA,iBAAA;EAAA,mBAAA;EAAA,sBAAA;EAAA,sDAAA;EAEA;AAFA;AAIA;EAEE,sBAAA;AJoDR;;AI7CE;EAAA,kBAAA;EAAA,UAAA;EAAA,YAAA;EAAA,uCAAA;EAAA,yDAAA;EAAA;AAAA;;AAIA;EAAA,kBAAA;EAAA,UAAA;EAAA,UAAA;EAAA,YAAA;EAAA,uCAAA;EAAA,yDAAA;EAAA;AAAA;;AAGF;EACE,kBAAA;EACA,sBAAA;EACA,0BAAA;AJiDF;AI/CE;EACE,0BAAA;EACA,YAAA;AJiDJ;AI9CM;EAAA,kBAAA;EAAA,gBAAA;EAAA;AAAA;AAKF;EAAA,kBAAA;EAAA,SAAA;EAAA,QAAA;EAAA,YAAA;EAAA;AAAA;;AAMA;EACE,sBAAA;AJ4CN;;AItCE;EAAA,WAAA;EAAA,wBAAA;KAAA,qBAAA;UAAA,gBAAA;EAAA,kBAAA;EAAA,6BAAA;EAAA,YAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA;AAAA;AACA;EACE,0CAAA;EAGA,6BAAA;EACA,YAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,mBAAA;EAAA,yBAAA;EAAA,uCAAA;AJ2CJ;AI3CI;EAAA;AAAA;AAIA;EAAA,YAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,mBAAA;EAAA,yBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAIA;EAAA,gBAAA;EAAA,YAAA;EAAA,WAAA;EAAA,wBAAA;UAAA,gBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,sDAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAIA;EAAA,YAAA;EAAA,WAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,sDAAA;EAAA;AAAA;AAKE;EAAA,8BAAA;EAAA;AAAA;AAIA;EAAA,8BAAA;EAAA;AAAA;;AAcF;EAAA;AAAA;;AAMA;EAAA;AAAA;AAKE;EAAA;AAAA;;AAMJ;EACE,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AJoBJ;;AIfE;EACE,yBAAA;AJkBJ;AIhBI;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AJkBN;;AIbA;EACE,yBAAA;AJgBF;;AITM;EAAA;AAAA;AAUE;EAAA,kBAAA;EAAA,OAAA;EAAA,eAAA;EAAA;AAAA;AAIA;EAAA;AAAA;AAEE;EACE,YAAA;AJKZ;AIFc;EAAA;AAAA;AAON;EAAA,WAAA;EAAA,YAAA;EAAA;AAAA;AAIA;EAAA;AAAA;AACA;EACE,wBAAA;EACA,eAAA;EAAA,mBAAA;AJCV;AICY;EAAA;AAAA;AAMJ;EAAA;AAAA;AACA;EACE,wBAAA;EACA,eAAA;EAAA,mBAAA;AJAV;AIEY;EAAA;AAAA;AAMJ;EAAA;AAAA;AACA;EACE,wBAAA;EACA,eAAA;EAAA,mBAAA;AJDV;AIGY;EAAA;AAAA;AAQA;EAAA;AAAA;AASF;EAAA;AAAA;;AAoBF;EAAA,WAAA;EAAA,0BAAA;EAAA;AAAA;AAIA;EAAA,WAAA;EAAA,0BAAA;EAAA;AAAA;AAIA;EAAA,WAAA;EAAA,0BAAA;EAAA;AAAA;AAEE;EAAA;AAAA;AAKF;EAAA,WAAA;EAAA,0BAAA;EAAA;AAAA;AAIA;EAAA;AAAA;AAOF;EAAA,WAAA;EAAA,YAAA;EAAA;AAAA;AAIA;EAAA,WAAA;EAAA,YAAA;EAAA;AAAA;AAIA;EAAA,WAAA;EAAA,YAAA;EAAA;AAAA;AAIA;EAAA,WAAA;EAAA,YAAA;EAAA;AAAA;AAKF;EACE,sBAAA;AJzCN;;AI+CA;EACE,kEAAA;EACA,sBAAA;AJ5CF;;AImDM;EACE,YAAA;AJhDR;AIuDM;EAAA;AAAA;AAMA;EAAA;AAAA;AAMA;EAAA;AAAA;AAMA;EAAA;AAAA;AAMA;EAAA;AAAA;;AASF;EAAA;AAAA;AAEE;EAAA,WAAA;EAAA;AAAA;AAKF;EAAA;AAAA;AAEE;EAAA,kBAAA;EAAA;AAAA;AAQE;EAAA,kBAAA;EAAA,YAAA;EAAA,UAAA;EAAA,YAAA;EAAA,WAAA;EAAA;AAAA;AAEE;EAAA,WAAA;EAAA,eAAA;EAAA,QAAA;EAAA,gBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA;AAAA;AAEE;EAAA,WAAA;EAAA,aAAA;EAAA,WAAA;EAAA,gBAAA;EAAA;AAAA;AAON;EAAA;AAAA;AAEE;EAAA;AAAA;AAEE;EAAA,kBAAA;EAAA;AAAA;AAKF;EAAA;AAAA;AAIA;EAAA;AAAA;AAIA;EAAA;AAAA;AAIA;EAAA;AAAA;AAKF;EACE,wBAAA;EACA,uBAAA;AJlFR;AIoFU;EAAA,YAAA;EAAA,UAAA;EAAA,SAAA;EAAA,eAAA;EAAA,YAAA;EAAA,mBAAA;EAAA;AAAA;AAIA;EAAA,WAAA;EAAA,WAAA;EAAA,SAAA;EAAA,eAAA;EAAA,YAAA;EAAA,mBAAA;EAAA,+LAAA;EAAA;AAAA;AAON;EAAA;AAAA;;AAKF;EACE,cAAA;AJxFJ;AI2FE;EACE,qCAAA;AJzFJ;;AI+FI;;EAEE,WAAA;AJ5FN;;AIkGE;;EAEE,aAAA;AJ/FJ;;AIoGE;;EAEE,aAAA;AJjGJ;;AIqGA;;EAEE,WAAA;EACA,YAAA;EACA,kBAAA;EAAA,cAAA;EAAA,YAAA;EAAA,WAAA;EAAA,kBAAA;EAAA,+LAAA;EAAA,kBAAA;EAAA,yDAAA;AJlGF;;AIkGE;;EAAA,kBAAA;EAAA;AAAA;;AAGF;EACE,YAAA;EACA,SAAA;AJlGF;;AIqGA;EACE,YAAA;EACA,cAAA;AJlGF;;AIqGA;EACE,YAAA;EACA,aAAA;AJlGF;AIoGE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;AJlGJ;;AIsGA;EACE,YAAA;EACA,aAAA;AJnGF;AIqGE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,aAAA;AJnGJ;;AIyGI;EACE,sBAAA;AJtGN;;AI2GA;EACE,UAAA;EACA,cAAA;AJxGF;;AI2GA;EACE,UAAA;EACA,WAAA;AJxGF;;AI6GA;EAKE,eAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;EACA,QAAA;EACA,oCAAA;AJ9GF;AIqGI;EAAU,aAAA;AJlGd;AImGI;EAAS,cAAA;AJhGb;AIyGE;EACE,uBAAA;EACA,kBAAA;EACA,aAjBS;EAkBT,6BAAA;EACA,gBAAA;EACA,wBAAA;EACA,iBAAA;EACA,kBAAA;AJvGJ;AIwGI;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,aA5BO;AJ1Eb;AIwGQ;EACE,eAAA;EACA,iBAAA;AJtGV;AIwGQ;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AJtGV;AI0GI;EACE,gBAAA;EACA,aAAA;EACA,qCAAA;EACA,qBAAA;EACA,kBAAA;AJxGN;AIyGM;EACE,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;AJvGR;AIwGQ;EACE,qBAAA;AJtGV;AIwGQ;EAAS,iBAAA;AJrGjB;AIsGQ;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;AJpGV;AIqGU;EACE,gBAAA;EACA,eAAA;AJnGZ;AIwGI;EACE,gBAAA;EACA,aAAA;EACA,qCAAA;EACA,qBAAA;EACA,kBAAA;EACA,+BAAA;EACA,kBAAA;EACA,kBAAA;AJtGN;AIuGM;EACE,aAAA;EACA,oDAAA;EACA,yBAAA;AJrGR;AIuGM;EACE,aAAA;EACA,UAAA;EACA,yBAAA;AJrGR;AIuGM;EACE,aAAA;EACA,yBAAA;AJrGR;AIuGM;EACE,WAAA;AJrGR;;AI0GA;EACE,WAAA;EACA,kBAAA;AJvGF;;AM/iCA;EACE;IACE,UAAA;ENkjCF;EMhjCA;IACE,YAAA;ENkjCF;AACF;AMlhCA;EACE;IAEE,eAAA;ENkjCF;EMhjCA;IAEE,2DAAA;ENkjCF;EMhjCA;IAEE,yDAAA;ENkjCF;EMhjCA;IAEE,2DAAA;ENkjCF;EMhjCA;IAEE,yDAAA;ENkjCF;EMhjCA;IAEE,0DAAA;ENkjCF;EMhjCA;IAEE,eAAA;ENkjCF;AACF;AMhjCA;EACE;IACE,2CAAA;ENkjCF;EMhjCA;IACE,2CAAA;ENkjCF;EMhjCA;IACE,2CAAA;ENkjCF;AACF;AMhjCA;EACE;IACE,SAAA;IACA,UAAA;IACA,QAAA;IACA,SAAA;IACA,UAAA;ENkjCF;EMhjCA;IACE,MAAA;IACA,OAAA;IACA,WAAA;IACA,YAAA;IACA,UAAA;ENkjCF;AACF;AM9iCA;EAEE,sBAAA;EACA,gCAAA;EACA,2CAAA;EACA,yCAAA;EACA,kCAAA;EACA,qBAAA;ANgjCF;;AM9iCA;EACE,gCAAA;ANijCF;;AOzpCM;EAAA,kBAAA;EAAA,YAAA;EAAA,WAAA;EAAA,kBAAA;EAAA,qDAAA;EAAA,YAAA;EAAA,gBAAA;EAAA;AAAA;AAKA;EAAA,kBAAA;EAAA,YAAA;EAAA,WAAA;EAAA,kBAAA;EAAA,qDAAA;EAAA,YAAA;EAAA,gBAAA;EAAA;AAAA;AAKA;EAAA,kBAAA;EAAA,YAAA;EAAA,WAAA;EAAA,kBAAA;EAAA,qDAAA;EAAA,YAAA;EAAA,gBAAA;EAAA;AAAA;AAGJ;EACE,mBAAA;APwpCJ;AOrpCI;EACE,mBAAA;APupCN;AOppCE;EACE,uBAAA;APspCJ;AOppCE;EACE,gBAAA;EACA,WAAA;APspCJ;AOlpCM;EACE,UAAA;APopCR;AO9oCM;EACE,iDAAA;APgpCR;AO5oCE;EACE,YAAA;AP8oCJ;AO5oCE;EACE,YAAA;AP8oCJ;AO5oCE;EACE,cAAA;AP8oCJ;AO7oCI;EACE,qBAAA;AP+oCN;;AQlsCM;EAAA;AAAA;AAKA;EAAA;AAAA;AAKA;EAAA;AAAA;AAKA;EAAA,aAAA;EAAA,mBAAA;EAAA;AAAA;;AAIN;EAIQ;IAAA;EAAA;AR8rCR;AQzrCA;EAIQ;IAAA;EAAA;AR0rCR;AQrrCA;EAIQ;IAAA;EAAA;ARsrCR;ASnuCA;EAEI;IAAA;EAAA;EAQA;;IAAA,QAAA;IAAA,aAAA;IAAA,WAAA;IAAA,gBAAA;IAAA,mBAAA;IAAA,kBAAA;IAAA;EAAA;EAQA;;IAAA;EAAA;EAQA;;IAAA;EAAA;EAUA;;IAAA,WAAA;IAAA,qBAAA;IAAA;EAAA;EAUA;;IAAA,aAAA;IAAA,mBAAA;IAAA;EAAA;EAYA;;IAAA;EAAA;EAEF;;IAIE,qBAAA;ETmsCF;ESvrCE;;IAAA,UAAA;IAAA,UAAA;IAAA,YAAA;IAAA,cAAA;IAAA;EAAA;EAcA;;IAAA,qBAAA;IAAA,mBAAA;IAAA;EAAA;EAYA;;IAAA,YAAA;IAAA,cAAA;IAAA,kBAAA;IAAA;EAAA;EAcA;;IAAA,qBAAA;IAAA,mBAAA;IAAA;EAAA;EAKA;IAAA;EAAA;EAKA;IAAA,WAAA;IAAA;EAAA;EAIA;IAAA;EAAA;EAIA;IAAA;EAAA;EAKA;IAAA;EAAA;EAKA;IAAA;EAAA;EAGA;IAAA;EAAA;EAGA;IAAA;EAAA;EAEF;IAGE,iBAAA;IACA,0BAAA;ETmpCF;ESjpCA;IAGE,iBAAA;IACA,0BAAA;ETipCF;ES/oCA;IAGE,iBAAA;IACA,0BAAA;ET+oCF;ES7oCA;IAGE,mBAAA;IACA,0BAAA;ET6oCF;ES3oCA;IAGE,mBAAA;IACA,0BAAA;ET2oCF;ESzoCA;IAGE,mBAAA;IACA,0BAAA;ETyoCF;ESvoCA;IAGE,iBAAA;IACA,0BAAA;ETuoCF;ESroCA;IAGE,iBAAA;IACA,0BAAA;ETqoCF;ESnoCA;IAGE,iBAAA;IACA,0BAAA;ETmoCF;ESjoCA;IAGE,0BAAA;ETioCF;ES/nCA;IAGE,0BAAA;ET+nCF;ES7nCA;IAGE,0BAAA;ET6nCF;ES3nCA;IAGE,iBAAA;IACA,0BAAA;ET2nCF;ESznCA;IAGE,iBAAA;IACA,0BAAA;ETynCF;ESvnCA;IAGE,iBAAA;IACA,0BAAA;ETunCF;ESrnCA;IAGE,0BAAA;ETqnCF;ESnnCA;IAGE,0BAAA;ETmnCF;ESjnCA;IAGE,0BAAA;ETinCF;ES/mCA;IAGE,iBAAA;IACA,0BAAA;ET+mCF;ES7mCA;IAGE,iBAAA;IACA,0BAAA;ET6mCF;ES3mCA;IAGE,iBAAA;IACA,0BAAA;ET2mCF;ESzmCA;IAGE,0BAAA;ETymCF;ESvmCA;IAGE,0BAAA;ETumCF;ESrmCA;IAGE,0BAAA;ETqmCF;ESnmCA;IAGE,iBAAA;IACA,0BAAA;ETmmCF;ESjmCA;IAGE,iBAAA;IACA,0BAAA;ETimCF;ES/lCA;IAGE,iBAAA;IACA,0BAAA;ET+lCF;ES7lCA;IAGE,0BAAA;ET6lCF;ES3lCA;IAGE,0BAAA;ET2lCF;ESzlCA;IAGE,0BAAA;ETylCF;ESrlCE;IAAA,UAAA;IAAA,WAAA;IAAA;EAAA;EAIA;IAAA,UAAA;IAAA,WAAA;IAAA;EAAA;EAIA;IAAA,UAAA;IAAA,WAAA;IAAA;EAAA;EAGF;;IAEE,4BAAA;IACA,YAAA;IACA,QAAA;ETqlCF;ESnlCA;;;;;;IAkBE,UAAA;IACA,YAAA;IACA,WAAA;ETykCF;ESvkCA;;;IASE,UAAA;IACA,YAAA;IACA,WAAA;ETmkCF;ESjkCA;;;IASE,UAAA;IACA,YAAA;IACA,WAAA;ET6jCF;AACF;AU/7CA;EAKU;IAAA,YAAA;IAAA,WAAA;IAAA,SAAA;IAAA,YAAA;IAAA,YAAA;IAAA,oBAAA;IAAA,uBAAA;IAAA,iBAAA;IAAA;EAAA;EACA;IACE,yBAAA;IACA,gBAAA;IAAA,mBAAA;IAAA,iBAAA;IAAA,kBAAA;EV+7CV;EU77CY;IAAA,mBAAA;IAAA,sBAAA;IAAA,gBAAA;IAAA,iBAAA;IAAA;EAAA;EAGA;IAAA,SAAA;IAAA,WAAA;IAAA,SAAA;IAAA,WAAA;IAAA,iBAAA;IAAA;EAAA;EAGA;IAAA,QAAA;IAAA,SAAA;IAAA,WAAA;IAAA,iBAAA;IAAA;EAAA;EASJ;IAAA;EAAA;AV27CV;AWp9CA;EAEI;IAAA;EAAA;AXu9CJ;AYz9CA;EAKU;IAAA,mBAAA;IAAA,oBAAA;IAAA;EAAA;EAgBF;IAAA;EAAA;AZ48CR;Aaj+CA;EAEI;IAAA,kBAAA;IAAA,aAAA;IAAA;EAAA;EAEF;IACE,kBAAA;IACA,YAAA;IACA,QAAA;IACA,aAAA;Ebm+CF;Eaj+CI;IACE,kBAAA;Ebm+CN;Eah+CM;IAAA;EAAA;EAOA;IAAA,kBAAA;IAAA,WAAA;IAAA,UAAA;IAAA,YAAA;IAAA,WAAA;IAAA,YAAA;IAAA;EAAA;EAEE;IAAA,WAAA;IAAA,eAAA;IAAA,QAAA;IAAA,gBAAA;IAAA,mBAAA;IAAA,kBAAA;IAAA;EAAA;EAEE;IAAA,WAAA;IAAA,aAAA;IAAA,WAAA;IAAA,gBAAA;IAAA;EAAA;EAEE;IAAA;EAAA;EAGA;IAAA;EAAA;EAGA;IAAA,SAAA;IAAA,kBAAA;IAAA;EAAA;EAIE;IAAA,UAAA;IAAA;EAAA;EAIF;IAAA,SAAA;IAAA;EAAA;EAOR;IACE,wBAAA;IACA,iBAAA;IAAA,uBAAA;Eb29CN;Ear9CQ;IAAA,YAAA;IAAA,UAAA;IAAA,SAAA;IAAA,eAAA;IAAA,YAAA;IAAA,mBAAA;IAAA;EAAA;EAGA;IAAA,WAAA;IAAA,WAAA;IAAA,SAAA;IAAA,eAAA;IAAA,YAAA;IAAA,mBAAA;IAAA;EAAA;EAKJ;IAAA;EAAA;EAGI;IAAA;EAAA;EAaF;IAAA,eAAA;IAAA;EAAA;EAMF;IAAA;EAAA;EAGA;IAAA,gBAAA;IAAA,mBAAA;IAAA;EAAA;EAKA;IAAA,eAAA;IAAA;EAAA;EAEE;IAAA;EAAA;EAEE;IAAA;EAAA;EAMN;IAAA;EAAA;EAEF;IACE,8BAAA;IACA,mIAAA;Ebs8CF;Ea77CE;IACE,mBAAA;Eb+7CJ;Ea37CE;IAAA,kBAAA;IAAA;EAAA;EAEE;IAAA,eAAA;IAAA,QAAA;IAAA;EAAA;EAGA;IAAA,eAAA;IAAA,WAAA;IAAA,cAAA;IAAA;EAAA;EAEF;IACE,qCAAA;IACA,eAAA;IAAA,SAAA;IAAA,WAAA;Eb+7CJ;Ea77CE;IACE,uBAAA;IACA,QAAA;Eb+7CJ;Eaz7CM;IAAA;EAAA;EAKJ;IAAA;EAAA;EAGA;IAAA,kBAAA;IAAA;EAAA;EAEF;IAKE,uBAAA;Ebs7CF;AACF;AcnlDA;EAEI;IAAA;EAAA;EAEE;IAAA;EAAA;EAGA;IAAA;EAAA;EAIF;IAAA;EAAA;EAEE;IAAA;EAAA;EAKA;IAAA;EAAA;EAKA;IAAA,gBAAA;IAAA,WAAA;IAAA,gBAAA;IAAA,mBAAA;IAAA,iBAAA;IAAA;EAAA;EAEE;IAAA,mBAAA;IAAA;EAAA;EAEE;IAAA,mBAAA;IAAA;EAAA;EAOJ;IAAA,kBAAA;IAAA,eAAA;IAAA,WAAA;IAAA,mCAAA;IAAA,gBAAA;IAAA;EAAA;AdilDN;AennDA;EAGM;IAAA;EAAA;EAGA;IAAA;EAAA;AfqnDN;AgB3nDA;EAEI;IAAA;EAAA;EAEE;IAAA,QAAA;IAAA;EAAA;EAGA;IAAA,QAAA;IAAA,eAAA;IAAA;EAAA;EAGA;IAAA,QAAA;IAAA,iBAAA;IAAA;EAAA;EAEE;IAAA,qBAAA;IAAA,mBAAA;IAAA;EAAA;EAMF;IAAA;EAAA;EAGA;IAAA;EAAA;EAGA;IAAA;EAAA;EAKA;IACE,wBAAA;IACA,eAAA;IACA,kCAAA;EhBynDN;EgBpnDE;IAAA;EAAA;EAKI;IAAA;EAAA;EAEE;IAAA,WAAA;IAAA;EAAA;EAIF;IAAA;EAAA;EAEE;IAAA,kBAAA;IAAA;EAAA;EAOF;IAAA;EAAA;EAFE;IAAA,YAAA;IAAA;EAAA;EAKF;IAAA;EAAA;EAEE;IAAA,YAAA;IAAA;EAAA;EAKA;IAAA;EAAA;EAKA;IAAA;EAAA;EAKA;IAAA;EAAA;EAOF;IAAA;EAAA;EAFE;IAAA,YAAA;IAAA;EAAA;AhBknDV;AiBpsDA;EAMY;IAAA,yBAAA;IAAA;EAAA;AjBmsDZ;AkBzsDA;EAGM;IAAA;EAAA;EAME;IAAA,kBAAA;IAAA;EAAA;EAMF;IAAA,gBAAA;IAAA,mBAAA;IAAA,iBAAA;IAAA,kBAAA;IAAA;EAAA;EAEE;IAAA;EAAA;AlBssDR;AmBvtDA;EAGM;IAAA;EAAA;EAGA;IAAA;EAAA;EAGA;IAAA;EAAA;EAKF;IAAA;EAAA;EAIA;IAAA;EAAA;EAKA;IAAA;EAAA;EAKA;IAAA;EAAA;EAGA;IAAA;EAAA;EAGA;IAAA;EAAA;EAKA;IAAA,UAAA;IAAA,WAAA;IAAA;EAAA;EAIA;IAAA,UAAA;IAAA,WAAA;IAAA;EAAA;EAIA;IAAA,UAAA;IAAA,WAAA;IAAA;EAAA;EAEF;;IAEE,4BAAA;IACA,YAAA;IACA,QAAA;EnB6sDF;AACF;AoBnwDA;EAEI;IAAA,WAAA;IAAA,YAAA;IAAA;EAAA;EAGA;IAAA,YAAA;IAAA,YAAA;IAAA;EAAA;EAEF;;IAEE,aAAA;EpBqwDF;AACF;AqB/wDA;EAEI;IACE,qBAAA;ErBgxDJ;EqB3wDI;IAAA;EAAA;EAIF;IACE,qBAAA;ErB4wDJ;EqBvwDI;IAAA;EAAA;EAKA;IAAA;EAAA;EAKA;IAAA;EAAA;ArBuwDN;ADnyDA;EAAA;ACmyDC;ADnyDD;EAAA,oBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA,iBCmyDC;EDnyDD,iBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA,6BCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA,6BCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA,kBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA,kBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA,kBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA,kBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA,kBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA,kBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA,kBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA,kBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA,oBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA,oBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA,oBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA,6ECmyDC;EDnyDD,iGCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA,sBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA,kBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA,8BCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA,2GCmyDC;EDnyDD,yGCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA,oBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA,2GCmyDC;EDnyDD,yGCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA,oBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA,oBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA,sBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA,sBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA,sBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA,sBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA,sBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA,kBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA,kBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA,kBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA,kBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA,kBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA,kBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA,kBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA,oBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA,oBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA,oBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA,oBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA,oBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA,oBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA,oBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA,oBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA,oBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA,kBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA,kBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA,oBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA,oBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA,kBCmyDC;IDnyDD;ECmyDC;EDnyDD;IAAA,qBCmyDC;IDnyDD;ECmyDC;EDnyDD;IAAA,gBCmyDC;IDnyDD;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA,eCmyDC;IDnyDD;ECmyDC;EDnyDD;IAAA,mBCmyDC;IDnyDD;ECmyDC;AAAA;ADnyDD;EAAA;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA,kBCmyDC;IDnyDD;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA,eCmyDC;IDnyDD;ECmyDC;EDnyDD;IAAA,mBCmyDC;IDnyDD;ECmyDC;EDnyDD;IAAA,mBCmyDC;IDnyDD;ECmyDC;AAAA;ADnyDD;EAAA;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA,oBCmyDC;IDnyDD;ECmyDC;EDnyDD;IAAA,mBCmyDC;IDnyDD;ECmyDC;EDnyDD;IAAA,mBCmyDC;IDnyDD;ECmyDC;EDnyDD;IAAA,6BCmyDC;IDnyDD;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA,mBCmyDC;IDnyDD;ECmyDC;EDnyDD;IAAA,kBCmyDC;IDnyDD;ECmyDC;AAAA;ADnyDD;EAAA;IAAA;ECmyDC;EDnyDD;IAAA,kBCmyDC;IDnyDD;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA,kBCmyDC;IDnyDD;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA;ECmyDC;EDnyDD;IAAA,mBCmyDC;IDnyDD;ECmyDC;AAAA;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA,yBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA,yBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA,wBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;IAAA;ECmyDC;AAAA;ADnyDD;EAAA;IAAA;ECmyDC;AAAA;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA,sBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA,2BCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA,0BCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA,yBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA,qBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA,mBCmyDC;EDnyDD;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;ACmyDC;ADnyDD;EAAA;IAAA;ECmyDC;AAAA;ADnyDD;EAAA;IAAA;ECmyDC;AAAA;ADnyDD;EAAA;IAAA;ECmyDC;AAAA","sourcesContent":["@font-face {\n  font-family: 'plugnmeet';\n  src: url('../assets/fonts/plugnmeet.ttf') format('truetype');\n  src: url('../assets/fonts/plugnmeet.woff') format('woff');\n  font-weight: normal;\n  font-style: normal;\n  font-display: block;\n}\n\n@font-face {\n  font-family: 'Nunito Sans';\n  src: url('../assets/fonts/NunitoSans-Regular.woff2');\n  src: url('../assets/fonts/NunitoSans-Bold.woff2');\n  src: url('../assets/fonts/NunitoSans-Italic.woff2');\n  src: url('../assets/fonts/NunitoSans-ExtraBold.woff2');\n  src: url('../assets/fonts/NunitoSans-SemiBold.woff2');\n}\n\ni {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'plugnmeet' !important;\n  speak: never;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.pnm-timeline-solid:before {\n  content: '\\e934';\n}\n.pnm-check:before {\n  content: '\\e932';\n}\n.pnm-updown:before {\n  content: '\\e933';\n}\n.pnm-closed-captioning:before {\n  content: '\\e931';\n}\n.pnm-pip:before {\n  content: '\\e930';\n}\n.pnm-cross:before {\n  content: '\\e92f';\n}\n.pnm-emoji:before {\n  content: '\\e92e';\n}\n.pnm-pin:before {\n  content: '\\e92d';\n}\n.pnm-moon:before {\n  content: '\\e92b';\n}\n.pnm-sun:before {\n  content: '\\e92c';\n}\n.pnm-display:before {\n  content: '\\e92a';\n}\n.pnm-blank-img:before {\n  content: '\\e929';\n}\n.pnm-breakout-room:before {\n  content: '\\e928';\n}\n.pnm-delete:before {\n  content: '\\e927';\n}\n.pnm-poll:before {\n  content: '\\e925';\n}\n.pnm-waiting-room:before {\n  content: '\\e926';\n}\n.pnm-menu-small:before {\n  content: '\\e900';\n}\n.pnm-attachment:before {\n  content: '\\e901';\n}\n.pnm-webcam:before {\n  content: '\\e902';\n}\n.pnm-settings:before {\n  content: '\\e903';\n}\n.pnm-send:before {\n  content: '\\e904';\n}\n.pnm-screen-share:before {\n  content: '\\e905';\n}\n.pnm-raise-hand:before {\n  content: '\\e906';\n}\n.pnm-participant:before {\n  content: '\\e907';\n}\n.pnm-arrow-below:before {\n  content: '\\e908';\n}\n.pnm-mic-mute:before {\n  content: '\\e909';\n}\n.pnm-lock:before {\n  content: '\\e90a';\n}\n.pnm-mic-unmute:before {\n  content: '\\e90b';\n}\n.pnm-menu-horizontal:before {\n  content: '\\e90c';\n}\n.pnm-call:before {\n  content: '\\e90d';\n}\n.pnm-chat:before {\n  content: '\\e90e';\n}\n.pnm-listen-only:before {\n  content: '\\e90f';\n}\n.pnm-network:before {\n  content: '\\e910';\n}\n.pnm-fullscreen:before {\n  content: '\\e911';\n}\n.pnm-arrow-down:before {\n  content: '\\e912';\n}\n.pnm-arrow-up:before {\n  content: '\\e913';\n}\n.pnm-logout:before {\n  content: '\\e914';\n}\n.pnm-rec:before {\n  content: '\\e915';\n}\n.pnm-broadcasting:before {\n  content: '\\e916';\n}\n.pnm-blur:before {\n  content: '\\e917';\n}\n.pnm-ban-solid:before {\n  content: '\\e918';\n}\n.pnm-notepad:before {\n  content: '\\e919';\n}\n.pnm-journal:before {\n  content: '\\e91a';\n}\n.pnm-whiteboard:before {\n  content: '\\e91b';\n}\n.pnm-download:before {\n  content: '\\e91c';\n}\n.pnm-keyboard:before {\n  content: '\\e91d';\n}\n.pnm-eye-slash:before {\n  content: '\\e91e';\n}\n.pnm-arrow-left-short:before {\n  content: '\\e91f';\n}\n.pnm-arrow-right-short:before {\n  content: '\\e920';\n}\n.pnm-file-play:before {\n  content: '\\e921';\n}\n.pnm-presenter:before {\n  content: '\\e922';\n}\n.pnm-speaker:before {\n  content: '\\e923';\n}\n.pnm-speaker-muted:before {\n  content: '\\e924';\n}\n","@font-face {\n  font-family: \"plugnmeet\";\n  src: url(\"../assets/fonts/plugnmeet.ttf\") format(\"truetype\");\n  src: url(\"../assets/fonts/plugnmeet.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n  font-display: block;\n}\n@font-face {\n  font-family: \"Nunito Sans\";\n  src: url(\"../assets/fonts/NunitoSans-Regular.woff2\");\n  src: url(\"../assets/fonts/NunitoSans-Bold.woff2\");\n  src: url(\"../assets/fonts/NunitoSans-Italic.woff2\");\n  src: url(\"../assets/fonts/NunitoSans-ExtraBold.woff2\");\n  src: url(\"../assets/fonts/NunitoSans-SemiBold.woff2\");\n}\ni {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: \"plugnmeet\" !important;\n  speak: never;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.pnm-timeline-solid:before {\n  content: \"\\e934\";\n}\n\n.pnm-check:before {\n  content: \"\\e932\";\n}\n\n.pnm-updown:before {\n  content: \"\\e933\";\n}\n\n.pnm-closed-captioning:before {\n  content: \"\\e931\";\n}\n\n.pnm-pip:before {\n  content: \"\\e930\";\n}\n\n.pnm-cross:before {\n  content: \"\\e92f\";\n}\n\n.pnm-emoji:before {\n  content: \"\\e92e\";\n}\n\n.pnm-pin:before {\n  content: \"\\e92d\";\n}\n\n.pnm-moon:before {\n  content: \"\\e92b\";\n}\n\n.pnm-sun:before {\n  content: \"\\e92c\";\n}\n\n.pnm-display:before {\n  content: \"\\e92a\";\n}\n\n.pnm-blank-img:before {\n  content: \"\\e929\";\n}\n\n.pnm-breakout-room:before {\n  content: \"\\e928\";\n}\n\n.pnm-delete:before {\n  content: \"\\e927\";\n}\n\n.pnm-poll:before {\n  content: \"\\e925\";\n}\n\n.pnm-waiting-room:before {\n  content: \"\\e926\";\n}\n\n.pnm-menu-small:before {\n  content: \"\\e900\";\n}\n\n.pnm-attachment:before {\n  content: \"\\e901\";\n}\n\n.pnm-webcam:before {\n  content: \"\\e902\";\n}\n\n.pnm-settings:before {\n  content: \"\\e903\";\n}\n\n.pnm-send:before {\n  content: \"\\e904\";\n}\n\n.pnm-screen-share:before {\n  content: \"\\e905\";\n}\n\n.pnm-raise-hand:before {\n  content: \"\\e906\";\n}\n\n.pnm-participant:before {\n  content: \"\\e907\";\n}\n\n.pnm-arrow-below:before {\n  content: \"\\e908\";\n}\n\n.pnm-mic-mute:before {\n  content: \"\\e909\";\n}\n\n.pnm-lock:before {\n  content: \"\\e90a\";\n}\n\n.pnm-mic-unmute:before {\n  content: \"\\e90b\";\n}\n\n.pnm-menu-horizontal:before {\n  content: \"\\e90c\";\n}\n\n.pnm-call:before {\n  content: \"\\e90d\";\n}\n\n.pnm-chat:before {\n  content: \"\\e90e\";\n}\n\n.pnm-listen-only:before {\n  content: \"\\e90f\";\n}\n\n.pnm-network:before {\n  content: \"\\e910\";\n}\n\n.pnm-fullscreen:before {\n  content: \"\\e911\";\n}\n\n.pnm-arrow-down:before {\n  content: \"\\e912\";\n}\n\n.pnm-arrow-up:before {\n  content: \"\\e913\";\n}\n\n.pnm-logout:before {\n  content: \"\\e914\";\n}\n\n.pnm-rec:before {\n  content: \"\\e915\";\n}\n\n.pnm-broadcasting:before {\n  content: \"\\e916\";\n}\n\n.pnm-blur:before {\n  content: \"\\e917\";\n}\n\n.pnm-ban-solid:before {\n  content: \"\\e918\";\n}\n\n.pnm-notepad:before {\n  content: \"\\e919\";\n}\n\n.pnm-journal:before {\n  content: \"\\e91a\";\n}\n\n.pnm-whiteboard:before {\n  content: \"\\e91b\";\n}\n\n.pnm-download:before {\n  content: \"\\e91c\";\n}\n\n.pnm-keyboard:before {\n  content: \"\\e91d\";\n}\n\n.pnm-eye-slash:before {\n  content: \"\\e91e\";\n}\n\n.pnm-arrow-left-short:before {\n  content: \"\\e91f\";\n}\n\n.pnm-arrow-right-short:before {\n  content: \"\\e920\";\n}\n\n.pnm-file-play:before {\n  content: \"\\e921\";\n}\n\n.pnm-presenter:before {\n  content: \"\\e922\";\n}\n\n.pnm-speaker:before {\n  content: \"\\e923\";\n}\n\n.pnm-speaker-muted:before {\n  content: \"\\e924\";\n}\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\nbody {\n  margin: 0;\n  font-family: \"Nunito Sans\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-weight: 400;\n}\n\ncode {\n  font-family: \"Nunito Sans\", sans-serif;\n}\n\n.primaryColor {\n  color: #004d90;\n}\n\n.secondaryColor {\n  color: #24aef7;\n}\n\n.bg-primaryColor {\n  background: #004d90;\n}\n\n.bg-secondaryColor {\n  background: #24aef7;\n}\n\n.border-primaryColor {\n  color: #004d90;\n}\n\n.border-secondaryColor {\n  color: #24aef7;\n}\n\n.multi-gradient {\n  background: rgb(235, 248, 255);\n  background: linear-gradient(150deg, rgb(235, 248, 255) 0%, rgb(255, 255, 255) 10%, rgb(243, 237, 249) 67%, rgb(214, 231, 255) 100%);\n}\n\n.scrollBar::-webkit-scrollbar-thumb {\n  @apply bg-secondaryColor border-none rounded-[5px];\n}\n.scrollBar::-webkit-scrollbar-track {\n  @apply bg-[rgba(0,0,0,0.15)];\n}\n.scrollBar::-webkit-scrollbar {\n  @apply w-2;\n}\n\n.scrollBar2::-webkit-scrollbar {\n  @apply w-[2px];\n}\n\n.scrollBar4::-webkit-scrollbar {\n  @apply w-1;\n}\n\n.scrollBar3::-webkit-scrollbar {\n  @apply h-2 w-full;\n}\n\n.private-m-tab .inner2::-webkit-scrollbar-track {\n  @apply bg-[rgb(224,226,231)];\n}\n.private-m-tab .inner2::-webkit-scrollbar {\n  @apply h-[5px];\n}\n.private-m-tab .inner2::-webkit-scrollbar-thumb {\n  @apply bg-secondaryColor border-none rounded-[5px];\n}\n\n.message-item .system p.message-content {\n  @apply text-base leading-[20px];\n}\n.message-item p.message-content {\n  @apply p-[10px] text-sm break-words rounded-MSG;\n}\n.message-item p.message-content span.download {\n  @apply relative;\n}\n.message-item p.message-content span.download i.pnm-download {\n  @apply text-base absolute -top-[2px] mr-[2px];\n}\n.message-item p.message-content span.download a {\n  @apply pl-5;\n}\n.message-item .content.me {\n  @apply w-full;\n}\n.message-item .content.me p.message-content {\n  @apply ml-auto rounded-MSGME;\n}\n.message-item .content.me p.message-content i.pnm-download {\n  @apply -top-[1px];\n}\n.message-item .content.me p.message-content a {\n  @apply underline;\n}\n.message-item .content.me .name {\n  @apply text-right;\n}\n\n.all-webcam-wrapper {\n  @apply h-full flex items-center;\n}\n.all-webcam-wrapper::-webkit-scrollbar {\n  @apply hidden;\n}\n.all-webcam-wrapper .all-webcam-wrapper-inner {\n  @apply w-full h-full p-5 grid gap-2;\n}\n.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-0 {\n  @apply flex gap-2 justify-center;\n}\n.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-1 {\n  @apply flex gap-2 justify-center;\n}\n.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-2 {\n  @apply flex gap-2 justify-center;\n}\n.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-0.total-items-2 .video-camera-item {\n  @apply w-1/2;\n}\n.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-1.total-items-2 .video-camera-item {\n  @apply w-1/2;\n}\n.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-0.total-items-3 .video-camera-item {\n  @apply w-1/3;\n}\n.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-1.total-items-3 .video-camera-item {\n  @apply w-1/3;\n}\n.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-1.total-items-5.inner-items-2 .video-camera-item {\n  @apply w-1/3;\n}\n.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-0.total-items-7.inner-items-4 .video-camera-item {\n  @apply w-1/4;\n}\n.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-1.total-items-7.inner-items-3 .video-camera-item {\n  @apply w-1/4;\n}\n.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-1.total-items-8.inner-items-4 .video-camera-item {\n  @apply w-1/4;\n}\n.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-2.total-items-11.inner-items-3 .video-camera-item {\n  @apply w-1/4;\n}\n.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-2.total-items-10.inner-items-2 .video-camera-item {\n  @apply w-1/4;\n}\n.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-2.total-items-13.inner-items-3 .video-camera-item {\n  @apply w-1/5;\n}\n.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-2.total-items-14.inner-items-4 .video-camera-item {\n  @apply w-1/5;\n}\n.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-2.total-items-15.inner-items-5 .video-camera-item {\n  @apply w-1/5;\n}\n.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-2.total-items-16.inner-items-4 .video-camera-item {\n  @apply w-[16.3%];\n}\n.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-2.total-items-17.inner-items-5 .video-camera-item {\n  @apply w-[16.3%];\n}\n.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-2.total-items-18.inner-items-6 .video-camera-item {\n  @apply w-[16.3%];\n}\n.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-2.total-items-19.inner-items-5 .video-camera-item {\n  @apply w-[13.95%];\n}\n.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-2.total-items-20.inner-items-6 .video-camera-item {\n  @apply w-[13.95%];\n}\n.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-2.total-items-21.inner-items-7 .video-camera-item {\n  @apply w-[13.95%];\n}\n.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-2.total-items-22.inner-items-6 .video-camera-item {\n  @apply w-[12.15%];\n}\n.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-2.total-items-23.inner-items-7 .video-camera-item {\n  @apply w-[12.15%];\n}\n.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-2.total-items-24.inner-items-8 .video-camera-item {\n  @apply w-[12.15%];\n}\n.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-1.total-items-9.inner-items-4 .video-camera-item {\n  @apply w-1/5;\n}\n.all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-1.total-items-10.inner-items-5 .video-camera-item {\n  @apply w-1/5;\n}\n.all-webcam-wrapper .all-webcam-wrapper-inner .video-camera-item.admin {\n  @apply order-1;\n}\n.all-webcam-wrapper .all-webcam-wrapper-inner .video-camera-item.participants {\n  @apply order-2;\n}\n.all-webcam-wrapper .all-webcam-wrapper-inner .video-camera-item.admin.speaking::before {\n  @apply border-[#004e91];\n}\n.all-webcam-wrapper button.previous-cam {\n  @apply absolute top-[48%] w-[120px] h-[30px] z-[1] bg-black/50 text-center transition-all -rotate-90 -left-[55px] rounded-tlblD pt-[6px];\n}\n.all-webcam-wrapper button.previous-cam i {\n  @apply w-[20px] m-auto transition-all text-white;\n}\n.all-webcam-wrapper button.previous-cam:hover i {\n  @apply text-white;\n}\n.all-webcam-wrapper button.next-cam {\n  @apply absolute top-[48%] w-[120px] h-[30px] z-[1] bg-black/50 text-center transition-all -rotate-90 left-auto -right-[55px] rounded-trbrD pt-[2px];\n}\n.all-webcam-wrapper button.next-cam i {\n  @apply w-[20px] m-auto transition-all text-white;\n}\n.all-webcam-wrapper button.next-cam:hover i {\n  @apply text-white;\n}\n\n.fullWidthMainArea .select-camera-number {\n  @apply hidden;\n}\n\n.select-camera-number {\n  @apply flex items-center absolute left-6 text-xs top-0;\n}\n.select-camera-number select#select-camera-num {\n  @apply bg-transparent border border-solid border-[#333] mr-[5px] outline-none;\n}\n\n.video-camera-item {\n  @apply w-full h-full rounded-2xl overflow-hidden z-[1] bg-black;\n}\n.video-camera-item .loading {\n  @apply top-1/2 -translate-y-1/2;\n}\n.video-camera-item::before {\n  @apply absolute content-[\"\"] w-full h-full border-[5px] border-solid border-transparent z-[999] rounded-[15px];\n}\n.video-camera-item::after {\n  background: linear-gradient(0deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.1) 50%);\n  @apply absolute content-[\"\"] w-full h-full z-[99];\n}\n.video-camera-item .name {\n  @apply absolute bottom-[10px] z-[999] text-white left-3 text-sm leading-[1];\n}\n.video-camera-item .camera-modules .camera-video-player {\n  @apply flex h-full w-full absolute;\n}\n.video-camera-item .camera-modules .camera-video-player video.camera-video {\n  @apply w-full h-full;\n}\n.video-camera-item .camera-modules .status {\n  @apply absolute z-[999] rounded-full bottom-3 right-3 flex items-center justify-center;\n}\n.video-camera-item .camera-modules .status > div {\n  @apply rounded-full bg-black/20 p-2 h-5 flex items-center justify-center;\n}\n.video-camera-item .camera-modules .status.PinWebcam {\n  @apply right-auto left-3 top-3 items-start;\n}\n\n.video-camera-item.speaking::before {\n  @apply border-secondaryColor;\n}\n\n#main-area.fullWidthMainArea .all-webcam-wrapper {\n  background: rgb(235, 248, 255);\n  background: linear-gradient(150deg, rgb(235, 248, 255) 0%, rgb(255, 255, 255) 10%, rgb(243, 237, 249) 67%, rgb(214, 231, 255) 100%);\n  @apply absolute w-[270px] h-full block py-[30px] px-0 z-[2] left-0;\n}\n#main-area.fullWidthMainArea .all-webcam-wrapper .video-camera-item::after {\n  @apply bg-transparent opacity-100;\n}\n#main-area.fullWidthMainArea .all-webcam-wrapper .video-camera-item .name {\n  @apply opacity-100 top-auto left-3;\n}\n#main-area.fullWidthMainArea .all-webcam-wrapper .video-camera-item .connection-status {\n  @apply flex;\n}\n#main-area.fullWidthMainArea .all-webcam-wrapper .video-camera-item .mic-status {\n  @apply flex;\n}\n#main-area.fullWidthMainArea .all-webcam-wrapper button.previous-cam {\n  @apply top-0 w-full left-0 rotate-0;\n}\n#main-area.fullWidthMainArea .all-webcam-wrapper button.next-cam {\n  @apply absolute w-full left-0 rotate-0 bottom-0 top-auto;\n}\n#main-area.fullWidthMainArea .all-webcam-wrapper .all-webcam-wrapper-inner {\n  @apply block py-0 px-[5px];\n}\n#main-area.fullWidthMainArea .middle-fullscreen-wrapper.verticalsWebcamsActivated {\n  @apply pl-[260px];\n}\n#main-area.fullWidthMainArea .middle-fullscreen-wrapper {\n  @apply flex-[auto] w-full h-full;\n}\n\n.SpeechHistory::before {\n  content: \"\";\n  @apply absolute h-[12px] w-[12px] bg-white dark:bg-darkPrimary bottom-[-6px] left-14 rotate-45 border border-solid border-darkPrimary/40;\n}\n\n.tooltip {\n  @apply invisible absolute shadow-lg rounded text-[13px] text-darkPrimary dark:text-darkText py-[6px] px-[10px] inline-block bg-gray-100 dark:bg-darkSecondary2 w-[150px] m-0 bottom-[52px] text-center;\n}\n.tooltip::before {\n  content: \"\";\n  @apply absolute h-[12px] w-[12px] bg-gray-100 dark:bg-darkSecondary2 bottom-[-6px] left-0 right-0 m-auto rotate-45 border border-solid border-darkPrimary/40;\n}\n.tooltip::after {\n  content: \"\";\n  @apply absolute h-2 w-full bg-gray-100 dark:bg-darkSecondary2 left-0 bottom-0 rounded;\n}\n\n.tooltip-left::before {\n  left: 24px !important;\n  right: auto !important;\n}\n\nhtml[dir=rtl] span.tooltip.tooltip-left {\n  right: -34px !important;\n  left: auto !important;\n}\n\nhtml[dir=rtl] span.tooltip.tooltip-left::before {\n  left: auto !important;\n  right: 45px !important;\n}\n\n.has-tooltip:hover .tooltip {\n  @apply visible z-[50];\n}\n\n#main-footer .record {\n  animation-name: pulse;\n  animation-duration: 1.5s;\n  animation-iteration-count: infinite;\n  animation-timing-function: linear;\n}\n\n.message-form {\n  background: rgb(214, 231, 255);\n  background: linear-gradient(0deg, rgba(214, 231, 255, 0.5) 67%, rgb(214, 231, 255) 100%);\n}\n\n.Toastify__toast-container {\n  @apply z-[999999];\n}\n\n.Toastify__toast-body {\n  @apply m-0 font-light;\n}\n\n.vertical-webcams .all-webcam-wrapper-inner .video-camera-item {\n  @apply h-[calc(33.33%-10px)] my-2 mx-0;\n}\n\n.share-screen-wrapper.is-share-screen-running .screen-share-video {\n  @apply h-full w-full;\n}\n.share-screen-wrapper.is-share-screen-running .screen-share-video video.video-player {\n  @apply h-[calc(100%-30px)] w-[calc(100%-30px)] top-[15px] left-[15px];\n}\n.share-screen-wrapper.is-share-screen-running .screen-share-video video.video-player.self-screen-share {\n  @apply w-[30%] left-[35%];\n}\n\n.footer-podcast-button {\n  @apply relative;\n}\n.footer-podcast-button .lds-ripple {\n  @apply absolute w-[30px] h-[30px] left-2;\n}\n.footer-podcast-button .lds-ripple div {\n  @apply border-2 border-solid border-[rgb(0,77,144)];\n  -webkit-animation: lds-ripple2 0.8s cubic-bezier(0, 0.2, 0.8, 1) infinite;\n  animation: lds-ripple2 0.8s cubic-bezier(0, 0.2, 0.8, 1) infinite;\n}\n.footer-podcast-button .lds-ripple div:last-child {\n  -webkit-animation-delay: -0.3s;\n  animation-delay: -0.3s;\n}\n\n.transition-left-panel {\n  @apply absolute h-full shadow-panel z-[3];\n}\n\n.transition-right-panel {\n  @apply absolute right-0 h-full shadow-panel z-[2];\n}\n\n.media-player-inner {\n  position: relative;\n  width: 100% !important;\n  height: inherit !important;\n}\n.media-player-inner > div {\n  height: inherit !important;\n  margin: auto;\n}\n.media-player-inner > div > div {\n  @apply overflow-hidden pb-[56.25%] relative;\n}\n.media-player-inner iframe {\n  @apply left-0 top-0 h-full w-full absolute;\n}\n\n.is-pc .media-player-inner > div {\n  width: 100% !important;\n}\n\n.range {\n  @apply appearance-none align-middle    outline-none border-none p-0 bg-transparent w-full;\n}\n.range::-webkit-slider-runnable-track {\n  background-color: rgba(128, 128, 128, 0.5);\n  height: 10px;\n  border-radius: 5px;\n  border: 1px solid transparent;\n  @apply bg-[rgba(128,128,128,0.5)] dark:bg-secondaryColor/90 h-[10px] rounded-[5px] border border-solid border-transparent;\n}\n.range::-moz-range-track {\n  @apply bg-[rgba(128,128,128,0.5)] dark:bg-secondaryColor/90 h-[10px] rounded-[5px] border border-solid border-transparent;\n}\n.range::-webkit-slider-thumb {\n  @apply appearance-none rounded-full bg-primaryColor dark:bg-white h-[18px] w-[18px] -mt-[5px];\n}\n.range::-moz-range-thumb {\n  @apply rounded-[20px] h-[18px] w-[18px] border-none bg-primaryColor;\n}\n.range:active::-webkit-slider-thumb {\n  @apply outline-none;\n}\n.range:active::-moz-range-thumb {\n  @apply outline-none;\n}\n\n.showParticipantsPanel .active-speakers-wrap {\n  @apply z-[2];\n}\n\n.showChatPanel .active-speakers-wrap {\n  @apply z-[2];\n}\n.showChatPanel .screen-share-video button {\n  @apply right-[320px];\n}\n\n.breakout-room-list-item .timer {\n  border-color: #fff;\n  color: #fff;\n  border-radius: 8px;\n  margin-left: 5px;\n}\n\n.react-js-player-wrap .video-js {\n  padding-top: 0 !important;\n}\n.react-js-player-wrap .video-js button.vjs-big-play-button {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.excalidraw.excalidraw-modal-container {\n  z-index: 99999 !important;\n}\n\n.landscape-device.is-mobile #main-area.fullWidthMainArea .share-screen-wrapper {\n  @apply h-full;\n}\n.landscape-device.is-mobile #main-area.fullWidthMainArea .middle-fullscreen-wrapper .notepad-wrapper {\n  @apply h-[94%] top-[3%] relative mt-0;\n}\n.landscape-device.is-mobile #main-area.fullWidthMainArea .middle-fullscreen-wrapper .externalMediaPlayerWrapper {\n  @apply h-full;\n}\n.landscape-device.is-mobile #main-area.fullWidthMainArea .middle-fullscreen-wrapper .externalMediaPlayerWrapper .media-player-inner div {\n  margin: auto;\n}\n.landscape-device.is-mobile #main-area.fullWidthMainArea .middle-fullscreen-wrapper .externalMediaPlayerWrapper .media-player-inner div div {\n  @apply pb-0;\n}\n.landscape-device.is-mobile #main-area.fullWidthMainArea .middle-fullscreen-wrapper .external-display-link-wrapper {\n  @apply h-full m-0 p-2;\n}\n.landscape-device.is-mobile #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper.vertical-webcams.total-cam-1 {\n  @apply p-0;\n}\n.landscape-device.is-mobile #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper.vertical-webcams.total-cam-1 .all-webcam-wrapper-inner {\n  display: flex !important;\n  @apply flex-wrap items-center;\n}\n.landscape-device.is-mobile #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper.vertical-webcams.total-cam-1 .all-webcam-wrapper-inner .video-camera-item {\n  @apply h-[45%];\n}\n.landscape-device.is-mobile #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper.vertical-webcams.total-cam-2 {\n  @apply p-0;\n}\n.landscape-device.is-mobile #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper.vertical-webcams.total-cam-2 .all-webcam-wrapper-inner {\n  display: flex !important;\n  @apply flex-wrap items-center;\n}\n.landscape-device.is-mobile #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper.vertical-webcams.total-cam-2 .all-webcam-wrapper-inner .video-camera-item {\n  @apply h-[45%];\n}\n.landscape-device.is-mobile #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper.vertical-webcams.total-cam-3 {\n  @apply p-0;\n}\n.landscape-device.is-mobile #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper.vertical-webcams.total-cam-3 .all-webcam-wrapper-inner {\n  display: flex !important;\n  @apply flex-wrap items-center;\n}\n.landscape-device.is-mobile #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper.vertical-webcams.total-cam-3 .all-webcam-wrapper-inner .video-camera-item {\n  @apply h-[30%];\n}\n.landscape-device.is-mobile #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper.vertical-webcams .all-webcam-wrapper-inner .video-camera-item {\n  @apply w-full;\n}\n.landscape-device.is-mobile #main-area.fullWidthMainArea .middle-fullscreen-wrapper.verticalsWebcamsActivated .screen-share-video button {\n  @apply bottom-[55px];\n}\n\n.portrait-device.is-mobile #main-area.fullWidthMainArea .verticalsWebcamsActivated .excalidraw-wrapper {\n  @apply h-[calc(100%-110px)] m-0 p-2;\n}\n.portrait-device.is-mobile #main-area.fullWidthMainArea .verticalsWebcamsActivated .notepad-wrapper {\n  @apply h-[calc(100%-110px)] m-0 p-2;\n}\n.portrait-device.is-mobile #main-area.fullWidthMainArea .verticalsWebcamsActivated .Div-external-media-player {\n  @apply h-[calc(100%-110px)] m-0 p-2;\n}\n.portrait-device.is-mobile #main-area.fullWidthMainArea .verticalsWebcamsActivated .Div-external-media-player .externalMediaPlayerWrapper {\n  @apply p-0;\n}\n.portrait-device.is-mobile #main-area.fullWidthMainArea .verticalsWebcamsActivated .external-display-link-wrapper {\n  @apply h-[calc(100%-110px)] m-0 p-2;\n}\n.portrait-device.is-mobile #main-area.fullWidthMainArea .verticalsWebcamsActivated .screen-share-video {\n  @apply h-[calc(100%-110px)];\n}\n.portrait-device.is-mobile .middle-fullscreen-wrapper .screen-share-video {\n  @apply h-full m-0 p-2;\n}\n.portrait-device.is-mobile .middle-fullscreen-wrapper .external-display-link-wrapper {\n  @apply h-full m-0 p-2;\n}\n.portrait-device.is-mobile .middle-fullscreen-wrapper .notepad-wrapper {\n  @apply h-full m-0 p-2;\n}\n.portrait-device.is-mobile .middle-fullscreen-wrapper .excalidraw-wrapper {\n  @apply h-full m-0 p-2;\n}\n.portrait-device.is-mobile .media-player-inner > div {\n  width: 100% !important;\n}\n\naside {\n  box-shadow: 0 2px 5px rgba(239, 239, 239, 0.8588235294) !important;\n  width: 100% !important;\n}\n\n.landscape-device.is-tablet #main-area.fullWidthMainArea .middle-fullscreen-wrapper.verticalsWebcamsActivated .all-webcam-wrapper {\n  height: 100%;\n}\n.landscape-device.is-tablet .camera-row-1.total-items-5.inner-items-2 .video-camera-item {\n  @apply w-1/2;\n}\n.landscape-device.is-tablet .camera-row-2.total-items-5.inner-items-1 .video-camera-item {\n  @apply w-1/2;\n}\n.landscape-device.is-tablet .camera-row-1.total-items-7.inner-items-3 .video-camera-item {\n  @apply w-1/3;\n}\n.landscape-device.is-tablet .camera-row-2.total-items-7.inner-items-1 .video-camera-item {\n  @apply w-1/3;\n}\n.landscape-device.is-tablet .camera-row-2.total-items-8.inner-items-2 .video-camera-item {\n  @apply w-1/3;\n}\n\n.portrait-device.is-tablet .camera-row-0.total-items-2 {\n  @apply flex-wrap;\n}\n.portrait-device.is-tablet .camera-row-0.total-items-2 .video-camera-item {\n  @apply w-full h-1/2;\n}\n.portrait-device.is-tablet .camera-row-0.total-items-3 {\n  @apply flex-wrap;\n}\n.portrait-device.is-tablet .camera-row-0.total-items-3 .video-camera-item {\n  @apply w-full h-1/3;\n}\n.portrait-device.is-tablet #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper {\n  @apply absolute h-auto w-full z-[9] p-0 -bottom-[5px];\n}\n.portrait-device.is-tablet #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper .all-webcam-wrapper-inner {\n  @apply m-0 py-0 px-[15px] flex-wrap gap-0;\n}\n.portrait-device.is-tablet #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper .all-webcam-wrapper-inner .video-camera-item {\n  @apply w-full m-[5px] h-[100px] pb-0 max-w-[135px];\n}\n.portrait-device.is-tablet #main-area.fullWidthMainArea .middle-fullscreen-wrapper.verticalsWebcamsActivated {\n  @apply pl-0;\n}\n.portrait-device.is-tablet #main-area.fullWidthMainArea .middle-fullscreen-wrapper.verticalsWebcamsActivated .screen-share-video {\n  @apply h-[calc(100%-105px)];\n}\n.portrait-device.is-tablet #main-area.fullWidthMainArea .middle-fullscreen-wrapper.verticalsWebcamsActivated .screen-share-video button {\n  @apply absolute bottom-0;\n}\n.portrait-device.is-tablet #main-area.fullWidthMainArea .middle-fullscreen-wrapper.verticalsWebcamsActivated .excalidraw-wrapper {\n  @apply h-[calc(100%-135px)];\n}\n.portrait-device.is-tablet #main-area.fullWidthMainArea .middle-fullscreen-wrapper.verticalsWebcamsActivated .notepad-wrapper {\n  @apply h-[calc(100%-150px)];\n}\n.portrait-device.is-tablet #main-area.fullWidthMainArea .middle-fullscreen-wrapper.verticalsWebcamsActivated .Div-external-media-player {\n  @apply h-[calc(100%-105px)];\n}\n.portrait-device.is-tablet #main-area.fullWidthMainArea .middle-fullscreen-wrapper.verticalsWebcamsActivated .external-display-link-wrapper {\n  @apply h-[calc(100%-145px)];\n}\n.portrait-device.is-tablet #main-area.fullWidthMainArea .all-webcam-wrapper.vertical-webcams .all-webcam-wrapper-inner {\n  display: flex !important;\n  @apply justify-center;\n}\n.portrait-device.is-tablet #main-area.fullWidthMainArea .all-webcam-wrapper.vertical-webcams .all-webcam-wrapper-inner button.next-cam {\n  @apply -right-[42px] w-[100px] left-auto h-5 top-[45px] -rotate-90;\n}\n.portrait-device.is-tablet #main-area.fullWidthMainArea .all-webcam-wrapper.vertical-webcams .all-webcam-wrapper-inner button.previous-cam {\n  @apply right-auto w-[100px] -left-[42px] h-5 top-[45px] -rotate-90 pt-0;\n}\n.portrait-device.is-tablet .excalidraw-wrapper {\n  @apply mt-4;\n}\n\n.message-form textarea#message-textarea {\n  color: #004d90;\n}\n.message-form textarea#message-textarea::placeholder {\n  color: rgba(0, 77, 144, 0.6666666667);\n}\n\n.dark .message-form textarea#message-textarea,\n.dark .message-form textarea#message-textarea::placeholder {\n  color: #fff;\n}\n\n.is-mobile .footer-collapse-arrow,\n.is-mobile .header-collapse-arrow {\n  display: none;\n}\n\n.portrait-device.is-tablet .footer-collapse-arrow,\n.portrait-device.is-tablet .header-collapse-arrow {\n  display: none;\n}\n\n.footer-collapse-arrow span::before,\n.header-collapse-arrow span::before {\n  content: \"\";\n  bottom: -6px;\n  @apply absolute w-[10px] h-[10px] bg-white dark:bg-darkPrimary right-5 rotate-45;\n}\n\n.header-collapse-arrow span::before {\n  bottom: auto;\n  top: -5px;\n}\n\n.notepad-wrapper .inner {\n  resize: both;\n  overflow: auto;\n}\n\n.waiting-room-logo {\n  height: 90px;\n  display: flex;\n}\n.waiting-room-logo .waiting-room-logo-img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  cursor: unset;\n}\n\n.header-logo {\n  height: 45px;\n  display: flex;\n}\n.header-logo .header-logo-img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  object-position: left;\n  cursor: unset;\n}\n\nhtml[dir=rtl] .header-logo .header-logo-img {\n  object-position: right;\n}\n\nhtml[dir=rtl] .rtl\\:microphone-rtl-left::before {\n  left: 26px;\n  margin-left: 0;\n}\n\n.show-speech-setting .rtl\\:tooltip-right::before {\n  left: 26px;\n  right: auto;\n}\n\n#main-health-monitor-panel {\n  position: fixed;\n  left: 0px;\n  width: 100%;\n  z-index: 99999;\n  height: 100vh;\n  top: 0px;\n  background-color: rgba(0, 0, 0, 0.3);\n}\n#main-health-monitor-panel.monitor-panel.close {\n  display: none;\n}\n#main-health-monitor-panel.monitor-panel.open {\n  display: block;\n}\n#main-health-monitor-panel .wrapper-health-monitor {\n  background-color: white;\n  border-radius: 8px;\n  padding: 50px;\n  min-height: calc(100% - 50px);\n  margin-top: 25px;\n  width: calc(100% - 50px);\n  margin-left: 25px;\n  position: relative;\n}\n#main-health-monitor-panel .wrapper-health-monitor .monitor-header {\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  width: 100%;\n  padding: 50px;\n}\n#main-health-monitor-panel .wrapper-health-monitor .monitor-header .monitor-patient.name {\n  font-size: 30px;\n  font-weight: bold;\n}\n#main-health-monitor-panel .wrapper-health-monitor .monitor-header .monitor-patient.close-modal {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n  border-radius: 100%;\n  border: 1px solid black;\n  padding: 10px;\n  width: 45px;\n  height: 45px;\n  text-align: center;\n}\n#main-health-monitor-panel .wrapper-health-monitor .monitor-content {\n  margin-top: 80px;\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  grid-column-gap: 10px;\n  grid-row-gap: 10px;\n}\n#main-health-monitor-panel .wrapper-health-monitor .monitor-content .monitor-alert {\n  background-color: green;\n  width: 100%;\n  border-radius: 8px;\n  color: white;\n  padding: 20px;\n}\n#main-health-monitor-panel .wrapper-health-monitor .monitor-content .monitor-alert.alert {\n  background-color: red;\n}\n#main-health-monitor-panel .wrapper-health-monitor .monitor-content .monitor-alert .title {\n  text-align: right;\n}\n#main-health-monitor-panel .wrapper-health-monitor .monitor-content .monitor-alert .content {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 10px;\n}\n#main-health-monitor-panel .wrapper-health-monitor .monitor-content .monitor-alert .content .monitor-value {\n  font-weight: 900;\n  font-size: 25px;\n}\n#main-health-monitor-panel .wrapper-health-monitor .monitor-chart {\n  margin-top: 20px;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-column-gap: 10px;\n  grid-row-gap: 10px;\n  max-height: calc(100vh - 350px);\n  overflow-y: scroll;\n  overflow-x: hidden;\n}\n#main-health-monitor-panel .wrapper-health-monitor .monitor-chart::-webkit-scrollbar-track {\n  display: none;\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  background-color: #F5F5F5;\n}\n#main-health-monitor-panel .wrapper-health-monitor .monitor-chart::-webkit-scrollbar {\n  display: none;\n  width: 6px;\n  background-color: #F5F5F5;\n}\n#main-health-monitor-panel .wrapper-health-monitor .monitor-chart::-webkit-scrollbar-thumb {\n  display: none;\n  background-color: #000000;\n}\n#main-health-monitor-panel .wrapper-health-monitor .monitor-chart .monitor-chart-wrapper {\n  width: 100%;\n}\n\n.monitor-icon {\n  width: 20px;\n  position: relative;\n}\n\n@keyframes refresh {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0.5;\n  }\n}\n@-webkit-keyframes wobble {\n  0% {\n    -webkit-transform: none;\n    transform: none;\n  }\n  15% {\n    -webkit-transform: translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg);\n    transform: translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg);\n  }\n  30% {\n    -webkit-transform: translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg);\n    transform: translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg);\n  }\n  45% {\n    -webkit-transform: translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg);\n    transform: translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg);\n  }\n  60% {\n    -webkit-transform: translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg);\n    transform: translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg);\n  }\n  75% {\n    -webkit-transform: translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg);\n    transform: translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg);\n  }\n  100% {\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n@keyframes wobble {\n  0% {\n    -webkit-transform: none;\n    transform: none;\n  }\n  15% {\n    -webkit-transform: translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg);\n    transform: translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg);\n  }\n  30% {\n    -webkit-transform: translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg);\n    transform: translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg);\n  }\n  45% {\n    -webkit-transform: translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg);\n    transform: translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg);\n  }\n  60% {\n    -webkit-transform: translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg);\n    transform: translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg);\n  }\n  75% {\n    -webkit-transform: translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg);\n    transform: translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg);\n  }\n  100% {\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n@keyframes pulse {\n  0% {\n    box-shadow: 0 0 5px 0 rgba(0, 77, 144, 0.3);\n  }\n  65% {\n    box-shadow: 0 0 5px 13px rgb(242, 242, 242);\n  }\n  90% {\n    box-shadow: 0 0 5px 13px rgb(242, 242, 242);\n  }\n}\n@keyframes lds-ripple2 {\n  0% {\n    top: 16px;\n    left: 16px;\n    width: 0;\n    height: 0;\n    opacity: 1;\n  }\n  100% {\n    top: 0;\n    left: 0;\n    width: 30px;\n    height: 30px;\n    opacity: 0;\n  }\n}\n.shake {\n  -webkit-animation-name: wobble;\n  animation-name: wobble;\n  -webkit-animation-duration: 0.8s;\n  -webkit-animation-iteration-count: infinite;\n  -webkit-animation-timing-function: linear;\n  -webkit-transform-origin: 50% 100%;\n  display: inline-block;\n}\n\n.hiddenAnimation {\n  animation: refresh 0.5s infinite;\n}\n\n.dark .main-app-bg::before {\n  @apply absolute content-[\"\"] w-full h-full bg-[#001222] opacity-70;\n}\n.dark .waiting-room::before {\n  @apply absolute content-[\"\"] w-full h-full bg-[#001222] opacity-70;\n}\n.dark .error-app-bg::before {\n  @apply absolute content-[\"\"] w-full h-full bg-[#001222] opacity-70;\n}\n.dark .multi-gradient {\n  background: #031a3e;\n}\n.dark #main-area.fullWidthMainArea .all-webcam-wrapper {\n  background: #031a3e;\n}\n.dark .message-form {\n  background: transparent;\n}\n.dark .Toastify__toast {\n  background: #222;\n  color: #fff;\n}\n.dark button.Toastify__close-button svg path {\n  fill: #fff;\n}\n.dark .wb-page-navigation button:disabled {\n  background-color: var(--button-gray-1) !important;\n}\n.dark .header-before-start {\n  opacity: 0.4;\n}\n.dark .header-before-end {\n  opacity: 0.1;\n}\n.dark .select-camera-number {\n  color: #a7cced;\n}\n.dark .select-camera-number select#select-camera-num {\n  border-color: #a7cced;\n}\n\n.plugNmeet-app #main-area.isRecorder .all-webcam-wrapper {\n  @apply h-screen;\n}\n.plugNmeet-app #main-area.fullWidthMainArea.isRecorder .middle-fullscreen-wrapper.verticalsWebcamsActivated {\n  @apply pl-[440px];\n}\n.plugNmeet-app .isRecorder .transition-right-panel {\n  @apply relative;\n}\n.plugNmeet-app .isRecorder.showScreenShare .middle-area {\n  @apply flex items-center justify-center;\n}\n\n@media screen and (max-width: 1800px) {\n  .plugNmeet-app #main-area.fullWidthMainArea.isRecorder .middle-fullscreen-wrapper.verticalsWebcamsActivated {\n    @apply pl-[270px];\n  }\n}\n@media screen and (max-width: 1280px) {\n  .plugNmeet-app #main-area.fullWidthMainArea.isRecorder .middle-fullscreen-wrapper.verticalsWebcamsActivated {\n    @apply pl-[200px];\n  }\n}\n@media screen and (max-width: 1023px) {\n  .plugNmeet-app #main-area.fullWidthMainArea.isRecorder .middle-fullscreen-wrapper.verticalsWebcamsActivated {\n    @apply pl-0;\n  }\n}\n@media (min-width: 1024px) {\n  .all-webcam-wrapper-inner {\n    @apply p-6;\n  }\n  #main-area.column-camera-position-top.fullWidthMainArea .verticalsWebcamsActivated .all-webcam-wrapper,\n  #main-area.column-camera-position-bottom.fullWidthMainArea .verticalsWebcamsActivated .all-webcam-wrapper {\n    @apply w-full top-0 h-[130px] py-[5px] px-[15px];\n  }\n  #main-area.column-camera-position-top.column-camera-width-medium.fullWidthMainArea .verticalsWebcamsActivated .all-webcam-wrapper,\n  #main-area.column-camera-position-bottom.column-camera-width-medium.fullWidthMainArea .verticalsWebcamsActivated .all-webcam-wrapper {\n    @apply h-[120px];\n  }\n  #main-area.column-camera-position-top.column-camera-width-small.fullWidthMainArea .verticalsWebcamsActivated .all-webcam-wrapper,\n  #main-area.column-camera-position-bottom.column-camera-width-small.fullWidthMainArea .verticalsWebcamsActivated .all-webcam-wrapper {\n    @apply h-[110px];\n  }\n  #main-area.column-camera-position-top.fullWidthMainArea .verticalsWebcamsActivated .all-webcam-wrapper .video-camera-item,\n  #main-area.column-camera-position-bottom.fullWidthMainArea .verticalsWebcamsActivated .all-webcam-wrapper .video-camera-item {\n    @apply inline-block h-full m-0;\n  }\n  #main-area.column-camera-position-top.fullWidthMainArea .verticalsWebcamsActivated .all-webcam-wrapper .all-webcam-wrapper-inner,\n  #main-area.column-camera-position-bottom.fullWidthMainArea .verticalsWebcamsActivated .all-webcam-wrapper .all-webcam-wrapper-inner {\n    @apply flex items-center justify-center;\n  }\n  #main-area.column-camera-position-top.fullWidthMainArea .verticalsWebcamsActivated .all-webcam-wrapper .all-webcam-wrapper-inner .video-camera-item,\n  #main-area.column-camera-position-bottom.fullWidthMainArea .verticalsWebcamsActivated .all-webcam-wrapper .all-webcam-wrapper-inner .video-camera-item {\n    @apply w-[12.5%];\n  }\n  #main-area.column-camera-position-top.fullWidthMainArea .verticalsWebcamsActivated,\n  #main-area.column-camera-position-bottom.fullWidthMainArea .verticalsWebcamsActivated {\n    padding: 0 !important;\n  }\n  #main-area.column-camera-position-top.fullWidthMainArea .verticalsWebcamsActivated .all-webcam-wrapper .all-webcam-wrapper-inner button.next-cam,\n  #main-area.column-camera-position-bottom.fullWidthMainArea .verticalsWebcamsActivated .all-webcam-wrapper .all-webcam-wrapper-inner button.next-cam {\n    @apply h-full w-5 right-0 left-auto rounded-none;\n  }\n  #main-area.column-camera-position-top.fullWidthMainArea .verticalsWebcamsActivated .all-webcam-wrapper .all-webcam-wrapper-inner button.next-cam i,\n  #main-area.column-camera-position-bottom.fullWidthMainArea .verticalsWebcamsActivated .all-webcam-wrapper .all-webcam-wrapper-inner button.next-cam i {\n    @apply inline-block -rotate-90;\n  }\n  #main-area.column-camera-position-top.fullWidthMainArea .verticalsWebcamsActivated .all-webcam-wrapper .all-webcam-wrapper-inner button.previous-cam,\n  #main-area.column-camera-position-bottom.fullWidthMainArea .verticalsWebcamsActivated .all-webcam-wrapper .all-webcam-wrapper-inner button.previous-cam {\n    @apply w-5 h-full p-0 rounded-none;\n  }\n  #main-area.column-camera-position-top.fullWidthMainArea .verticalsWebcamsActivated .all-webcam-wrapper .all-webcam-wrapper-inner button.previous-cam i,\n  #main-area.column-camera-position-bottom.fullWidthMainArea .verticalsWebcamsActivated .all-webcam-wrapper .all-webcam-wrapper-inner button.previous-cam i {\n    @apply inline-block -rotate-90;\n  }\n  #main-area.column-camera-position-top.fullWidthMainArea .verticalsWebcamsActivated .all-webcam-wrapper {\n    @apply bottom-0;\n  }\n  #main-area.column-camera-position-bottom.fullWidthMainArea .verticalsWebcamsActivated .all-webcam-wrapper {\n    @apply bottom-0 top-auto;\n  }\n  #main-area.column-camera-position-left.column-camera-width-medium.fullWidthMainArea .middle-fullscreen-wrapper.verticalsWebcamsActivated {\n    @apply pl-[250px];\n  }\n  #main-area.column-camera-position-left.column-camera-width-small.fullWidthMainArea .middle-fullscreen-wrapper.verticalsWebcamsActivated {\n    @apply pl-[230px];\n  }\n  #main-area.column-camera-position-left.column-camera-width-medium.fullWidthMainArea .middle-fullscreen-wrapper.verticalsWebcamsActivated .all-webcam-wrapper {\n    @apply w-[240px];\n  }\n  #main-area.column-camera-position-left.column-camera-width-small.fullWidthMainArea .middle-fullscreen-wrapper.verticalsWebcamsActivated .all-webcam-wrapper {\n    @apply w-[220px];\n  }\n  #main-area.column-camera-width-medium.fullWidthMainArea #main-left-panel {\n    @apply w-[240px];\n  }\n  #main-area.column-camera-width-small.fullWidthMainArea #main-left-panel {\n    @apply w-[220px];\n  }\n  #main-area.column-camera-position-top.fullWidthMainArea .verticalsWebcamsActivated .excalidraw-wrapper {\n    margin-top: 140px;\n    height: calc(100% - 150px);\n  }\n  #main-area.column-camera-position-top.column-camera-width-medium.fullWidthMainArea .verticalsWebcamsActivated .excalidraw-wrapper {\n    margin-top: 130px;\n    height: calc(100% - 140px);\n  }\n  #main-area.column-camera-position-top.column-camera-width-small.fullWidthMainArea .verticalsWebcamsActivated .excalidraw-wrapper {\n    margin-top: 120px;\n    height: calc(100% - 130px);\n  }\n  #main-area.column-camera-position-bottom.fullWidthMainArea .verticalsWebcamsActivated .excalidraw-wrapper {\n    margin-top: 2.25rem;\n    height: calc(100% - 175px);\n  }\n  #main-area.column-camera-position-bottom.column-camera-width-medium.fullWidthMainArea .verticalsWebcamsActivated .excalidraw-wrapper {\n    margin-top: 2.25rem;\n    height: calc(100% - 165px);\n  }\n  #main-area.column-camera-position-bottom.column-camera-width-small.fullWidthMainArea .verticalsWebcamsActivated .excalidraw-wrapper {\n    margin-top: 2.25rem;\n    height: calc(100% - 155px);\n  }\n  #main-area.column-camera-position-top.fullWidthMainArea .verticalsWebcamsActivated .screen-share-video {\n    margin-top: 130px;\n    height: calc(100% - 130px);\n  }\n  #main-area.column-camera-position-top.column-camera-width-medium.fullWidthMainArea .verticalsWebcamsActivated .screen-share-video {\n    margin-top: 120px;\n    height: calc(100% - 120px);\n  }\n  #main-area.column-camera-position-top.column-camera-width-small.fullWidthMainArea .verticalsWebcamsActivated .screen-share-video {\n    margin-top: 110px;\n    height: calc(100% - 110px);\n  }\n  #main-area.column-camera-position-bottom.fullWidthMainArea .verticalsWebcamsActivated .screen-share-video {\n    height: calc(100% - 130px);\n  }\n  #main-area.column-camera-position-bottom.column-camera-width-medium.fullWidthMainArea .verticalsWebcamsActivated .screen-share-video {\n    height: calc(100% - 120px);\n  }\n  #main-area.column-camera-position-bottom.column-camera-width-small.fullWidthMainArea .verticalsWebcamsActivated .screen-share-video {\n    height: calc(100% - 110px);\n  }\n  #main-area.column-camera-position-top.fullWidthMainArea .verticalsWebcamsActivated .notepad-wrapper {\n    margin-top: 140px;\n    height: calc(100% - 150px);\n  }\n  #main-area.column-camera-position-top.column-camera-width-medium.fullWidthMainArea .verticalsWebcamsActivated .notepad-wrapper {\n    margin-top: 130px;\n    height: calc(100% - 140px);\n  }\n  #main-area.column-camera-position-top.column-camera-width-small.fullWidthMainArea .verticalsWebcamsActivated .notepad-wrapper {\n    margin-top: 120px;\n    height: calc(100% - 130px);\n  }\n  #main-area.column-camera-position-bottom.fullWidthMainArea .verticalsWebcamsActivated .notepad-wrapper {\n    height: calc(100% - 175px);\n  }\n  #main-area.column-camera-position-bottom.column-camera-width-medium.fullWidthMainArea .verticalsWebcamsActivated .notepad-wrapper {\n    height: calc(100% - 165px);\n  }\n  #main-area.column-camera-position-bottom.column-camera-width-small.fullWidthMainArea .verticalsWebcamsActivated .notepad-wrapper {\n    height: calc(100% - 155px);\n  }\n  #main-area.column-camera-position-top.fullWidthMainArea .verticalsWebcamsActivated .Div-external-media-player {\n    margin-top: 130px;\n    height: calc(100% - 130px);\n  }\n  #main-area.column-camera-position-top.column-camera-width-medium.fullWidthMainArea .verticalsWebcamsActivated .Div-external-media-player {\n    margin-top: 120px;\n    height: calc(100% - 120px);\n  }\n  #main-area.column-camera-position-top.column-camera-width-small.fullWidthMainArea .verticalsWebcamsActivated .Div-external-media-player {\n    margin-top: 110px;\n    height: calc(100% - 110px);\n  }\n  #main-area.column-camera-position-bottom.fullWidthMainArea .verticalsWebcamsActivated .Div-external-media-player {\n    height: calc(100% - 130px);\n  }\n  #main-area.column-camera-position-bottom.column-camera-width-medium.fullWidthMainArea .verticalsWebcamsActivated .Div-external-media-player {\n    height: calc(100% - 120px);\n  }\n  #main-area.column-camera-position-bottom.column-camera-width-small.fullWidthMainArea .verticalsWebcamsActivated .Div-external-media-player {\n    height: calc(100% - 110px);\n  }\n  #main-area.column-camera-position-top.fullWidthMainArea .verticalsWebcamsActivated .external-display-link-wrapper {\n    margin-top: 140px;\n    height: calc(100% - 150px);\n  }\n  #main-area.column-camera-position-top.column-camera-width-medium.fullWidthMainArea .verticalsWebcamsActivated .external-display-link-wrapper {\n    margin-top: 130px;\n    height: calc(100% - 140px);\n  }\n  #main-area.column-camera-position-top.column-camera-width-small.fullWidthMainArea .verticalsWebcamsActivated .external-display-link-wrapper {\n    margin-top: 120px;\n    height: calc(100% - 130px);\n  }\n  #main-area.column-camera-position-bottom.fullWidthMainArea .verticalsWebcamsActivated .external-display-link-wrapper {\n    height: calc(100% - 175px);\n  }\n  #main-area.column-camera-position-bottom.column-camera-width-medium.fullWidthMainArea .verticalsWebcamsActivated .external-display-link-wrapper {\n    height: calc(100% - 165px);\n  }\n  #main-area.column-camera-position-bottom.column-camera-width-small.fullWidthMainArea .verticalsWebcamsActivated .external-display-link-wrapper {\n    height: calc(100% - 155px);\n  }\n  #main-area.fullWidthMainArea.column-camera-position-left.column-camera-width-full .active-speakers-wrap {\n    @apply w-[calc(100%-300px)] left-auto right-[30px];\n  }\n  #main-area.fullWidthMainArea.column-camera-position-left.column-camera-width-medium .active-speakers-wrap {\n    @apply w-[calc(100%-280px)] left-auto right-[30px];\n  }\n  #main-area.fullWidthMainArea.column-camera-position-left.column-camera-width-small .active-speakers-wrap {\n    @apply w-[calc(100%-260px)] left-auto right-[30px];\n  }\n  .column-camera-position-top .active-speakers-wrap,\n  .column-camera-position-bottom .active-speakers-wrap {\n    max-width: calc(100% - 30px);\n    margin: auto;\n    right: 0;\n  }\n  .column-camera-width-medium .all-webcam-wrapper.total-cam-1 .all-webcam-wrapper-inner,\n  .column-camera-width-medium .all-webcam-wrapper.total-cam-2 .all-webcam-wrapper-inner,\n  .column-camera-width-medium .all-webcam-wrapper.total-cam-3 .all-webcam-wrapper-inner,\n  .column-camera-width-medium .all-webcam-wrapper.total-cam-4 .all-webcam-wrapper-inner,\n  .column-camera-width-medium .all-webcam-wrapper.total-cam-5 .all-webcam-wrapper-inner,\n  .column-camera-width-medium .all-webcam-wrapper.total-cam-6 .all-webcam-wrapper-inner {\n    width: 80%;\n    margin: auto;\n    height: 90%;\n  }\n  .column-camera-width-small .all-webcam-wrapper.total-cam-1 .all-webcam-wrapper-inner,\n  .column-camera-width-small .all-webcam-wrapper.total-cam-2 .all-webcam-wrapper-inner,\n  .column-camera-width-small .all-webcam-wrapper.total-cam-3 .all-webcam-wrapper-inner {\n    width: 60%;\n    margin: auto;\n    height: 70%;\n  }\n  .column-camera-width-small .all-webcam-wrapper.total-cam-4 .all-webcam-wrapper-inner,\n  .column-camera-width-small .all-webcam-wrapper.total-cam-5 .all-webcam-wrapper-inner,\n  .column-camera-width-small .all-webcam-wrapper.total-cam-6 .all-webcam-wrapper-inner {\n    width: 70%;\n    margin: auto;\n    height: 80%;\n  }\n}\n@media only screen and (max-width: 980px) and (max-height: 450px) {\n  .landscape-device #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper {\n    @apply bottom-auto right-auto w-[140px] left-0 h-full py-5 px-0;\n  }\n  .landscape-device #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper .all-webcam-wrapper-inner {\n    display: block !important;\n    @apply py-0 px-[5px];\n  }\n  .landscape-device #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper .all-webcam-wrapper-inner .video-camera-item {\n    @apply h-[31.33%] my-1 mx-0;\n  }\n  .landscape-device #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper .all-webcam-wrapper-inner button.next-cam {\n    @apply top-auto bottom-0 rotate-0 left-0 w-full;\n  }\n  .landscape-device #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper .all-webcam-wrapper-inner button.previous-cam {\n    @apply top-0 rotate-0 left-0 w-full;\n  }\n  .landscape-device .share-screen-wrapper.is-share-screen-running .screen-share-video button {\n    @apply bottom-[55px];\n  }\n}\n@media only screen and (max-height: 720px) {\n  .externalMediaPlayerWrapper {\n    @apply max-w-[900px];\n  }\n}\n@media screen and (max-width: 1279px) {\n  .all-MessageModule-wrap .message-item .system p.message-content {\n    @apply text-sm leading-[16px];\n  }\n  .showChatPanel .screen-share-video button {\n    @apply right-[250px];\n  }\n}\n@media screen and (max-width: 1023px) {\n  .transition-left-panel {\n    @apply absolute h-full z-[9999];\n  }\n  .transition-right-panel {\n    position: absolute;\n    height: 100%;\n    right: 0;\n    z-index: 9999;\n  }\n  .transition-right-panel #main-right-panel .message-form {\n    position: absolute;\n  }\n  .transition-right-panel #main-right-panel .messageModule-wrapper {\n    @apply h-[calc(100%-72px)];\n  }\n  #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper {\n    @apply absolute h-auto w-full z-[9] p-0 bottom-0 pt-0;\n  }\n  #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper .all-webcam-wrapper-inner {\n    @apply m-0 py-0 px-[15px] flex-wrap gap-0;\n  }\n  #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper .all-webcam-wrapper-inner .video-camera-item {\n    @apply w-full m-[5px] h-[100px] pb-0 max-w-[150px];\n  }\n  #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper .all-webcam-wrapper-inner .video-camera-item .connection-status {\n    @apply hidden;\n  }\n  #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper .all-webcam-wrapper-inner .video-camera-item .mic-status {\n    @apply hidden;\n  }\n  #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper .all-webcam-wrapper-inner .video-camera-item .name {\n    @apply text-xs left-[5px];\n  }\n  #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper .all-webcam-wrapper-inner .video-camera-item .camera-video-player button {\n    @apply right-0 top-0;\n  }\n  #main-area.fullWidthMainArea .middle-fullscreen-wrapper .all-webcam-wrapper .all-webcam-wrapper-inner .video-camera-item .status.PinWebcam {\n    @apply left-0 top-0;\n  }\n  #main-area.fullWidthMainArea .all-webcam-wrapper.vertical-webcams .all-webcam-wrapper-inner {\n    display: flex !important;\n    @apply justify-center flex-nowrap;\n  }\n  #main-area.fullWidthMainArea .all-webcam-wrapper .all-webcam-wrapper-inner button.next-cam {\n    @apply -right-[42px] w-[100px] left-auto h-5 top-[45px] -rotate-90;\n  }\n  #main-area.fullWidthMainArea .all-webcam-wrapper .all-webcam-wrapper-inner button.previous-cam {\n    @apply right-auto w-[100px] -left-[42px] h-5 top-[45px] -rotate-90;\n  }\n  #main-area.fullWidthMainArea .middle-fullscreen-wrapper.verticalsWebcamsActivated {\n    @apply pl-0;\n  }\n  #main-area.fullWidthMainArea .middle-fullscreen-wrapper.verticalsWebcamsActivated .screen-share-video button {\n    @apply bottom-[165px];\n  }\n  .share-screen-wrapper.is-share-screen-running .screen-share-video button {\n    @apply fixed bottom-[55px];\n  }\n  .Toastify__toast-container .Toastify__toast-body {\n    @apply p-0;\n  }\n  .Toastify__toast-container .Toastify__toast {\n    @apply min-h-[40px] text-sm;\n  }\n  #main-area.hideParticipantsPanel.showScreenShare .active-speakers-wrap {\n    @apply p-0 flex-wrap;\n  }\n  #main-area.hideParticipantsPanel.showScreenShare .active-speakers-wrap div {\n    @apply text-[10px];\n  }\n  #main-area.hideParticipantsPanel.showScreenShare .active-speakers-wrap div i {\n    @apply text-[7px];\n  }\n  .pin-webcam {\n    @apply hidden;\n  }\n  #main-right-panel {\n    background: rgb(235, 248, 255);\n    background: linear-gradient(150deg, rgb(235, 248, 255) 0%, rgb(255, 255, 255) 10%, rgb(243, 237, 249) 67%, rgb(214, 231, 255) 100%);\n  }\n  .dark #main-right-panel {\n    background: #001222;\n  }\n  .plugNmeet-app {\n    @apply relative h-screen;\n  }\n  .plugNmeet-app header#main-header {\n    @apply fixed top-0 w-full;\n  }\n  .plugNmeet-app footer#main-footer {\n    @apply fixed w-full bottom-0 z-[99999];\n  }\n  .plugNmeet-app #main-area {\n    height: calc(100% - 105px) !important;\n    @apply fixed w-full top-[50px];\n  }\n  .plugNmeet-app #main-area.isRecorder {\n    height: 100% !important;\n    @apply top-0;\n  }\n  .landscape-device.is-mobile #main-area.fullWidthMainArea .middle-fullscreen-wrapper.verticalsWebcamsActivated {\n    @apply pl-[140px];\n  }\n  .private-m-tab {\n    @apply w-[calc(100vh-180px)];\n  }\n  .excalidraw-wrapper {\n    @apply mt-2 h-[calc(100%-20px)];\n  }\n  body #plugNmeet-app .excalidraw-wrapper .excalidraw button.scroll-back-to-content {\n    bottom: 35px !important;\n  }\n}\n@media screen and (max-width: 767px) {\n  .transition-right-panel {\n    @apply w-full;\n  }\n  .transition-right-panel .messageModule-wrapper {\n    @apply w-full;\n  }\n  .transition-right-panel .message-form {\n    @apply w-full;\n  }\n  .transition-left-panel {\n    @apply w-full;\n  }\n  .transition-left-panel #main-left-panel {\n    @apply w-full;\n  }\n  .is-mobile.portrait-device #main-area {\n    @apply h-[calc(100vh-180px)];\n  }\n  .message-form .btns {\n    @apply w-[50px] py-[5px] px-0 -mt-[6px];\n  }\n  .message-form .btns button {\n    @apply w-[50px] mb-[10px];\n  }\n  .message-form .btns button i {\n    @apply text-lg;\n  }\n  .private-m-tab::before {\n    @apply absolute content-[\"\"] h-1 w-full bg-[rgb(0,77,144,0.2)];\n  }\n}\n@media screen and (min-width: 641px) {\n  .preview-camera-webcam video {\n    @apply min-h-[240px];\n  }\n  .preview-camera-webcam canvas {\n    @apply min-h-[240px];\n  }\n}\n@media screen and (max-width: 640px) {\n  header#main-header {\n    @apply flex-wrap;\n  }\n  header#main-header .logo {\n    @apply w-1/2 order-1;\n  }\n  header#main-header .dark-area {\n    @apply w-1/2 order-1 h-5;\n  }\n  header#main-header .middle {\n    @apply w-full order-2 -mt-[10px];\n  }\n  header#main-header .middle h2 {\n    @apply text-sm break-all;\n  }\n  footer#main-footer .footer-icon {\n    @apply mr-[5px];\n  }\n  footer#main-footer .whiteboard {\n    @apply mr-[5px];\n  }\n  footer#main-footer .shared-notepad {\n    @apply mr-[5px];\n  }\n  .excalidraw-wrapper .excalidraw .Stack_horizontal {\n    display: flex !important;\n    flex-wrap: wrap;\n    justify-content: center !important;\n  }\n  .header-logo {\n    @apply h-[30px];\n  }\n  .all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-0.total-items-2 {\n    @apply flex-wrap;\n  }\n  .all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-0.total-items-2 .video-camera-item {\n    @apply w-full h-1/2;\n  }\n  .all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-0.total-items-3 {\n    @apply flex-wrap;\n  }\n  .all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-0.total-items-3 .video-camera-item {\n    @apply w-full h-1/3;\n  }\n  .all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-0.total-items-4.inner-items-2 {\n    @apply flex-nowrap;\n  }\n  .all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-0.total-items-4.inner-items-2 .video-camera-item {\n    @apply w-1/2 h-full;\n  }\n  .all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-0.total-items-5.inner-items-2 {\n    @apply flex-nowrap;\n  }\n  .all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-0.total-items-5.inner-items-2 .video-camera-item {\n    @apply w-1/2 h-full;\n  }\n  .all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-1.total-items-5.inner-items-2 .video-camera-item {\n    @apply w-1/2;\n  }\n  .all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-2.total-items-5.inner-items-1 .video-camera-item {\n    @apply w-1/2;\n  }\n  .all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-2.total-items-6.inner-items-1 .video-camera-item {\n    @apply w-1/2;\n  }\n  .all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-0.total-items-6.inner-items-2 {\n    @apply flex-nowrap;\n  }\n  .all-webcam-wrapper .all-webcam-wrapper-inner .camera-row-0.total-items-6.inner-items-2 .video-camera-item {\n    @apply w-1/2 h-full;\n  }\n}\n@media screen and (max-width: 575px) {\n  #main-area .share-screen-wrapper.is-share-screen-running .all-webcam-wrapper .all-webcam-wrapper-inner .video-camera-item {\n    @apply w-[calc(32.5%-10px)] max-w-full;\n  }\n}\n@media screen and (max-width: 370px) {\n  .video-camera-item .name {\n    @apply text-[10px];\n  }\n  header#main-header .middle h2 {\n    @apply text-xs;\n  }\n  .active-speakers-wrap div {\n    @apply text-[10px] py-0 px-[5px];\n  }\n  .active-speakers-wrap div i {\n    @apply text-[8px];\n  }\n}\n@media screen and (min-width: 1800px) {\n  #main-area.fullWidthMainArea .all-webcam-wrapper {\n    @apply w-[440px];\n  }\n  #main-area.fullWidthMainArea .middle-fullscreen-wrapper.verticalsWebcamsActivated {\n    @apply pl-[440px];\n  }\n  #main-area.fullWidthMainArea #main-left-panel {\n    @apply w-[440px];\n  }\n  #main-area.column-camera-position-left.column-camera-width-medium.fullWidthMainArea .middle-fullscreen-wrapper.verticalsWebcamsActivated {\n    @apply pl-[360px];\n  }\n  #main-area.column-camera-position-left.column-camera-width-small.fullWidthMainArea .middle-fullscreen-wrapper.verticalsWebcamsActivated {\n    @apply pl-[280px];\n  }\n  #main-area.column-camera-position-left.column-camera-width-medium.fullWidthMainArea .middle-fullscreen-wrapper.verticalsWebcamsActivated .all-webcam-wrapper {\n    @apply w-[360px];\n  }\n  #main-area.column-camera-position-left.column-camera-width-small.fullWidthMainArea .middle-fullscreen-wrapper.verticalsWebcamsActivated .all-webcam-wrapper {\n    @apply w-[280px];\n  }\n  #main-area.column-camera-width-medium.fullWidthMainArea #main-left-panel {\n    @apply w-[360px];\n  }\n  #main-area.column-camera-width-small.fullWidthMainArea #main-left-panel {\n    @apply w-[280px];\n  }\n  #main-area.fullWidthMainArea.column-camera-position-left.column-camera-width-full .active-speakers-wrap {\n    @apply w-[calc(100%-470px)] left-auto right-[30px];\n  }\n  #main-area.fullWidthMainArea.column-camera-position-left.column-camera-width-medium .active-speakers-wrap {\n    @apply w-[calc(100%-390px)] left-auto right-[30px];\n  }\n  #main-area.fullWidthMainArea.column-camera-position-left.column-camera-width-small .active-speakers-wrap {\n    @apply w-[calc(100%-310px)] left-auto right-[30px];\n  }\n  .column-camera-position-top .active-speakers-wrap,\n  .column-camera-position-bottom .active-speakers-wrap {\n    max-width: calc(100% - 30px);\n    margin: auto;\n    right: 0;\n  }\n}\n@media screen and (max-width: 1025px) {\n  button.previous-cam {\n    @apply w-[95px] h-[25px] -left-[43px];\n  }\n  button.next-cam {\n    @apply w-[95px] h-[25px] -right-[43px];\n  }\n  .footer-collapse-arrow,\n  .header-collapse-arrow {\n    display: none;\n  }\n}\n@media screen and (max-width: 1025px) and (min-width: 641px) {\n  .camera-row-1.total-items-5.inner-items-2 .video-camera-item {\n    width: 50% !important;\n  }\n  .camera-row-2.total-items-5.inner-items-1 .video-camera-item {\n    @apply w-1/2;\n  }\n  .camera-row-1.total-items-7.inner-items-3 .video-camera-item {\n    width: 50% !important;\n  }\n  .camera-row-2.total-items-7.inner-items-1 .video-camera-item {\n    @apply w-1/3;\n  }\n  .camera-row-2.total-items-8.inner-items-2 .video-camera-item {\n    @apply w-1/3;\n  }\n  .camera-row-2.total-items-9.inner-items-3 .video-camera-item {\n    @apply w-1/3;\n  }\n}","@tailwind base;\n","@tailwind components;\n","@tailwind utilities;\n","// Common SCSS\nbody {\n  margin: 0;\n  font-family: 'Nunito Sans', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-weight: 400;\n}\n\ncode {\n  font-family: 'Nunito Sans', sans-serif;\n}\n\n.primaryColor {\n  color: $primaryColor;\n}\n\n.secondaryColor {\n  color: $secondaryColor;\n}\n\n.bg-primaryColor {\n  background: $primaryColor;\n}\n\n.bg-secondaryColor {\n  background: $secondaryColor;\n}\n\n.border-primaryColor {\n  color: $primaryColor;\n}\n\n.border-secondaryColor {\n  color: $secondaryColor;\n}\n\n// Common SCSS\n\n// Gradient pattern\n.multi-gradient {\n  background: rgb(235, 248, 255);\n  background: linear-gradient(\n    150deg,\n    rgba(235, 248, 255, 1) 0%,\n    rgba(255, 255, 255, 1) 10%,\n    rgba(243, 237, 249, 1) 67%,\n    rgba(214, 231, 255, 1) 100%\n  );\n}\n\n// Gradient pattern\n\n// ScrollBar SCSS\n.scrollBar {\n  &::-webkit-scrollbar-thumb {\n    @apply bg-secondaryColor border-none rounded-[5px];\n  }\n\n  &::-webkit-scrollbar-track {\n    @apply bg-[rgba(0,0,0,0.15)];\n  }\n\n  &::-webkit-scrollbar {\n    @apply w-2;\n  }\n}\n\n.scrollBar2 {\n  &::-webkit-scrollbar {\n    @apply w-[2px];\n  }\n}\n\n.scrollBar4 {\n  &::-webkit-scrollbar {\n    @apply w-1;\n  }\n}\n\n.scrollBar3 {\n  &::-webkit-scrollbar {\n    @apply h-2 w-full;\n  }\n}\n\n// ScrollBar SCSS\n\n// Private Message Area\n.private-m-tab {\n  .inner2 {\n    &::-webkit-scrollbar-track {\n      @apply bg-[rgb(224,226,231)];\n    }\n\n    &::-webkit-scrollbar {\n      @apply h-[5px];\n    }\n\n    &::-webkit-scrollbar-thumb {\n      @apply bg-secondaryColor border-none rounded-[5px];\n    }\n  }\n}\n\n.message-item {\n  .system {\n    p.message-content {\n      @apply text-base leading-[20px];\n    }\n  }\n\n  p.message-content {\n    @apply p-[10px] text-sm break-words rounded-MSG;\n    span.download {\n      @apply relative;\n      i.pnm-download {\n        @apply text-base absolute -top-[2px] mr-[2px];\n      }\n\n      a {\n        @apply pl-5;\n      }\n    }\n  }\n\n  .content.me {\n    @apply w-full;\n    p.message-content {\n      @apply ml-auto rounded-MSGME;\n      i.pnm-download {\n        @apply -top-[1px];\n      }\n\n      a {\n        @apply underline;\n      }\n    }\n\n    .name {\n      @apply text-right;\n    }\n  }\n}\n\n// Private Message Area\n\n// Webcam Area SCSS\n.all-webcam-wrapper {\n  @apply h-full flex items-center;\n  &::-webkit-scrollbar {\n    @apply hidden;\n  }\n\n  .all-webcam-wrapper-inner {\n    @apply w-full h-full p-5 grid gap-2;\n    .camera-row-0 {\n      @apply flex gap-2 justify-center;\n    }\n\n    .camera-row-1 {\n      @apply flex gap-2 justify-center;\n    }\n\n    .camera-row-2 {\n      @apply flex gap-2 justify-center;\n    }\n\n    .camera-row-0.total-items-2 {\n      .video-camera-item {\n        @apply w-1/2;\n      }\n    }\n\n    .camera-row-1.total-items-2 {\n      .video-camera-item {\n        @apply w-1/2;\n      }\n    }\n\n    .camera-row-0.total-items-3 {\n      .video-camera-item {\n        @apply w-1/3;\n      }\n    }\n\n    .camera-row-1.total-items-3 {\n      .video-camera-item {\n        @apply w-1/3;\n      }\n    }\n\n    .camera-row-1.total-items-5.inner-items-2 {\n      .video-camera-item {\n        @apply w-1/3;\n      }\n    }\n\n    .camera-row-0.total-items-7.inner-items-4 {\n      .video-camera-item {\n        @apply w-1/4;\n      }\n    }\n\n    .camera-row-1.total-items-7.inner-items-3 {\n      .video-camera-item {\n        @apply w-1/4;\n      }\n    }\n\n    .camera-row-1.total-items-8.inner-items-4 {\n      .video-camera-item {\n        @apply w-1/4;\n      }\n    }\n\n    .camera-row-2.total-items-11.inner-items-3 {\n      .video-camera-item {\n        @apply w-1/4;\n      }\n    }\n\n    .camera-row-2.total-items-10.inner-items-2 {\n      .video-camera-item {\n        @apply w-1/4;\n      }\n    }\n\n    .camera-row-2.total-items-13.inner-items-3 {\n      .video-camera-item {\n        @apply w-1/5;\n      }\n    }\n\n    .camera-row-2.total-items-14.inner-items-4 {\n      .video-camera-item {\n        @apply w-1/5;\n      }\n    }\n\n    .camera-row-2.total-items-15.inner-items-5 {\n      .video-camera-item {\n        @apply w-1/5;\n      }\n    }\n\n    .camera-row-2.total-items-16.inner-items-4 {\n      .video-camera-item {\n        @apply w-[16.3%];\n      }\n    }\n\n    .camera-row-2.total-items-17.inner-items-5 {\n      .video-camera-item {\n        @apply w-[16.3%];\n      }\n    }\n\n    .camera-row-2.total-items-18.inner-items-6 {\n      .video-camera-item {\n        @apply w-[16.3%];\n      }\n    }\n\n    .camera-row-2.total-items-19.inner-items-5 {\n      .video-camera-item {\n        @apply w-[13.95%];\n      }\n    }\n\n    .camera-row-2.total-items-20.inner-items-6 {\n      .video-camera-item {\n        @apply w-[13.95%];\n      }\n    }\n\n    .camera-row-2.total-items-21.inner-items-7 {\n      .video-camera-item {\n        @apply w-[13.95%];\n      }\n    }\n\n    .camera-row-2.total-items-22.inner-items-6 {\n      .video-camera-item {\n        @apply w-[12.15%];\n      }\n    }\n\n    .camera-row-2.total-items-23.inner-items-7 {\n      .video-camera-item {\n        @apply w-[12.15%];\n      }\n    }\n\n    .camera-row-2.total-items-24.inner-items-8 {\n      .video-camera-item {\n        @apply w-[12.15%];\n      }\n    }\n\n    .camera-row-1.total-items-9.inner-items-4 {\n      .video-camera-item {\n        @apply w-1/5;\n      }\n    }\n\n    .camera-row-1.total-items-10.inner-items-5 {\n      .video-camera-item {\n        @apply w-1/5;\n      }\n    }\n\n    .video-camera-item.admin {\n      @apply order-1;\n    }\n\n    .video-camera-item.participants {\n      @apply order-2;\n    }\n\n    .video-camera-item.admin.speaking {\n      &::before {\n        @apply border-[#004e91];\n      }\n    }\n  }\n\n  button.previous-cam {\n    @apply absolute top-[48%] w-[120px] h-[30px] z-[1] bg-black/50 text-center transition-all -rotate-90 -left-[55px] rounded-tlblD pt-[6px];\n    i {\n      @apply w-[20px] m-auto transition-all text-white;\n    }\n\n    &:hover {\n      i {\n        @apply text-white;\n      }\n    }\n  }\n\n  button.next-cam {\n    @apply absolute top-[48%] w-[120px] h-[30px] z-[1] bg-black/50 text-center transition-all -rotate-90 left-auto -right-[55px] rounded-trbrD pt-[2px];\n    i {\n      @apply w-[20px] m-auto transition-all text-white;\n    }\n\n    &:hover {\n      i {\n        @apply text-white;\n      }\n    }\n  }\n}\n\n.fullWidthMainArea {\n  .select-camera-number {\n    @apply hidden;\n  }\n}\n\n.select-camera-number {\n  @apply flex items-center absolute left-6 text-xs top-0;\n  select#select-camera-num {\n    @apply bg-transparent border border-solid border-[#333] mr-[5px] outline-none;\n  }\n}\n\n.video-camera-item {\n  @apply w-full h-full rounded-2xl overflow-hidden z-[1] bg-black;\n  .loading {\n    @apply top-1/2 -translate-y-1/2;\n  }\n\n  &::before {\n    @apply absolute content-[''] w-full h-full border-[5px] border-solid border-transparent z-[999] rounded-[15px];\n  }\n\n  &::after {\n    background: linear-gradient(\n      0deg,\n      rgba(0, 0, 0, 0.4) 0%,\n      rgba(0, 0, 0, 0.1) 50%\n    );\n    @apply absolute content-[''] w-full h-full z-[99];\n  }\n\n  .name {\n    @apply absolute bottom-[10px] z-[999] text-white left-3 text-sm leading-[1];\n  }\n\n  .camera-modules {\n    .camera-video-player {\n      @apply flex h-full w-full absolute;\n      video.camera-video {\n        @apply w-full h-full;\n      }\n    }\n\n    .status {\n      @apply absolute z-[999] rounded-full bottom-3 right-3 flex items-center justify-center;\n      > div {\n        @apply rounded-full bg-black/20 p-2 h-5 flex items-center justify-center;\n      }\n    }\n\n    .status.PinWebcam {\n      @apply right-auto left-3 top-3 items-start;\n    }\n  }\n}\n\n.video-camera-item.speaking {\n  &::before {\n    @apply border-secondaryColor;\n  }\n}\n\n// Webcam Area SCSS\n\n#main-area.fullWidthMainArea {\n  .all-webcam-wrapper {\n    background: rgb(235, 248, 255);\n    background: linear-gradient(\n      150deg,\n      rgba(235, 248, 255, 1) 0%,\n      rgba(255, 255, 255, 1) 10%,\n      rgba(243, 237, 249, 1) 67%,\n      rgba(214, 231, 255, 1) 100%\n    );\n    @apply absolute w-[270px] h-full block py-[30px] px-0 z-[2] left-0;\n    .video-camera-item {\n      &::after {\n        @apply bg-transparent opacity-100;\n      }\n\n      .name {\n        @apply opacity-100 top-auto left-3;\n      }\n\n      .connection-status {\n        @apply flex;\n      }\n\n      .mic-status {\n        @apply flex;\n      }\n    }\n\n    button.previous-cam {\n      @apply top-0 w-full left-0 rotate-0;\n    }\n\n    button.next-cam {\n      @apply absolute w-full left-0 rotate-0 bottom-0 top-auto;\n    }\n\n    .all-webcam-wrapper-inner {\n      @apply block py-0 px-[5px];\n    }\n  }\n\n  .middle-fullscreen-wrapper.verticalsWebcamsActivated {\n    @apply pl-[260px];\n  }\n\n  .middle-fullscreen-wrapper {\n    @apply flex-[auto] w-full h-full;\n  }\n}\n\n.SpeechHistory {\n  &::before {\n    content: '';\n    @apply absolute h-[12px] w-[12px] bg-white dark:bg-darkPrimary bottom-[-6px] left-14 rotate-45 border border-solid border-darkPrimary/40;\n  }\n}\n\n// Tool Tip\n.tooltip {\n  @apply invisible absolute shadow-lg rounded text-[13px] text-darkPrimary dark:text-darkText py-[6px] px-[10px] inline-block bg-gray-100 dark:bg-darkSecondary2 w-[150px] m-0 bottom-[52px] text-center;\n  &::before {\n    content: '';\n    @apply absolute h-[12px] w-[12px] bg-gray-100 dark:bg-darkSecondary2 bottom-[-6px] left-0 right-0 m-auto rotate-45 border border-solid border-darkPrimary/40;\n  }\n\n  &::after {\n    content: '';\n    @apply absolute h-2 w-full bg-gray-100 dark:bg-darkSecondary2 left-0 bottom-0 rounded;\n  }\n}\n\n.tooltip-left {\n  &::before {\n    left: 24px !important;\n    right: auto !important;\n  }\n}\n\nhtml[dir='rtl'] span.tooltip.tooltip-left {\n  right: -34px !important;\n  left: auto !important;\n}\n\nhtml[dir='rtl'] span.tooltip.tooltip-left::before {\n  left: auto !important;\n  right: 45px !important;\n}\n\n.has-tooltip {\n  &:hover {\n    .tooltip {\n      @apply visible z-[50];\n    }\n  }\n}\n\n// Tool Tip\n\n#main-footer {\n  .record {\n    animation-name: pulse;\n    animation-duration: 1.5s;\n    animation-iteration-count: infinite;\n    animation-timing-function: linear;\n  }\n}\n\n.message-form {\n  background: rgb(214, 231, 255);\n  background: linear-gradient(\n    0deg,\n    rgba(214, 231, 255, 0.5) 67%,\n    rgba(214, 231, 255, 1) 100%\n  );\n}\n\n.Toastify__toast-container {\n  @apply z-[999999];\n}\n\n.Toastify__toast-body {\n  @apply m-0 font-light;\n}\n\n.vertical-webcams {\n  .all-webcam-wrapper-inner {\n    .video-camera-item {\n      @apply h-[calc(33.33%-10px)] my-2 mx-0;\n    }\n  }\n}\n\n// Share Screen Running\n.share-screen-wrapper.is-share-screen-running {\n  .screen-share-video {\n    @apply h-full w-full;\n    video.video-player {\n      @apply h-[calc(100%-30px)] w-[calc(100%-30px)] top-[15px] left-[15px];\n    }\n\n    video.video-player.self-screen-share {\n      @apply w-[30%] left-[35%];\n    }\n  }\n}\n\n// Share Screen Running\n\n.footer-podcast-button {\n  @apply relative;\n  .lds-ripple {\n    @apply absolute w-[30px] h-[30px] left-2;\n    div {\n      @apply border-2 border-solid border-[rgb(0,77,144)];\n      -webkit-animation: lds-ripple2 0.8s cubic-bezier(0, 0.2, 0.8, 1) infinite;\n      animation: lds-ripple2 0.8s cubic-bezier(0, 0.2, 0.8, 1) infinite;\n\n      &:last-child {\n        -webkit-animation-delay: -0.3s;\n        animation-delay: -0.3s;\n      }\n    }\n  }\n}\n\n.transition-left-panel {\n  @apply absolute h-full shadow-panel z-[3];\n}\n\n.transition-right-panel {\n  @apply absolute right-0 h-full shadow-panel z-[2];\n}\n\n.media-player-inner {\n  position: relative;\n  width: 100% !important;\n  height: inherit !important;\n\n  > div {\n    height: inherit !important;\n    margin: auto;\n\n    > div {\n      @apply overflow-hidden pb-[56.25%] relative;\n    }\n  }\n\n  iframe {\n    @apply left-0 top-0 h-full w-full absolute;\n  }\n}\n\n.is-pc {\n  .media-player-inner {\n    > div {\n      width: 100% !important;\n    }\n  }\n}\n\n.range {\n  @apply appearance-none align-middle    outline-none border-none p-0 bg-transparent w-full;\n  &::-webkit-slider-runnable-track {\n    background-color: rgba(128, 128, 128, 0.5);\n    height: 10px;\n    border-radius: 5px;\n    border: 1px solid transparent;\n    @apply bg-[rgba(128,128,128,0.5)] dark:bg-secondaryColor/90 h-[10px] rounded-[5px] border border-solid border-transparent;\n  }\n\n  &::-moz-range-track {\n    @apply bg-[rgba(128,128,128,0.5)] dark:bg-secondaryColor/90 h-[10px] rounded-[5px] border border-solid border-transparent;\n  }\n\n  &::-webkit-slider-thumb {\n    @apply appearance-none rounded-full bg-primaryColor dark:bg-white h-[18px] w-[18px] -mt-[5px];\n  }\n\n  &::-moz-range-thumb {\n    @apply rounded-[20px] h-[18px] w-[18px] border-none bg-primaryColor;\n  }\n\n  &:active {\n    &::-webkit-slider-thumb {\n      @apply outline-none;\n    }\n\n    &::-moz-range-thumb {\n      @apply outline-none;\n    }\n  }\n}\n\n// header#main-header {\n//   // header volume slider\n//   .volume-popup-wrapper {\n\n//   }\n// }\n// header volume slider\n.showParticipantsPanel {\n  .active-speakers-wrap {\n    @apply z-[2];\n  }\n}\n\n.showChatPanel {\n  .active-speakers-wrap {\n    @apply z-[2];\n  }\n\n  .screen-share-video {\n    button {\n      @apply right-[320px];\n    }\n  }\n}\n\n.breakout-room-list-item {\n  .timer {\n    border-color: #fff;\n    color: #fff;\n    border-radius: 8px;\n    margin-left: 5px;\n  }\n}\n\n.react-js-player-wrap {\n  .video-js {\n    padding-top: 0 !important;\n\n    button.vjs-big-play-button {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n    }\n  }\n}\n\n.excalidraw.excalidraw-modal-container {\n  z-index: 99999 !important;\n}\n\n// Camera Height/Width fix on Landscape MObile devices\n.landscape-device.is-mobile {\n  #main-area.fullWidthMainArea {\n    .share-screen-wrapper {\n      @apply h-full;\n      .screen-share-video {\n        video.video-player {\n          // @apply w-full px-[10px];\n        }\n      }\n    }\n\n    .middle-fullscreen-wrapper {\n      .notepad-wrapper {\n        @apply h-[94%] top-[3%] relative mt-0;\n      }\n\n      .externalMediaPlayerWrapper {\n        @apply h-full;\n        .media-player-inner {\n          div {\n            margin: auto;\n\n            div {\n              @apply pb-0;\n            }\n          }\n        }\n      }\n\n      .external-display-link-wrapper {\n        @apply h-full m-0 p-2;\n      }\n\n      .all-webcam-wrapper.vertical-webcams.total-cam-1 {\n        @apply p-0;\n        .all-webcam-wrapper-inner {\n          display: flex !important;\n          @apply flex-wrap items-center;\n          .video-camera-item {\n            @apply h-[45%];\n          }\n        }\n      }\n\n      .all-webcam-wrapper.vertical-webcams.total-cam-2 {\n        @apply p-0;\n        .all-webcam-wrapper-inner {\n          display: flex !important;\n          @apply flex-wrap items-center;\n          .video-camera-item {\n            @apply h-[45%];\n          }\n        }\n      }\n\n      .all-webcam-wrapper.vertical-webcams.total-cam-3 {\n        @apply p-0;\n        .all-webcam-wrapper-inner {\n          display: flex !important;\n          @apply flex-wrap items-center;\n          .video-camera-item {\n            @apply h-[30%];\n          }\n        }\n      }\n\n      .all-webcam-wrapper.vertical-webcams {\n        .all-webcam-wrapper-inner {\n          .video-camera-item {\n            @apply w-full;\n          }\n        }\n      }\n    }\n\n    .middle-fullscreen-wrapper.verticalsWebcamsActivated {\n      .screen-share-video {\n        button {\n          @apply bottom-[55px];\n        }\n      }\n    }\n  }\n\n  // .camera-row-1.total-items-5.inner-items-2 {\n  //   .video-camera-item {\n  //     @apply h-1/3;\n  //   }\n  // }\n}\n\n// Camera Height/Width fix on Landscape MObile devices\n\n// Full width Modules height Fix for Portrait Mobile devices\n.portrait-device.is-mobile {\n  #main-area.fullWidthMainArea {\n    .verticalsWebcamsActivated {\n      .excalidraw-wrapper {\n        @apply h-[calc(100%-110px)] m-0 p-2;\n      }\n\n      .notepad-wrapper {\n        @apply h-[calc(100%-110px)] m-0 p-2;\n      }\n\n      .Div-external-media-player {\n        @apply h-[calc(100%-110px)] m-0 p-2;\n        .externalMediaPlayerWrapper {\n          @apply p-0;\n        }\n      }\n\n      .external-display-link-wrapper {\n        @apply h-[calc(100%-110px)] m-0 p-2;\n      }\n\n      .screen-share-video {\n        @apply h-[calc(100%-110px)];\n      }\n    }\n  }\n\n  .middle-fullscreen-wrapper {\n    .screen-share-video {\n      @apply h-full m-0 p-2;\n    }\n\n    .external-display-link-wrapper {\n      @apply h-full m-0 p-2;\n    }\n\n    .notepad-wrapper {\n      @apply h-full m-0 p-2;\n    }\n\n    .excalidraw-wrapper {\n      @apply h-full m-0 p-2;\n    }\n  }\n\n  .media-player-inner {\n    > div {\n      width: 100% !important;\n    }\n  }\n}\n\n// Full width Modules height Fix for Portrait Mobile devices\naside {\n  box-shadow: 0 2px 5px #efefefdb !important;\n  width: 100% !important;\n}\n\n// Camera width on Landscape Tablet\n.landscape-device.is-tablet {\n  #main-area.fullWidthMainArea {\n    .middle-fullscreen-wrapper.verticalsWebcamsActivated {\n      .all-webcam-wrapper {\n        height: 100%;\n      }\n    }\n  }\n\n  .camera-row-1.total-items-5.inner-items-2 {\n    .video-camera-item {\n      @apply w-1/2;\n    }\n  }\n\n  .camera-row-2.total-items-5.inner-items-1 {\n    .video-camera-item {\n      @apply w-1/2;\n    }\n  }\n\n  .camera-row-1.total-items-7.inner-items-3 {\n    .video-camera-item {\n      @apply w-1/3;\n    }\n  }\n\n  .camera-row-2.total-items-7.inner-items-1 {\n    .video-camera-item {\n      @apply w-1/3;\n    }\n  }\n\n  .camera-row-2.total-items-8.inner-items-2 {\n    .video-camera-item {\n      @apply w-1/3;\n    }\n  }\n}\n\n// Camera width on Landscape Tablet\n.portrait-device.is-tablet {\n  // Camera height on Portrait Tablet\n  .camera-row-0.total-items-2 {\n    @apply flex-wrap;\n    .video-camera-item {\n      @apply w-full h-1/2;\n    }\n  }\n\n  .camera-row-0.total-items-3 {\n    @apply flex-wrap;\n    .video-camera-item {\n      @apply w-full h-1/3;\n    }\n  }\n\n  // Camera height on Portrait Tablet\n  #main-area.fullWidthMainArea {\n    .middle-fullscreen-wrapper {\n      .all-webcam-wrapper {\n        @apply absolute h-auto w-full z-[9] p-0 -bottom-[5px];\n        .all-webcam-wrapper-inner {\n          @apply m-0 py-0 px-[15px] flex-wrap gap-0;\n          .video-camera-item {\n            @apply w-full m-[5px] h-[100px] pb-0 max-w-[135px];\n          }\n        }\n      }\n    }\n\n    .middle-fullscreen-wrapper.verticalsWebcamsActivated {\n      @apply pl-0;\n      .screen-share-video {\n        @apply h-[calc(100%-105px)];\n        button {\n          @apply absolute bottom-0;\n        }\n      }\n\n      .excalidraw-wrapper {\n        @apply h-[calc(100%-135px)];\n      }\n\n      .notepad-wrapper {\n        @apply h-[calc(100%-150px)];\n      }\n\n      .Div-external-media-player {\n        @apply h-[calc(100%-105px)];\n      }\n\n      .external-display-link-wrapper {\n        @apply h-[calc(100%-145px)];\n      }\n    }\n\n    .all-webcam-wrapper.vertical-webcams {\n      .all-webcam-wrapper-inner {\n        display: flex !important;\n        @apply justify-center;\n        button.next-cam {\n          @apply -right-[42px] w-[100px] left-auto h-5 top-[45px] -rotate-90;\n        }\n\n        button.previous-cam {\n          @apply right-auto w-[100px] -left-[42px] h-5 top-[45px] -rotate-90 pt-0;\n        }\n      }\n    }\n  }\n\n  .excalidraw-wrapper {\n    @apply mt-4;\n  }\n}\n\n.message-form {\n  textarea#message-textarea {\n    color: #004d90;\n  }\n\n  textarea#message-textarea::placeholder {\n    color: #004d90aa;\n  }\n}\n\n.dark {\n  .message-form {\n    textarea#message-textarea,\n    textarea#message-textarea::placeholder {\n      color: #fff;\n    }\n  }\n}\n\n.is-mobile {\n  .footer-collapse-arrow,\n  .header-collapse-arrow {\n    display: none;\n  }\n}\n\n.portrait-device.is-tablet {\n  .footer-collapse-arrow,\n  .header-collapse-arrow {\n    display: none;\n  }\n}\n\n.footer-collapse-arrow span::before,\n.header-collapse-arrow span::before {\n  content: '';\n  bottom: -6px;\n  @apply absolute w-[10px] h-[10px] bg-white dark:bg-darkPrimary right-5 rotate-45;\n}\n\n.header-collapse-arrow span::before {\n  bottom: auto;\n  top: -5px;\n}\n\n.notepad-wrapper .inner {\n  resize: both;\n  overflow: auto;\n}\n\n.waiting-room-logo {\n  height: 90px;\n  display: flex;\n\n  .waiting-room-logo-img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    cursor: unset;\n  }\n}\n\n.header-logo {\n  height: 45px;\n  display: flex;\n\n  .header-logo-img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    object-position: left;\n    cursor: unset;\n  }\n}\n\nhtml[dir='rtl'] {\n  .header-logo {\n    .header-logo-img {\n      object-position: right;\n    }\n  }\n}\n\nhtml[dir='rtl'] .rtl\\:microphone-rtl-left::before {\n  left: 26px;\n  margin-left: 0;\n}\n\n.show-speech-setting .rtl\\:tooltip-right::before {\n  left: 26px;\n  right: auto;\n}\n\n$base-space: 50px;\n\n#main-health-monitor-panel {\n  &.monitor-panel {\n    &.close { display: none; }\n    &.open { display: block; }\n  }\n  position        : fixed;\n  left            : 0px;\n  width           : 100%;\n  z-index         : 99999;\n  height          : 100vh;\n  top             : 0px;\n  background-color: rgba(0, 0, 0, 0.3);\n  .wrapper-health-monitor {\n    background-color: white;\n    border-radius   : 8px;\n    padding         : $base-space;\n    min-height      : calc(100% - $base-space);\n    margin-top      : calc($base-space / 2);\n    width           : calc(100% - $base-space);\n    margin-left     : calc($base-space / 2);\n    position        : relative;\n    .monitor-header {\n      position        : absolute;\n      left            : 0px;\n      top             : 0px;\n      width           : 100%;\n      padding         : $base-space;\n      .monitor-patient {\n        &.name {\n          font-size  : 30px;\n          font-weight: bold;\n        }\n        &.close-modal {\n          position     : absolute;\n          right        : 10px;\n          top          : 10px;\n          border-radius: 100%;\n          border       : 1px solid black;\n          padding      : 10px;\n          width        : 45px;\n          height       : 45px;\n          text-align   : center;\n        }\n      }\n    }\n    .monitor-content {\n      margin-top: 80px;\n      display: grid;\n      grid-template-columns: repeat(5, 1fr);\n      grid-column-gap: 10px;\n      grid-row-gap: 10px;\n      .monitor-alert {\n        background-color: green;\n        width           : 100%;\n        border-radius   : 8px;\n        color           : white;\n        padding         : 20px;\n        &.alert {\n          background-color: red;\n        }\n        .title { text-align: right; }\n        .content {\n          display        : flex;\n          justify-content: flex-end;\n          align-items    : center;\n          gap            : 10px;\n          .monitor-value {\n            font-weight: 900;\n            font-size  : 25px;\n          }\n        }\n      }\n    }\n    .monitor-chart {\n      margin-top           : 20px;\n      display              : grid;\n      grid-template-columns: repeat(2, 1fr);\n      grid-column-gap      : 10px;\n      grid-row-gap         : 10px;\n      max-height           : calc(100vh - 350px);\n      overflow-y           : scroll;\n      overflow-x           : hidden;\n      &::-webkit-scrollbar-track {\n        display           : none;\n        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);\n        background-color  : #F5F5F5;\n      }\n      &::-webkit-scrollbar {\n        display         : none;\n        width           : 6px;\n        background-color: #F5F5F5;\n      }\n      &::-webkit-scrollbar-thumb {\n        display         : none;\n        background-color: #000000;\n      }\n      .monitor-chart-wrapper {\n        width: 100%\n      }\n    }\n  }\n}\n.monitor-icon {\n  width   : 20px;\n  position: relative;\n}","$primaryColor: #004d90;\n$secondaryColor: #24aef7;\n","//  KeyFrames Animations\n@keyframes refresh {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0.5;\n  }\n}\n@-webkit-keyframes wobble {\n  0% {\n    -webkit-transform: none;\n    transform: none;\n  }\n  15% {\n    -webkit-transform: translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg);\n    transform: translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg);\n  }\n  30% {\n    -webkit-transform: translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg);\n    transform: translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg);\n  }\n  45% {\n    -webkit-transform: translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg);\n    transform: translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg);\n  }\n  60% {\n    -webkit-transform: translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg);\n    transform: translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg);\n  }\n  75% {\n    -webkit-transform: translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg);\n    transform: translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg);\n  }\n  100% {\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n@keyframes wobble {\n  0% {\n    -webkit-transform: none;\n    transform: none;\n  }\n  15% {\n    -webkit-transform: translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg);\n    transform: translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg);\n  }\n  30% {\n    -webkit-transform: translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg);\n    transform: translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg);\n  }\n  45% {\n    -webkit-transform: translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg);\n    transform: translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg);\n  }\n  60% {\n    -webkit-transform: translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg);\n    transform: translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg);\n  }\n  75% {\n    -webkit-transform: translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg);\n    transform: translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg);\n  }\n  100% {\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n@keyframes pulse {\n  0% {\n    box-shadow: 0 0 5px 0 rgba(0, 77, 144, 0.3);\n  }\n  65% {\n    box-shadow: 0 0 5px 13px rgb(242, 242, 242);\n  }\n  90% {\n    box-shadow: 0 0 5px 13px rgb(242, 242, 242);\n  }\n}\n@keyframes lds-ripple2 {\n  0% {\n    top: 16px;\n    left: 16px;\n    width: 0;\n    height: 0;\n    opacity: 1;\n  }\n  100% {\n    top: 0;\n    left: 0;\n    width: 30px;\n    height: 30px;\n    opacity: 0;\n  }\n}\n//  KeyFrames Animations\n\n.shake {\n  -webkit-animation-name: wobble;\n  animation-name: wobble;\n  -webkit-animation-duration: 0.8s;\n  -webkit-animation-iteration-count: infinite;\n  -webkit-animation-timing-function: linear;\n  -webkit-transform-origin: 50% 100%;\n  display: inline-block;\n}\n.hiddenAnimation {\n  animation: refresh 0.5s infinite;\n}\n","// Dark Mode Design Updates\n.dark {\n  .main-app-bg {\n    &::before {\n      @apply absolute content-[''] w-full h-full bg-[#001222] opacity-70;\n    }\n  }\n  .waiting-room {\n    &::before {\n      @apply absolute content-[''] w-full h-full bg-[#001222] opacity-70;\n    }\n  }\n  .error-app-bg {\n    &::before {\n      @apply absolute content-[''] w-full h-full bg-[#001222] opacity-70;\n    }\n  }\n  .multi-gradient {\n    background: #031a3e;\n  }\n  #main-area.fullWidthMainArea {\n    .all-webcam-wrapper {\n      background: #031a3e;\n    }\n  }\n  .message-form {\n    background: transparent;\n  }\n  .Toastify__toast {\n    background: #222;\n    color: #fff;\n  }\n  button.Toastify__close-button {\n    svg {\n      path {\n        fill: #fff;\n      }\n    }\n  }\n  .wb-page-navigation {\n    button {\n      &:disabled {\n        background-color: var(--button-gray-1) !important;\n      }\n    }\n  }\n  .header-before-start {\n    opacity: 0.4;\n  }\n  .header-before-end {\n    opacity: 0.1;\n  }\n  .select-camera-number {\n    color: #a7cced;\n    select#select-camera-num {\n      border-color: #a7cced;\n    }\n  }\n}\n// Dark Mode Design Updates\n","//  Recorder CSS\n.plugNmeet-app {\n  #main-area.isRecorder {\n    .all-webcam-wrapper {\n      @apply h-screen;\n    }\n  }\n  #main-area.fullWidthMainArea.isRecorder {\n    .middle-fullscreen-wrapper.verticalsWebcamsActivated {\n      @apply pl-[440px];\n    }\n  }\n  .isRecorder {\n    .transition-right-panel {\n      @apply relative;\n    }\n  }\n  .isRecorder.showScreenShare {\n    .middle-area {\n      @apply flex items-center justify-center;\n    }\n  }\n}\n@media screen and (max-width: 1800px) {\n  .plugNmeet-app {\n    #main-area.fullWidthMainArea.isRecorder {\n      .middle-fullscreen-wrapper.verticalsWebcamsActivated {\n        @apply pl-[270px];\n      }\n    }\n  }\n}\n@media screen and (max-width: 1280px) {\n  .plugNmeet-app {\n    #main-area.fullWidthMainArea.isRecorder {\n      .middle-fullscreen-wrapper.verticalsWebcamsActivated {\n        @apply pl-[200px];\n      }\n    }\n  }\n}\n@media screen and (max-width: 1023px) {\n  .plugNmeet-app {\n    #main-area.fullWidthMainArea.isRecorder {\n      .middle-fullscreen-wrapper.verticalsWebcamsActivated {\n        @apply pl-0;\n      }\n    }\n  }\n}\n//  Recorder CSS\n","@media (min-width: 1024px) {\n  .all-webcam-wrapper-inner {\n    @apply p-6;\n  }\n  #main-area.column-camera-position-top.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .all-webcam-wrapper,\n  #main-area.column-camera-position-bottom.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .all-webcam-wrapper {\n    @apply w-full top-0 h-[130px] py-[5px] px-[15px];\n  }\n  #main-area.column-camera-position-top.column-camera-width-medium.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .all-webcam-wrapper,\n  #main-area.column-camera-position-bottom.column-camera-width-medium.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .all-webcam-wrapper {\n    @apply h-[120px];\n  }\n  #main-area.column-camera-position-top.column-camera-width-small.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .all-webcam-wrapper,\n  #main-area.column-camera-position-bottom.column-camera-width-small.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .all-webcam-wrapper {\n    @apply h-[110px];\n  }\n  #main-area.column-camera-position-top.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .all-webcam-wrapper\n    .video-camera-item,\n  #main-area.column-camera-position-bottom.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .all-webcam-wrapper\n    .video-camera-item {\n    @apply inline-block h-full m-0;\n  }\n  #main-area.column-camera-position-top.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .all-webcam-wrapper\n    .all-webcam-wrapper-inner,\n  #main-area.column-camera-position-bottom.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .all-webcam-wrapper\n    .all-webcam-wrapper-inner {\n    @apply flex items-center justify-center;\n  }\n  #main-area.column-camera-position-top.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .all-webcam-wrapper\n    .all-webcam-wrapper-inner\n    .video-camera-item,\n  #main-area.column-camera-position-bottom.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .all-webcam-wrapper\n    .all-webcam-wrapper-inner\n    .video-camera-item {\n    @apply w-[12.5%];\n  }\n  #main-area.column-camera-position-top.fullWidthMainArea\n    .verticalsWebcamsActivated,\n  #main-area.column-camera-position-bottom.fullWidthMainArea\n    .verticalsWebcamsActivated {\n    padding: 0 !important;\n  }\n  #main-area.column-camera-position-top.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .all-webcam-wrapper\n    .all-webcam-wrapper-inner\n    button.next-cam,\n  #main-area.column-camera-position-bottom.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .all-webcam-wrapper\n    .all-webcam-wrapper-inner\n    button.next-cam {\n    @apply h-full w-5 right-0 left-auto rounded-none;\n  }\n  #main-area.column-camera-position-top.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .all-webcam-wrapper\n    .all-webcam-wrapper-inner\n    button.next-cam\n    i,\n  #main-area.column-camera-position-bottom.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .all-webcam-wrapper\n    .all-webcam-wrapper-inner\n    button.next-cam\n    i {\n    @apply inline-block -rotate-90;\n  }\n  #main-area.column-camera-position-top.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .all-webcam-wrapper\n    .all-webcam-wrapper-inner\n    button.previous-cam,\n  #main-area.column-camera-position-bottom.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .all-webcam-wrapper\n    .all-webcam-wrapper-inner\n    button.previous-cam {\n    @apply w-5 h-full p-0 rounded-none;\n  }\n  #main-area.column-camera-position-top.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .all-webcam-wrapper\n    .all-webcam-wrapper-inner\n    button.previous-cam\n    i,\n  #main-area.column-camera-position-bottom.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .all-webcam-wrapper\n    .all-webcam-wrapper-inner\n    button.previous-cam\n    i {\n    @apply inline-block -rotate-90;\n  }\n  #main-area.column-camera-position-top.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .all-webcam-wrapper {\n    @apply bottom-0;\n  }\n  #main-area.column-camera-position-bottom.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .all-webcam-wrapper {\n    @apply bottom-0 top-auto;\n  }\n  #main-area.column-camera-position-left.column-camera-width-medium.fullWidthMainArea\n    .middle-fullscreen-wrapper.verticalsWebcamsActivated {\n    @apply pl-[250px];\n  }\n  #main-area.column-camera-position-left.column-camera-width-small.fullWidthMainArea\n    .middle-fullscreen-wrapper.verticalsWebcamsActivated {\n    @apply pl-[230px];\n  }\n  #main-area.column-camera-position-left.column-camera-width-medium.fullWidthMainArea\n    .middle-fullscreen-wrapper.verticalsWebcamsActivated\n    .all-webcam-wrapper {\n    @apply w-[240px];\n  }\n  #main-area.column-camera-position-left.column-camera-width-small.fullWidthMainArea\n    .middle-fullscreen-wrapper.verticalsWebcamsActivated\n    .all-webcam-wrapper {\n    @apply w-[220px];\n  }\n  #main-area.column-camera-width-medium.fullWidthMainArea #main-left-panel {\n    @apply w-[240px];\n  }\n  #main-area.column-camera-width-small.fullWidthMainArea #main-left-panel {\n    @apply w-[220px];\n  }\n  #main-area.column-camera-position-top.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .excalidraw-wrapper {\n    margin-top: 140px;\n    height: calc(100% - 150px);\n  }\n  #main-area.column-camera-position-top.column-camera-width-medium.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .excalidraw-wrapper {\n    margin-top: 130px;\n    height: calc(100% - 140px);\n  }\n  #main-area.column-camera-position-top.column-camera-width-small.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .excalidraw-wrapper {\n    margin-top: 120px;\n    height: calc(100% - 130px);\n  }\n  #main-area.column-camera-position-bottom.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .excalidraw-wrapper {\n    margin-top: 2.25rem;\n    height: calc(100% - 175px);\n  }\n  #main-area.column-camera-position-bottom.column-camera-width-medium.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .excalidraw-wrapper {\n    margin-top: 2.25rem;\n    height: calc(100% - 165px);\n  }\n  #main-area.column-camera-position-bottom.column-camera-width-small.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .excalidraw-wrapper {\n    margin-top: 2.25rem;\n    height: calc(100% - 155px);\n  }\n  #main-area.column-camera-position-top.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .screen-share-video {\n    margin-top: 130px;\n    height: calc(100% - 130px);\n  }\n  #main-area.column-camera-position-top.column-camera-width-medium.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .screen-share-video {\n    margin-top: 120px;\n    height: calc(100% - 120px);\n  }\n  #main-area.column-camera-position-top.column-camera-width-small.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .screen-share-video {\n    margin-top: 110px;\n    height: calc(100% - 110px);\n  }\n  #main-area.column-camera-position-bottom.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .screen-share-video {\n    height: calc(100% - 130px);\n  }\n  #main-area.column-camera-position-bottom.column-camera-width-medium.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .screen-share-video {\n    height: calc(100% - 120px);\n  }\n  #main-area.column-camera-position-bottom.column-camera-width-small.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .screen-share-video {\n    height: calc(100% - 110px);\n  }\n  #main-area.column-camera-position-top.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .notepad-wrapper {\n    margin-top: 140px;\n    height: calc(100% - 150px);\n  }\n  #main-area.column-camera-position-top.column-camera-width-medium.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .notepad-wrapper {\n    margin-top: 130px;\n    height: calc(100% - 140px);\n  }\n  #main-area.column-camera-position-top.column-camera-width-small.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .notepad-wrapper {\n    margin-top: 120px;\n    height: calc(100% - 130px);\n  }\n  #main-area.column-camera-position-bottom.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .notepad-wrapper {\n    height: calc(100% - 175px);\n  }\n  #main-area.column-camera-position-bottom.column-camera-width-medium.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .notepad-wrapper {\n    height: calc(100% - 165px);\n  }\n  #main-area.column-camera-position-bottom.column-camera-width-small.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .notepad-wrapper {\n    height: calc(100% - 155px);\n  }\n  #main-area.column-camera-position-top.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .Div-external-media-player {\n    margin-top: 130px;\n    height: calc(100% - 130px);\n  }\n  #main-area.column-camera-position-top.column-camera-width-medium.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .Div-external-media-player {\n    margin-top: 120px;\n    height: calc(100% - 120px);\n  }\n  #main-area.column-camera-position-top.column-camera-width-small.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .Div-external-media-player {\n    margin-top: 110px;\n    height: calc(100% - 110px);\n  }\n  #main-area.column-camera-position-bottom.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .Div-external-media-player {\n    height: calc(100% - 130px);\n  }\n  #main-area.column-camera-position-bottom.column-camera-width-medium.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .Div-external-media-player {\n    height: calc(100% - 120px);\n  }\n  #main-area.column-camera-position-bottom.column-camera-width-small.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .Div-external-media-player {\n    height: calc(100% - 110px);\n  }\n  #main-area.column-camera-position-top.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .external-display-link-wrapper {\n    margin-top: 140px;\n    height: calc(100% - 150px);\n  }\n  #main-area.column-camera-position-top.column-camera-width-medium.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .external-display-link-wrapper {\n    margin-top: 130px;\n    height: calc(100% - 140px);\n  }\n  #main-area.column-camera-position-top.column-camera-width-small.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .external-display-link-wrapper {\n    margin-top: 120px;\n    height: calc(100% - 130px);\n  }\n  #main-area.column-camera-position-bottom.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .external-display-link-wrapper {\n    height: calc(100% - 175px);\n  }\n  #main-area.column-camera-position-bottom.column-camera-width-medium.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .external-display-link-wrapper {\n    height: calc(100% - 165px);\n  }\n  #main-area.column-camera-position-bottom.column-camera-width-small.fullWidthMainArea\n    .verticalsWebcamsActivated\n    .external-display-link-wrapper {\n    height: calc(100% - 155px);\n  }\n  #main-area.fullWidthMainArea.column-camera-position-left.column-camera-width-full\n    .active-speakers-wrap {\n    @apply w-[calc(100%-300px)] left-auto right-[30px];\n  }\n  #main-area.fullWidthMainArea.column-camera-position-left.column-camera-width-medium\n    .active-speakers-wrap {\n    @apply w-[calc(100%-280px)] left-auto right-[30px];\n  }\n  #main-area.fullWidthMainArea.column-camera-position-left.column-camera-width-small\n    .active-speakers-wrap {\n    @apply w-[calc(100%-260px)] left-auto right-[30px];\n  }\n\n  .column-camera-position-top .active-speakers-wrap,\n  .column-camera-position-bottom .active-speakers-wrap {\n    max-width: calc(100% - 30px);\n    margin: auto;\n    right: 0;\n  }\n  .column-camera-width-medium\n    .all-webcam-wrapper.total-cam-1\n    .all-webcam-wrapper-inner,\n  .column-camera-width-medium\n    .all-webcam-wrapper.total-cam-2\n    .all-webcam-wrapper-inner,\n  .column-camera-width-medium\n    .all-webcam-wrapper.total-cam-3\n    .all-webcam-wrapper-inner,\n  .column-camera-width-medium\n    .all-webcam-wrapper.total-cam-4\n    .all-webcam-wrapper-inner,\n  .column-camera-width-medium\n    .all-webcam-wrapper.total-cam-5\n    .all-webcam-wrapper-inner,\n  .column-camera-width-medium\n    .all-webcam-wrapper.total-cam-6\n    .all-webcam-wrapper-inner {\n    width: 80%;\n    margin: auto;\n    height: 90%;\n  }\n  .column-camera-width-small\n    .all-webcam-wrapper.total-cam-1\n    .all-webcam-wrapper-inner,\n  .column-camera-width-small\n    .all-webcam-wrapper.total-cam-2\n    .all-webcam-wrapper-inner,\n  .column-camera-width-small\n    .all-webcam-wrapper.total-cam-3\n    .all-webcam-wrapper-inner {\n    width: 60%;\n    margin: auto;\n    height: 70%;\n  }\n  .column-camera-width-small\n    .all-webcam-wrapper.total-cam-4\n    .all-webcam-wrapper-inner,\n  .column-camera-width-small\n    .all-webcam-wrapper.total-cam-5\n    .all-webcam-wrapper-inner,\n  .column-camera-width-small\n    .all-webcam-wrapper.total-cam-6\n    .all-webcam-wrapper-inner {\n    width: 70%;\n    margin: auto;\n    height: 80%;\n  }\n}\n","@media only screen and (max-width: 980px) and (max-height: 450px) {\n  .landscape-device {\n    #main-area.fullWidthMainArea {\n      .middle-fullscreen-wrapper {\n        .all-webcam-wrapper {\n          @apply bottom-auto right-auto w-[140px] left-0 h-full py-5 px-0;\n          .all-webcam-wrapper-inner {\n            display: block !important;\n            @apply py-0 px-[5px];\n            .video-camera-item {\n              @apply h-[31.33%] my-1 mx-0;\n            }\n            button.next-cam {\n              @apply top-auto bottom-0 rotate-0 left-0 w-full;\n            }\n            button.previous-cam {\n              @apply top-0 rotate-0 left-0 w-full;\n            }\n          }\n        }\n      }\n    }\n    .share-screen-wrapper.is-share-screen-running {\n      .screen-share-video {\n        button {\n          @apply bottom-[55px];\n        }\n        video.video-player {\n          // @apply h-[calc(100%-20px)] top-[10px];\n        }\n      }\n    }\n  }\n}\n","@media only screen and (max-height: 720px) {\n  .externalMediaPlayerWrapper {\n    @apply max-w-[900px];\n  }\n}\n","@media screen and (max-width: 1279px) {\n  .all-MessageModule-wrap {\n    .message-item {\n      .system {\n        p.message-content {\n          @apply text-sm leading-[16px];\n        }\n      }\n    }\n  }\n  // #main-area.fullWidthMainArea {\n  //   .all-webcam-wrapper {\n  //     @apply w-[200px];\n  //   }\n  //   .middle-fullscreen-wrapper.verticalsWebcamsActivated {\n  //     @apply pl-[200px];\n  //   }\n  // }\n  .showChatPanel {\n    .screen-share-video {\n      button {\n        @apply right-[250px];\n      }\n    }\n  }\n}\n","@media screen and (max-width: 1023px) {\n  .transition-left-panel {\n    @apply absolute h-full z-[9999];\n  }\n  .transition-right-panel {\n    position: absolute;\n    height: 100%;\n    right: 0;\n    z-index: 9999;\n    #main-right-panel {\n      .message-form {\n        position: absolute;\n      }\n      .messageModule-wrapper {\n        @apply h-[calc(100%-72px)];\n      }\n    }\n  }\n  #main-area.fullWidthMainArea {\n    .middle-fullscreen-wrapper {\n      .all-webcam-wrapper {\n        @apply absolute h-auto w-full z-[9] p-0 bottom-0 pt-0;\n        .all-webcam-wrapper-inner {\n          @apply m-0 py-0 px-[15px] flex-wrap gap-0;\n          .video-camera-item {\n            @apply w-full m-[5px] h-[100px] pb-0 max-w-[150px];\n            .connection-status {\n              @apply hidden;\n            }\n            .mic-status {\n              @apply hidden;\n            }\n            .name {\n              @apply text-xs left-[5px];\n            }\n            .camera-video-player {\n              button {\n                @apply right-0 top-0;\n              }\n            }\n            .status.PinWebcam {\n              @apply left-0 top-0;\n            }\n          }\n        }\n      }\n    }\n    .all-webcam-wrapper.vertical-webcams {\n      .all-webcam-wrapper-inner {\n        display: flex !important;\n        @apply justify-center flex-nowrap;\n      }\n    }\n    .all-webcam-wrapper {\n      .all-webcam-wrapper-inner {\n        button.next-cam {\n          @apply -right-[42px] w-[100px] left-auto h-5 top-[45px] -rotate-90;\n        }\n        button.previous-cam {\n          @apply right-auto w-[100px] -left-[42px] h-5 top-[45px] -rotate-90;\n        }\n      }\n    }\n    .middle-fullscreen-wrapper.verticalsWebcamsActivated {\n      @apply pl-0;\n      .screen-share-video {\n        button {\n          @apply bottom-[165px];\n        }\n      }\n    }\n  }\n  .share-screen-wrapper.is-share-screen-running {\n    .screen-share-video {\n      // padding-bottom: calc(100vh - 105px) !important;\n      // @apply pl-[15px];\n      video.video-player {\n        // @apply w-[calc(100%-30px)] h-[calc(100%-110px)] top-0;\n      }\n      button {\n        @apply fixed bottom-[55px];\n      }\n    }\n  }\n  .Toastify__toast-container {\n    .Toastify__toast-body {\n      @apply p-0;\n    }\n    .Toastify__toast {\n      @apply min-h-[40px] text-sm;\n    }\n  }\n  #main-area.hideParticipantsPanel.showScreenShare {\n    .active-speakers-wrap {\n      @apply p-0 flex-wrap;\n      div {\n        @apply text-[10px];\n        i {\n          @apply text-[7px];\n        }\n      }\n    }\n  }\n  .pin-webcam {\n    @apply hidden;\n  }\n  #main-right-panel {\n    background: rgb(235, 248, 255);\n    background: linear-gradient(\n      150deg,\n      rgba(235, 248, 255, 1) 0%,\n      rgba(255, 255, 255, 1) 10%,\n      rgba(243, 237, 249, 1) 67%,\n      rgba(214, 231, 255, 1) 100%\n    );\n  }\n  .dark {\n    #main-right-panel {\n      background: #001222;\n    }\n  }\n  .plugNmeet-app {\n    @apply relative h-screen;\n    header#main-header {\n      @apply fixed top-0 w-full;\n    }\n    footer#main-footer {\n      @apply fixed w-full bottom-0 z-[99999];\n    }\n    #main-area {\n      height: calc(100% - 105px) !important;\n      @apply fixed w-full top-[50px];\n    }\n    #main-area.isRecorder {\n      height: 100% !important;\n      @apply top-0;\n    }\n  }\n  .landscape-device.is-mobile {\n    #main-area.fullWidthMainArea {\n      .middle-fullscreen-wrapper.verticalsWebcamsActivated {\n        @apply pl-[140px];\n      }\n    }\n  }\n  .private-m-tab {\n    @apply w-[calc(100vh-180px)];\n  }\n  .excalidraw-wrapper {\n    @apply mt-2 h-[calc(100%-20px)];\n  }\n  body\n    #plugNmeet-app\n    .excalidraw-wrapper\n    .excalidraw\n    button.scroll-back-to-content {\n    bottom: 35px !important;\n  }\n}\n","@media screen and (max-width: 767px) {\n  .transition-right-panel {\n    @apply w-full;\n    .messageModule-wrapper {\n      @apply w-full;\n    }\n    .message-form {\n      @apply w-full;\n    }\n  }\n  .transition-left-panel {\n    @apply w-full;\n    #main-left-panel {\n      @apply w-full;\n    }\n  }\n  .is-mobile.portrait-device {\n    #main-area {\n      @apply h-[calc(100vh-180px)];\n    }\n  }\n  .message-form {\n    .btns {\n      @apply w-[50px] py-[5px] px-0 -mt-[6px];\n      button {\n        @apply w-[50px] mb-[10px];\n        i {\n          @apply text-lg;\n        }\n      }\n    }\n  }\n  .private-m-tab {\n    &::before {\n      @apply absolute content-[''] h-1 w-full bg-[rgb(0,77,144,0.2)];\n    }\n  }\n}\n","@media screen and (min-width: 641px) {\n  .preview-camera-webcam {\n    video {\n      @apply min-h-[240px];\n    }\n    canvas {\n      @apply min-h-[240px];\n    }\n  }\n}\n","@media screen and (max-width: 640px) {\n  header#main-header {\n    @apply flex-wrap;\n    .logo {\n      @apply w-1/2 order-1;\n    }\n    .dark-area {\n      @apply w-1/2 order-1 h-5;\n    }\n    .middle {\n      @apply w-full order-2 -mt-[10px];\n      h2 {\n        @apply text-sm break-all;\n      }\n    }\n  }\n  footer#main-footer {\n    .footer-icon {\n      @apply mr-[5px];\n    }\n    .whiteboard {\n      @apply mr-[5px];\n    }\n    .shared-notepad {\n      @apply mr-[5px];\n    }\n  }\n  .excalidraw-wrapper {\n    .excalidraw {\n      .Stack_horizontal {\n        display: flex !important;\n        flex-wrap: wrap;\n        justify-content: center !important;\n      }\n    }\n  }\n  .header-logo {\n    @apply h-[30px];\n  }\n  .all-webcam-wrapper {\n    .all-webcam-wrapper-inner {\n      .camera-row-0.total-items-2 {\n        @apply flex-wrap;\n        .video-camera-item {\n          @apply w-full h-1/2;\n        }\n      }\n      .camera-row-0.total-items-3 {\n        @apply flex-wrap;\n        .video-camera-item {\n          @apply w-full h-1/3;\n        }\n      }\n      .camera-row-0.total-items-4.inner-items-2 {\n        .video-camera-item {\n          @apply w-1/2 h-full;\n        }\n        @apply flex-nowrap;\n      }\n      .camera-row-0.total-items-5.inner-items-2 {\n        @apply flex-nowrap;\n        .video-camera-item {\n          @apply w-1/2 h-full;\n        }\n      }\n      .camera-row-1.total-items-5.inner-items-2 {\n        .video-camera-item {\n          @apply w-1/2;\n        }\n      }\n      .camera-row-2.total-items-5.inner-items-1 {\n        .video-camera-item {\n          @apply w-1/2;\n        }\n      }\n      .camera-row-2.total-items-6.inner-items-1 {\n        .video-camera-item {\n          @apply w-1/2;\n        }\n      }\n      .camera-row-0.total-items-6.inner-items-2 {\n        .video-camera-item {\n          @apply w-1/2 h-full;\n        }\n        @apply flex-nowrap;\n      }\n    }\n  }\n}\n","@media screen and (max-width: 575px) {\n  #main-area {\n    .share-screen-wrapper.is-share-screen-running {\n      .all-webcam-wrapper {\n        .all-webcam-wrapper-inner {\n          .video-camera-item {\n            @apply w-[calc(32.5%-10px)] max-w-full;\n          }\n        }\n      }\n    }\n  }\n}\n","@media screen and (max-width: 370px) {\n  .video-camera-item {\n    .name {\n      @apply text-[10px];\n    }\n  }\n  header#main-header {\n    .middle {\n      h2 {\n        @apply text-xs;\n      }\n    }\n  }\n  .active-speakers-wrap {\n    div {\n      @apply text-[10px] py-0 px-[5px];\n      i {\n        @apply text-[8px];\n      }\n    }\n  }\n}\n","@media screen and (min-width: 1800px) {\n  #main-area.fullWidthMainArea {\n    .all-webcam-wrapper {\n      @apply w-[440px];\n    }\n    .middle-fullscreen-wrapper.verticalsWebcamsActivated {\n      @apply pl-[440px];\n    }\n    #main-left-panel {\n      @apply w-[440px];\n    }\n  }\n  #main-area.column-camera-position-left.column-camera-width-medium.fullWidthMainArea\n    .middle-fullscreen-wrapper.verticalsWebcamsActivated {\n    @apply pl-[360px];\n  }\n  #main-area.column-camera-position-left.column-camera-width-small.fullWidthMainArea\n    .middle-fullscreen-wrapper.verticalsWebcamsActivated {\n    @apply pl-[280px];\n  }\n  #main-area.column-camera-position-left.column-camera-width-medium.fullWidthMainArea\n    .middle-fullscreen-wrapper.verticalsWebcamsActivated\n    .all-webcam-wrapper {\n    @apply w-[360px];\n  }\n  #main-area.column-camera-position-left.column-camera-width-small.fullWidthMainArea\n    .middle-fullscreen-wrapper.verticalsWebcamsActivated\n    .all-webcam-wrapper {\n    @apply w-[280px];\n  }\n  #main-area.column-camera-width-medium.fullWidthMainArea #main-left-panel {\n    @apply w-[360px];\n  }\n  #main-area.column-camera-width-small.fullWidthMainArea #main-left-panel {\n    @apply w-[280px];\n  }\n\n  #main-area.fullWidthMainArea.column-camera-position-left.column-camera-width-full\n    .active-speakers-wrap {\n    @apply w-[calc(100%-470px)] left-auto right-[30px];\n  }\n  #main-area.fullWidthMainArea.column-camera-position-left.column-camera-width-medium\n    .active-speakers-wrap {\n    @apply w-[calc(100%-390px)] left-auto right-[30px];\n  }\n  #main-area.fullWidthMainArea.column-camera-position-left.column-camera-width-small\n    .active-speakers-wrap {\n    @apply w-[calc(100%-310px)] left-auto right-[30px];\n  }\n  .column-camera-position-top .active-speakers-wrap,\n  .column-camera-position-bottom .active-speakers-wrap {\n    max-width: calc(100% - 30px);\n    margin: auto;\n    right: 0;\n  }\n}\n","@media screen and (max-width: 1025px) {\n  button.previous-cam {\n    @apply w-[95px] h-[25px] -left-[43px];\n  }\n  button.next-cam {\n    @apply w-[95px] h-[25px] -right-[43px];\n  }\n  .footer-collapse-arrow,\n  .header-collapse-arrow {\n    display: none;\n  }\n}\n","@media screen and (max-width: 1025px) and (min-width: 641px) {\n  .camera-row-1.total-items-5.inner-items-2 {\n    .video-camera-item {\n      width: 50% !important;\n    }\n  }\n  .camera-row-2.total-items-5.inner-items-1 {\n    .video-camera-item {\n      @apply w-1/2;\n    }\n  }\n  .camera-row-1.total-items-7.inner-items-3 {\n    .video-camera-item {\n      width: 50% !important;\n    }\n  }\n  .camera-row-2.total-items-7.inner-items-1 {\n    .video-camera-item {\n      @apply w-1/3;\n    }\n  }\n  .camera-row-2.total-items-8.inner-items-2 {\n    .video-camera-item {\n      @apply w-1/3;\n    }\n  }\n  .camera-row-2.total-items-9.inner-items-3 {\n    .video-camera-item {\n      @apply w-1/3;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
